import React from "react";
import Button from "@mui/material/Button";
import eyeIcon from "../../assets/new icons/eye.svg";
// import noteIcon from "../../assets/new icons/rejections/note.svg";
import lightNoteIcon from "../../assets/new icons/rejections/subtitle.svg";
import dropdownArrowIcon from "../../assets/new icons/arrow.svg";
import rightArrowIcon from "../../assets/new icons/extraction review/right arrow.svg";
import { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import InputBase from "@mui/material/InputBase";
import { useHistory } from "react-router-dom";
import SingleFormPopup from "../Extraction_View/SingleFormPopup";
import DataValidationPopup from "../Extraction_View/DataValidationPopup";
import "../../Forms/style.css";
import "./approvalReview.css";
import CloseIcon from "@mui/icons-material/Close";
import InstaColors, {
  countries,
  AppCheckbox,
  DeleteButton,
  EditButton,
  fontFamily,
  paddingAndMargin,
  paginationstyle,
  reviewScreenButtonWithColor,
  reviewScreenButtonWithOutColor,
  screenHeaderStyle,
  searchBoxStyle,
  UpperLowerText,
  useSharedValue,
} from "../Constants/constants";
import {
  ConditionalPagination,
  paginationStyles,
  useDynamicRowsPerPage,
} from "../../utils/paginationUtils";
import { BASE_URL, businessunitName, pythonBaseUrl } from "../../App_Settings/app_settings";
import SearchInput from "../Constants/search_input";
import ReactSelect, { components as SelectComponents } from "react-select";
import { handleFileDelete } from "../../services/deleteService";
import DeleteModal from "../Models/Delete/DeleteModal";
import { formatDate, getAllFilesList, getAdminUrlByBusinessUnit } from "../../Utility/utility";
import Loader from "../../Utility/loading";
import SendingAdminModal from "../../Models/SendingAdminModal";
import { searchSingleRow } from "../../services/MatchingEntityService";
import "../App.css";
import { countriesWithStates, isValidStateForCountry } from "../Constants/countrisStatesList";
import { isDateField, formatDateInput, getDatePlaceholder } from "../../services/extractionService";
import { validateField } from "../Constants/validationRules";
import "../list";
import {
  accountBalancesList,
  accountConnectionsList,
  accountsList,
  addressList,
  auditColumnNames,
  businessList,
  chapter4StatusOptions,
  entityClassificationOptions,
  entityTypeOptions,
  forms,
  formsTypeList,
  incomeCodesDropDownList,
  incomeList,
  listArray,
  paymentList,
  taxList,
} from "../list";
import {
  getFileAuditById,
  getUserIdFromLocalStorage,
  logFileChanges,
  logFileProcess,
} from "../../API_Endpoints/APIEndpoints";
import IMYFormComplete from "../../Forms/W-8IMYFORM";
import W8BENFORM from "../../Forms/W-8BEN-Form";
import BENEFormComplete from "../../Forms/W-8BEN-E-FORM";
import W9Form from "../../Forms/W-9Form";
import EXPFormComplete from "../../Forms/W-8EXP-Form";
import ECIFormComplete from "../../Forms/W8ECIFORM";
import Form8233Complete from "../../Forms/Form8233";
import W8BENApiHandler from "../SendingForms/App";
import { useUserSettings } from "../../contexts/UserSettingsContext";
import SelfCertificationForm from "../../Forms/Self-Cert-Individual";
import SelfCertEntityForm from "../../Forms/Self-Cert-Entity";
import {
  determineVisibleButtons,
  canPerformDataValidation,
  canAddNote,
  entityTypeMap,
  chapter4StatusMap,
} from "./approvalReviewService";

import { handleLogout } from "../../Utility/utility";

const columns = [
  {
    field: "fileName",
    headerName: "FILE NAME",
    width: 150,
    editable: true,
  },
  {
    field: "uploadType",
    headerName: "UPLOAD TYPE",
    // width: 110,
    // editable: true,
  },
  {
    field: "businessUnit",
    headerName: businessunitName,
    width: 110,
    editable: true,
  },
  {
    field: "totalForms",
    headerName: "Forms",
    width: 110,
    editable: true,
  },
  {
    field: "totalPages",
    headerName: "Pages",
    width: 110,
    editable: true,
  },

  {
    field: "reviewedBy",
    headerName: "REVIEWED BY",
    width: 110,
    editable: true,
  },
  {
    field: "reviewedDate",
    headerName: "REVIEWED DATE",
    width: 200,
    editable: true,
  },
  {
    field: "confidenceLevel",
    headerName: "Confidence(%)",
    width: 180,
    sortable: false,
  },

  {
    field: "compatibility",
    headerName: "Compatibility",
    width: 180,
    sortable: false,
  },

  {
    field: "functions",
    headerName: "",
    width: 180,
    sortable: false,
  },
];

const versionList = ["1.5"]; // Added "1.5" to the version list

const extractionToColumns = [
  { field: "numberOfLines", headerName: "NUMBER OF TIERS", type: "string" },
  { field: "allocations", headerName: "ALLOCATIONS %", type: "string" },
  { field: "matchManual", headerName: "MATCH MANUAL", type: "string" },
];
const borderStyle = {
  width: "250px",
  marginLeft: "20px",
  backgroundColor: "white",
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2aa7e0",
  },
  "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2aa7e0",
  },
  "&.Mui-focused .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2aa7e0",
  },
};

const getSelectStyles = (hasError) => ({
  control: (provided) => ({
    ...provided,
    height: 46,
    minHeight: 46,
    width: 260,
    borderRadius: "4.55px",
    border: hasError ? "2px solid red" : "1.14px solid #DDDDDD",
    boxShadow: "none",
    fontFamily: fontFamily,
    fontSize: 14,
    cursor: "pointer",
    "&:hover": {
      border: hasError ? "2px solid red" : "1.14px solid #DDDDDD",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 16px",
    height: 44,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: 44,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#9F9F9F",
    fontSize: 14,
    fontFamily: fontFamily,
    margin: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#9F9F9F",
    fontSize: 14,
    fontFamily: fontFamily,
    margin: 0,
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "0 24px 0 8px",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "4.55px",
    border: "1.14px solid #DDDDDD",
    boxShadow: "none",
    zIndex: 9999,
    marginTop: 2,
  }),
  menuList: (provided) => ({
    ...provided,
    borderRadius: "4.55px",
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#2aa7e0" : state.isFocused ? "#2aa7e0" : "white",
    color: state.isSelected ? "white" : state.isFocused ? "white" : "#9F9F9F",
    fontFamily: fontFamily,
    fontSize: 14,
    cursor: "pointer",
  }),
});

const NoteDropdownIndicator = (props) => (
  <SelectComponents.DropdownIndicator {...props}>
    <img src={dropdownArrowIcon} alt="" style={{ width: 10, height: 10 }} />
  </SelectComponents.DropdownIndicator>
);

export default function ApprovalReviewProcess() {
  const { dataRows } = useSharedValue();
  const [activeView, setActiveView] = useState({
    id: null,
    visualize: false,
    extraction: false,
    original: false,
  });

  const { isMenuOpen } = useSharedValue();
  const { isSuccessPopup } = useSharedValue();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Get Comply Admin status from UserSettings context
  const { hasComplyAdmin } = useUserSettings();

  const [isLoading, setIsLoading] = useState(false);
  const [totalNumberFileds, settotalNumberFields] = useState(0);
  const [columnName, setColumnName] = useState(null);
  const [rowIndex, setRowIndex] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);

  const [email, setEmail] = React.useState("Select");
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [editingCell, setEditingCell] = useState({ rowId: null, field: null });
  const [type, setType] = React.useState("");
  const [reason, setReason] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editValue, setEditValue] = useState("");
  const [oldValue, setOldValue] = useState("");
  const [updateQuestion, setUpdateQuestion] = useState("");
  const [treeData, setTreeData] = useState([]);
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);
  const [selectedCheckboxList, setSelectedCheckboxList] = useState([]);
  const [extractedData, setExtractedData] = useState(null);
  const [extractionColumns, setExtractionColumns] = useState([]);
  const [addNote, setAddNote] = useState("");
  const [saveSum, setSaveSum] = useState(0);

  const [businessUnitName, setBusinessUnitName] = useState("");
  const [runValidation, setRunValidation] = useState("");

  const [selectSheet, setSelectSheet] = useState("Business Entities");
  const history = useHistory();
  const typeList = [
    "Select",
    "Additional Information Only",
    "Outstanding Action",
    "Escalated",
    "Approved",
    "Rejected",
  ];
  const rejectionList = [
    "Select Reject Reason",
    "Data Discrepancy",
    "Allocation Discrepancy",
    "Other",
  ];
  const approveList = [
    "Select Approve Reason",
    "Approved – No Issues Found",
    "Approved – Minor Discrepancy Accepted",
    "Approved – Verified by Reviewer",
    "Other",
  ];
  const outstandingList = [
    "Select Outstanding Reason",
    "Awaiting Client Response",
    "Pending Documentation",
    "Under Review",
    "Other",
  ];
  const escalatedList = [
    "Select Escalated Reason",
    "Compliance Issue",
    "Requires Senior Review",
    "High-Risk Discrepancy",
    "Other",
  ];
  const additionalInfoList = [
    "Select Additional Info Reason",
    "Additional Documentation Required",
    "Clarification Needed",
    "Supporting Evidence Requested",
    "Other",
  ];
  const [usersEmailsList, setUsersEmailsList] = useState(["Select"]);
  const [extractedValidatedata, setExtractedValidateData] = useState([]);
  const [matchedEntitiesData, setMatchedEntitiesData] = useState({}); // Keyed by row index
  const [isLoadingMatches, setIsLoadingMatches] = useState(false);
  const [emailedDate, setEmailedDate] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [viewMode, setViewMode] = useState("keyValue");
  const [auditColumnHeaders, setAuditColumnHeaders] = [];
  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();
  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const { ref: scrollContainerRef, rowsPerPage: dynamicRowsPerPage } = useDynamicRowsPerPage();
  const [endIndex, setEndIndex] = useState(dynamicRowsPerPage);
  const [activePopupMenu, setActivePopupMenu] = useState(null);
  const [popupMenuPosition, setPopupMenuPosition] = useState({ x: 0, y: 0 });
  const popupRef = useRef(null);
  const [dataValidation, setDataValidation] = useState([]);
  const [isConfirmationPopup, setIsConfirmationPopup] = useState(false);
  const [isChangesSaved, setIsChangesSaved] = useState(false);
  const [onClickValue, setOnClickValue] = useState(false);
  const [selectDeletedItem, setSelectDeletedItem] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [storeUpdatingValues, setStoreUpdatingValues] = useState([]);
  const { defaultBusinessunit, defaultOrganization, defaultUser } = useSharedValue();
  const [isAddNotePopupOpen, setIsAddNotePopupOpen] = useState(false);
  const [isDataValidationPopupOpen, setIsDataValidationPopupOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [extractionRows, setextractionRows] = React.useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedRowId, setSelectedRowId] = useState(null);

  // Compute selected files info and button visibility (must be after rows is declared)
  const selectedFilesInfo = selectedCheckboxList.map((fileImportId) => {
    const row = rows.find((r) => r.fileImportId === fileImportId);
    const uploadType = row?.uploadType || 0;
    return {
      fileImportId,
      uploadType: uploadType,
      fileName: row?.fileName || "",
    };
  });

  const buttonVisibility = determineVisibleButtons(selectedFilesInfo);
  const [showNoteWindow, setShowNoteWindow] = useState(null);
  const [selectedOptionValue, setSelectedOptionValue] = useState("");
  const { notifications, handleNotificationList } = useSharedValue();
  const [addNewRowsList, setAddNewRowsList] = useState([]);
  const [notMatchingFields, setNotMatchingFields] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [validationErrors, setValidationErrors] = useState([]);
  const [showMoveOptions, setShowMoveOptions] = useState(false);
  const [selectedFormToMove, setSelectedFormToMove] = useState(null);
  const [availableWithholdingStatements, setAvailableWithholdingStatements] = useState([]);
  // Define static array for sheet names
  const [isDeleting, setIsDeleting] = useState(false);
  // Single Form popup state
  const [isSingleFormPopupOpen, setIsSingleFormPopupOpen] = useState(false);
  const [singleFormData, setSingleFormData] = useState(null);
  const [forceFormRerender, setForceFormRerender] = useState(0);
  const [singleFormViewMode, setSingleFormViewMode] = useState("form"); // 'form' or 'keyValue'
  const [singleFormMatchingData, setSingleFormMatchingData] = useState(null);
  const [isSingleFormSearchLoading, setIsSingleFormSearchLoading] = useState(false);
  const [isSendingToAdmin, setIsSendingToAdmin] = useState(false);

  // Form comparison modal state
  const [isFormComparisonOpen, setIsFormComparisonOpen] = useState(false);
  const [selectedFormIdForComparison, setSelectedFormIdForComparison] = useState("");
  const [currentPdfFileImportId, setCurrentPdfFileImportId] = useState("");

  const [isEntitySearchLoading, setIsEntitySearchLoading] = useState(false);

  React.useEffect(() => {
    // Fetching dat

    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      fetch(`${BASE_URL}/users/getAllUsers/${userData.organizationId}`, {
        headers: {
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
      })
        .then((response) => {
          if (response.status === 401) {
            handleLogout(history);
            return;
          }
          return response.json();
        })
        .then((data) => {
          // Extract usernames from the data and create a new array
          const usernames = data
            .filter((element) => !element.isDeleted)
            .map((element) => element.email);

          // Update the state with the new array of usernames
          setUsersEmailsList(["Select", ...usernames]);
          // Here, you can transform the fetched data to match the format of your 'data' array.
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
  }, []);

  React.useEffect(() => {
    const userDataJSON = localStorage.getItem("token");
    setLoading(true);
    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      getAllFiles();
    }
  }, [searchValue, defaultBusinessunit, defaultOrganization, defaultUser]);
  React.useEffect(() => {
    if (isSuccessPopup == true) {
      getAllFiles();
    }
  }, [isSuccessPopup]);

  const getAllFiles = async () => {
    setLoading(true);
    const data = await getAllFilesList(
      history,
      defaultOrganization,
      defaultBusinessunit,
      defaultUser,
      3 // Status 3: Sent to approval review
    );
    setRows(
      data.filter(
        (row) =>
          row.isProcessed === true &&
          row.rejectedDate === null &&
          row.approvedDate === null &&
          row.reviewedDate !== null &&
          (row.fileName.toLowerCase().includes(searchValue.toLowerCase()) ||
            formatUploadType(row.uploadType).toLowerCase().includes(searchValue.toLowerCase()))
      )
    );
    setLoading(false);
  };

  const handleSaveEditData = async () => {
    setIsChangesSaved(true);
    updatedSaveSum();

    // Check for duplicate values in the same column
    const updatedExtractedValidateData = [...extractedValidatedata];

    // Update the value in the extractedValidateData array for the specified row and column
    updatedExtractedValidateData[rowIndex][columnName] = editValue;
    setExtractedValidateData(updatedExtractedValidateData);
    const updateDataValidation = dataValidation;

    if (selectSheet === "Business Entities") {
      // update the  business unit to extractedData
      updateDataValidation.businessUnitList = updatedExtractedValidateData;
    } else if (selectSheet === "Accounts") {
      // update the  Accounts to extractedData
      updateDataValidation.accountsList = updatedExtractedValidateData;
    } else if (selectSheet === "Income Codes") {
      // update the Income Codesto extractedData
      updateDataValidation.incomeCodesList = updatedExtractedValidateData;
    } else if (selectSheet === "Account Connections") {
      // update the  Account Connects to extractedData
      updateDataValidation.accountConnectionsList = updatedExtractedValidateData;
    } else if (selectSheet === "Forms") {
      // update the Forms to extractedData
      updateDataValidation.formsList = updatedExtractedValidateData;
    }

    setDataValidation(updateDataValidation);
    setIsModalOpen(false);
    if (oldValue && oldValue !== editValue) {
      const duplicates = updatedExtractedValidateData.filter(
        (data, idx) => data[columnName] === oldValue && idx !== rowIndex
      );

      if (duplicates.length > 0) {
        // Ask the user if they want to replace duplicates
        const userConfirmed = window.confirm(
          `The value "${oldValue}" is also used in other rows in the "${columnName}" column. Do you want to replace it with "${editValue}" in those rows?`
        );

        if (userConfirmed) {
          // Replace duplicates
          updatedExtractedValidateData.forEach((data, idx) => {
            if (data[columnName] === oldValue && idx !== rowIndex) {
              data[columnName] = editValue;
              updatedSaveSumWithValues(
                idx,
                oldValue,
                columnName,
                editValue,
                data["UniqueIdentifier"]
              ); // Update saved values
            }
          });
        }
      }
    }
  };
  // Handle checkbox click for multiple selection
  const handleCheckboxClick = (fileImportId) => {
    setSelectedCheckboxList((prevList) => {
      if (prevList.includes(fileImportId)) {
        // Remove if already selected
        return prevList.filter((id) => id !== fileImportId);
      } else {
        // Add to selection
        return [...prevList, fileImportId];
      }
    });
  };

  const handleRunValidation = () => {
    if (!canPerformDataValidation(selectedFilesInfo)) {
      alert("Please select a single withholding statement or form pack for data validation");
      return;
    }

    if (selectedCheckboxList.length > 0) {
      const selectedRow = rows.find((item) => item.fileImportId === selectedCheckboxList[0]);
      setSelectedCheckbox(selectedCheckboxList[0]);

      setSelectedRowId(null);
      setAddNewRowsList([]);
      setStoreUpdatingValues([]);
      setSaveSum(0);
      setSelectSheet("Business Entities");

      setDataValidation(JSON.parse(selectedRow.dataValidation));
      setExtractedValidateData(JSON.parse(selectedRow.dataValidation).businessUnitList);
      setIsDataValidationPopupOpen(true);
      setRunValidation(true);
    }
  };

  // Function to check if a row has any errors
  const rowHasErrors = (row, rowIndex) => {
    // Check mandatory fields (only relevant for Business Entities sheet)
    if (selectSheet === "Business Entities") {
      if (!row["UniqueIdentifier"]) return true;
      if (!row["Entity Type"]) return true;
      if (!row["BusinessUnit"]) return true;

      if (
        row["Entity Type"] === "Individual" ||
        row["Entity Type"] === "Individual/Sole Proprietor"
      ) {
        if (!row["FirstName"] || !row["LastName"]) return true;
      }

      if (row["Entity Type"] === "Corporation") {
        if (!row["Business Name"]) return true;
      }
    }

    // Check format validation for all fields
    const allColumns = handleSelectedSheet();
    for (const column of allColumns) {
      const fieldName = column.field;
      const value = row[fieldName];

      if (value && value.toString().trim() !== "") {
        const validation = validateField(fieldName, value);
        if (!validation.isValid) {
          return true;
        }
      }
    }

    // Check dropdown validations
    const dropdownFields = [
      { field: "Entity Type", options: entityTypeOptions },
      { field: "Entity Classification", options: entityClassificationOptions },
      { field: "Chapter4Status", options: chapter4StatusOptions },
      { field: "FATCA Entity Types", options: chapter4StatusOptions },
      { field: "Form type and revision", options: formsTypeList },
      { field: "Income Code", options: incomeCodesDropDownList },
    ];

    for (const dropdown of dropdownFields) {
      if (selectSheet === "Income Codes" && dropdown.field === "Income Code") {
        if (
          row[dropdown.field] &&
          !dropdown.options.some((opt) => opt.toLowerCase() === row[dropdown.field].toLowerCase())
        ) {
          return true;
        }
      } else if (
        selectSheet === "Forms" &&
        (dropdown.field === "FATCA Entity Types" || dropdown.field === "Form type and revision")
      ) {
        if (
          row[dropdown.field] &&
          !dropdown.options.some((opt) => opt.toLowerCase() === row[dropdown.field].toLowerCase())
        ) {
          return true;
        }
      } else if (
        selectSheet === "Business Entities" &&
        !["FATCA Entity Types", "Form type and revision", "Income Code"].includes(dropdown.field)
      ) {
        if (
          row[dropdown.field] &&
          !dropdown.options.some((opt) => opt.toLowerCase() === row[dropdown.field].toLowerCase())
        ) {
          return true;
        }
      }
    }

    // Check country validations
    const countryFields = [
      "CountryOfBirth",
      "CountryOfBirthOther",
      "Country Of Citizenship For Tax Purposes",
      "Country Of Citizenship For Tax Purposes Other",
      "Country Of Citizenship For Tax Purposes2",
      "Country Of Citizenship For Tax Purposes3",
      "Business Country",
      "CountryOther",
      "Domicile Country",
      "ForeignTaxpayerCountry",
      "Perm. Country",
      "Perm. CountryOther",
      "Mail Country",
      "Mail CountryOther",
      "Contact CellNumber Country",
      "Contact Telephone Country",
      "Contact Telephone Country2",
      "VATCountry",
      "Treaty country",
      "Foreign Tax Country",
      "Self-cert Primary Jurisdiction2",
      "Self-cert Additional Jurisdiction1",
      "Self-cert Additional Jurisdiction2",
      "Permanent Country",
      "Permanent Country Other",
      "Country of Citizenship",
      "Country of incorporation or organization",
      "Mailing address Country",
      "Mailing address Country Other",
      "Disregarded entity address Country",
    ];

    for (const field of countryFields) {
      if (
        row[field] &&
        !countries.some((country) => country.toLowerCase() === row[field].toLowerCase())
      ) {
        return true;
      }
    }

    // Check state/province validations
    const permCountry = row["Perm. Country"];
    const mailCountry = row["Mail Country"];

    if (row["State_Province"] && (permCountry === "United States" || permCountry === "Canada")) {
      if (!isValidStateForCountry(row["State_Province"], permCountry)) {
        return true;
      }
    }

    if (row["State_Province2"] && (mailCountry === "United States" || mailCountry === "Canada")) {
      if (!isValidStateForCountry(row["State_Province2"], mailCountry)) {
        return true;
      }
    }

    if (selectSheet === "Forms") {
      if (
        row["Permanent State Province"] &&
        (row["Permanent Country"] === "United States" || row["Permanent Country"] === "Canada")
      ) {
        if (!isValidStateForCountry(row["Permanent State Province"], row["Permanent Country"])) {
          return true;
        }
      }

      if (
        row["Mailing address State Province"] &&
        (row["Mailing address Country"] === "United States" ||
          row["Mailing address Country"] === "Canada")
      ) {
        if (
          !isValidStateForCountry(
            row["Mailing address State Province"],
            row["Mailing address Country"]
          )
        ) {
          return true;
        }
      }
    }

    return false;
  };

  // Function to check if a column has any errors across all rows
  const columnHasErrors = (columnField) => {
    // Always show mandatory columns
    const alwaysShowColumns = ["UniqueIdentifier", "Entity Type", "BusinessUnit"];
    if (alwaysShowColumns.includes(columnField)) return true;

    for (let i = 0; i < extractedValidatedata.length; i++) {
      const row = extractedValidatedata[i];
      const value = row[columnField];

      // Check if value exists and has format validation error
      if (value && value.toString().trim() !== "") {
        const validation = validateField(columnField, value);
        if (!validation.isValid) {
          return true;
        }
      }

      // Check mandatory field errors
      if (columnField === "UniqueIdentifier" && !row["UniqueIdentifier"]) return true;
      if (columnField === "Entity Type" && !row["Entity Type"]) return true;
      if (columnField === "BusinessUnit" && !row["BusinessUnit"]) return true;
      if (
        row["Entity Type"] === "Individual" ||
        row["Entity Type"] === "Individual/Sole Proprietor"
      ) {
        if (columnField === "FirstName" && !row["FirstName"]) return true;
        if (columnField === "LastName" && !row["LastName"]) return true;
      }
      if (row["Entity Type"] === "Corporation") {
        if (columnField === "Business Name" && !row["Business Name"]) return true;
      }

      // Check dropdown errors (case-insensitive comparison to handle API variations)
      if (
        columnField === "Entity Type" &&
        value &&
        !entityTypeOptions.some((opt) => opt.toLowerCase() === value.toLowerCase())
      )
        return true;
      if (
        columnField === "Entity Classification" &&
        value &&
        !entityClassificationOptions.some((opt) => opt.toLowerCase() === value.toLowerCase())
      )
        return true;
      if (
        columnField === "Chapter4Status" &&
        value &&
        !chapter4StatusOptions.some((opt) => opt.toLowerCase() === value.toLowerCase())
      )
        return true;
      if (
        columnField === "FATCA Entity Types" &&
        value &&
        !chapter4StatusOptions.some((opt) => opt.toLowerCase() === value.toLowerCase())
      )
        return true;
      if (
        columnField === "Form type and revision" &&
        value &&
        !formsTypeList.some((opt) => opt.toLowerCase() === value.toLowerCase())
      )
        return true;
      if (
        columnField === "Income Code" &&
        value &&
        !incomeCodesDropDownList.some((opt) => opt.toLowerCase() === value.toLowerCase())
      )
        return true;

      // Check country errors
      const countryFields = [
        "CountryOfBirth",
        "CountryOfBirthOther",
        "Country Of Citizenship For Tax Purposes",
        "Country Of Citizenship For Tax Purposes Other",
        "Country Of Citizenship For Tax Purposes2",
        "Country Of Citizenship For Tax Purposes3",
        "Business Country",
        "CountryOther",
        "Domicile Country",
        "ForeignTaxpayerCountry",
        "Perm. Country",
        "Perm. CountryOther",
        "Mail Country",
        "Mail CountryOther",
        "Contact CellNumber Country",
        "Contact Telephone Country",
        "Contact Telephone Country2",
        "VATCountry",
        "Treaty country",
        "Foreign Tax Country",
        "Self-cert Primary Jurisdiction2",
        "Self-cert Additional Jurisdiction1",
        "Self-cert Additional Jurisdiction2",
        "Permanent Country",
        "Permanent Country Other",
        "Country of Citizenship",
        "Country of incorporation or organization",
        "Mailing address Country",
        "Mailing address Country Other",
        "Disregarded entity address Country",
      ];
      if (
        countryFields.includes(columnField) &&
        value &&
        !countries.some((country) => country.toLowerCase() === value.toLowerCase())
      )
        return true;

      // Check state/province errors
      if (columnField === "State_Province") {
        const permCountry = row["Perm. Country"];
        if (value && (permCountry === "United States" || permCountry === "Canada")) {
          if (!isValidStateForCountry(value, permCountry)) return true;
        }
      }
      if (columnField === "State_Province2") {
        const mailCountry = row["Mail Country"];
        if (value && (mailCountry === "United States" || mailCountry === "Canada")) {
          if (!isValidStateForCountry(value, mailCountry)) return true;
        }
      }
      if (columnField === "Permanent State Province") {
        const permCountry = row["Permanent Country"];
        if (value && (permCountry === "United States" || permCountry === "Canada")) {
          if (!isValidStateForCountry(value, permCountry)) return true;
        }
      }
      if (columnField === "Mailing address State Province") {
        const mailCountry = row["Mailing address Country"];
        if (value && (mailCountry === "United States" || mailCountry === "Canada")) {
          if (!isValidStateForCountry(value, mailCountry)) return true;
        }
      }
    }

    return false;
  };

  const handleDeleteRow = (index) => {
    // Create a copy of the data array
    const newData = [...extractedValidatedata];

    // Remove the value from addNewRowsList
    const updatedList = addNewRowsList.filter((item) => item !== index);
    setAddNewRowsList(updatedList);

    // Get the data for the row being deleted
    const deletedRowData = newData[index];

    // Create updated storeUpdatingValues
    const updatedStoreValues = [...storeUpdatingValues];

    // Log the deleted row's data
    for (const [columnName, oldValue] of Object.entries(deletedRowData)) {
      if (oldValue === null || oldValue === undefined || oldValue === "" || oldValue === "None") {
        // console.log('Empty or None value');
      } else {
        const key = `${index}-${columnName}`;

        const newEntry = {
          oldValue: oldValue,
          newValue: "", // No new value for deleted row
          type: selectSheet,
          modifiedBy: getUserIdFromLocalStorage().userId,
          modifiedDate: new Date(),
          action: "Deleted",
          rowIndex: index,
          columnName: columnName,
        };
        updatedStoreValues.push(newEntry);
      }
    }

    // Update storeUpdatingValues with all changes
    setStoreUpdatingValues(updatedStoreValues);

    // Remove the row from the data
    newData.splice(index, 1);
    setExtractedValidateData(newData);
    const updateDataValidation = dataValidation;

    if (selectSheet === "Business Entities") {
      // update the  business unit to extractedData
      updateDataValidation.businessUnitList = newData;
    } else if (selectSheet === "Accounts") {
      // update the  Accounts to extractedData
      updateDataValidation.accountsList = newData;
    } else if (selectSheet === "Income Codes") {
      // update the Income Codesto extractedData
      updateDataValidation.incomeCodesList = newData;
    } else if (selectSheet === "Account Connections") {
      // update the  Account Connects to extractedData
      updateDataValidation.accountConnectionsList = newData;
    } else if (selectSheet === "Forms") {
      // update the Forms to extractedData
      updateDataValidation.formsList = newData;
    } else if (selectSheet === "Forms (Self-Cert)") {
      // update the Forms (Self-Cert) to extractedData
      updateDataValidation.selfcertFormsList = newData;
    }

    setDataValidation(updateDataValidation);
  };
  const handleAddEmptyRow = () => {
    // Assuming all rows have the same structure, use the first row to get the keys
    const newRowTemplate = extractedValidatedata[0] || {};
    const newRow = {};

    // Use for...in loop to iterate over the keys of the template row
    for (const key in newRowTemplate) {
      if (newRowTemplate.hasOwnProperty(key)) {
        // Set the value for each key to an empty string or some default value
        newRow[key] = ""; // or some default value for specific keys
      }
    }
    // Update the extractionRows state with the new row
    setExtractedValidateData([...extractedValidatedata, newRow]);

    const newValue = extractedValidatedata.length;
    setAddNewRowsList((prevRows) => [...prevRows, newValue]);
  };

  // Function to add a single matching entity as a permanent row
  const handleAddMatchingRow = (parentIndex, matchIndex) => {
    if (!matchedEntitiesData[parentIndex] || !matchedEntitiesData[parentIndex][matchIndex]) {
      return;
    }

    const matchedEntity = matchedEntitiesData[parentIndex][matchIndex];
    const entity = matchedEntity.entity || {};

    // Create a new row based on the current sheet structure
    const newRowTemplate = extractedValidatedata[0] || {};
    const newRow = {};

    // Initialize all fields with empty values
    for (const key in newRowTemplate) {
      if (newRowTemplate.hasOwnProperty(key)) {
        newRow[key] = "";
      }
    }

    // Populate with entity data based on the sheet type
    if (selectSheet === "Business Entities") {
      // Entity data is already flattened by MatchingEntityService
      const displayBusinessName = entity.businessName || "";
      const firstName = entity.firstName || "";
      const lastName = entity.lastName || "";

      // Basic entity fields
      newRow["UniqueIdentifier"] = entity.uniqueIdentifier || matchedEntity.uniqueIdentifier || "";
      newRow["Business Name"] = displayBusinessName;

      // Handle both "First Name" (with space) and "FirstName" (no space)
      if (newRowTemplate.hasOwnProperty("First Name")) {
        newRow["First Name"] = firstName;
      }
      if (newRowTemplate.hasOwnProperty("FirstName")) {
        newRow["FirstName"] = firstName;
      }

      // Handle both "Last Name" (with space) and "LastName" (no space)
      if (newRowTemplate.hasOwnProperty("Last Name")) {
        newRow["Last Name"] = lastName;
      }
      if (newRowTemplate.hasOwnProperty("LastName")) {
        newRow["LastName"] = lastName;
      }
      newRow["Entity Type"] = entity.type || "";
      newRow["BusinessUnit"] = entity.businessUnit || "";
      newRow["Entity Classification"] = entity.entityClassification || "";
      newRow["Chapter4Status"] = entity.chapter4Status || "";
      newRow["Legal Status"] = entity.legalStatus || "";

      // Permanent Address
      newRow["Perm. Address Line1"] = entity.permanentAddressLine1 || "";
      newRow["Perm. Address Line2"] = entity.permanentAddressLine2 || "";
      newRow["City_Town"] = entity.permanentAddressCity || "";
      newRow["State_Province"] = entity.permanentAddressState || "";
      newRow["Perm. Country"] = entity.permanentAddressCountry || "";
      newRow["Zip_PostalCode"] = entity.permanentAddressPostalCode || "";

      // Mailing Address
      newRow["Mail Address Line1"] = entity.mailingAddressLine1 || "";
      newRow["Mail Address Line2"] = entity.mailingAddressLine2 || "";
      newRow["Mail City_Town"] = entity.mailingAddressCity || "";
      newRow["State_Province2"] = entity.mailingAddressState || "";
      newRow["Mail Country"] = entity.mailingAddressCountry || "";
      newRow["Mail Zip_PostalCode"] = entity.mailingAddressPostalCode || "";

      // Tax Identification Numbers
      newRow["ATIN"] = entity.ATIN || "";
      newRow["EIN"] = entity.EIN || "";
      newRow["SSNOrITIN"] = entity.SSNOrITIN || "";
      newRow["PTIN"] = entity.PTIN || "";
      newRow["QIEIN"] = entity.QIEIN || "";
      newRow["WP-EIN"] = entity["WP-EIN"] || "";
      newRow["WT-EIN"] = entity["WT-EIN"] || "";
      newRow["ForeignTaxpayerId"] = entity.ForeignTaxpayerId || "";
      newRow["GIIN"] = entity.GIIN || "";
    }

    // Get the parent row data before replacement for audit logging
    const parentRow = extractedValidatedata[parentIndex];

    // Store old unique identifier for Account Connections replacement
    const oldUniqueIdentifier =
      parentRow["UniqueIdentifier"] || parentRow["Unique Identifier"] || "";
    const newUniqueIdentifier = newRow["UniqueIdentifier"] || "";

    // Replace the parent row with the matched entity row
    const newData = [...extractedValidatedata];
    newData[parentIndex] = newRow;
    setExtractedValidateData(newData);

    // Track changes for audit logging - compare parent row with new matched entity row
    const updatedStoreValues = [...storeUpdatingValues];

    // Update dataValidation to reflect the changes
    const updateDataValidation = { ...dataValidation };
    if (selectSheet === "Business Entities") {
      updateDataValidation.businessUnitList = newData;

      // Also update Accounts tab: replace Account Number values that match old unique identifier
      if (updateDataValidation.accountsList && oldUniqueIdentifier && newUniqueIdentifier) {
        const updatedAccounts = updateDataValidation.accountsList.map((account) => {
          const updatedAccount = { ...account };

          // Replace Account Number or Number column value if it matches old unique identifier
          const accountNumberField =
            updatedAccount["Account Number"] !== undefined ? "Account Number" : "Number";
          if (updatedAccount[accountNumberField] === oldUniqueIdentifier) {
            updatedAccount[accountNumberField] = newUniqueIdentifier;

            // Track this change for audit
            updatedStoreValues.push({
              oldValue: oldUniqueIdentifier,
              newValue: newUniqueIdentifier,
              type: "Accounts",
              modifiedBy: getUserIdFromLocalStorage().userId,
              modifiedDate: new Date(),
              action: "Updated",
              rowIndex: -1,
              columnName: accountNumberField,
              uniqueIdentifier: updatedAccount["Account Name"] || "",
            });
          }

          return updatedAccount;
        });

        updateDataValidation.accountsList = updatedAccounts;
      }

      // Also update Account Connections tab: replace Parent and Child values that match old unique identifier
      if (
        updateDataValidation.accountConnectionsList &&
        oldUniqueIdentifier &&
        newUniqueIdentifier
      ) {
        const updatedAccountConnections = updateDataValidation.accountConnectionsList.map(
          (connection) => {
            const updatedConnection = { ...connection };

            // Replace Parent column value if it matches old unique identifier
            if (updatedConnection["Parent"] === oldUniqueIdentifier) {
              updatedConnection["Parent"] = newUniqueIdentifier;

              // Track this change for audit
              updatedStoreValues.push({
                oldValue: oldUniqueIdentifier,
                newValue: newUniqueIdentifier,
                type: "Account Connections",
                modifiedBy: getUserIdFromLocalStorage().userId,
                modifiedDate: new Date(),
                action: "Updated",
                rowIndex: -1, // We don't have specific index here
                columnName: "Parent",
                uniqueIdentifier: updatedConnection["Child"] || "",
              });
            }

            // Replace Child column value if it matches old unique identifier
            if (updatedConnection["Child"] === oldUniqueIdentifier) {
              updatedConnection["Child"] = newUniqueIdentifier;

              // Track this change for audit
              updatedStoreValues.push({
                oldValue: oldUniqueIdentifier,
                newValue: newUniqueIdentifier,
                type: "Account Connections",
                modifiedBy: getUserIdFromLocalStorage().userId,
                modifiedDate: new Date(),
                action: "Updated",
                rowIndex: -1,
                columnName: "Child",
                uniqueIdentifier: updatedConnection["Child"] || "",
              });
            }

            return updatedConnection;
          }
        );

        updateDataValidation.accountConnectionsList = updatedAccountConnections;
      }

      // } else if (selectSheet === "Accounts") {
      //   updateDataValidation.accountsList = newData;
      // } else if (selectSheet === "Income Codes") {
      //   updateDataValidation.incomeCodesList = newData;
      // } else if (selectSheet === "Account Connections") {
      //   updateDataValidation.accountConnectionsList = newData;
    }
    setDataValidation(updateDataValidation);

    // Update formsData if it exists for this row - replace UniqueIdentifier in all forms
    if (selectedCheckbox && oldUniqueIdentifier && newUniqueIdentifier) {
      const currentRow = rows.find((row) => row.fileImportId === selectedCheckbox);
      if (currentRow && currentRow.formsData) {
        try {
          const parsedFormsData = JSON.parse(currentRow.formsData);
          let formsDataModified = false;

          // Handle different formsData structures
          if (parsedFormsData.formsData && Array.isArray(parsedFormsData.formsData)) {
            // Structure: { formsData: [{ data: [...] }, ...] }
            parsedFormsData.formsData.forEach((item) => {
              if (Array.isArray(item.data)) {
                item.data.forEach((formObj) => {
                  // Match by UniqueIdentifier but assign to entityUniqueIdentifier
                  if (formObj.UniqueIdentifier === oldUniqueIdentifier) {
                    formObj.entityUniqueIdentifier = newUniqueIdentifier;
                    formsDataModified = true;
                  }
                  // Also check lowercase variant
                  if (formObj.uniqueidentifier === oldUniqueIdentifier) {
                    formObj.entityUniqueIdentifier = newUniqueIdentifier;
                    formsDataModified = true;
                  }
                });
              }
            });
          } else if (Array.isArray(parsedFormsData)) {
            // Structure: directly an array of forms
            parsedFormsData.forEach((formObj) => {
              // Match by UniqueIdentifier but assign to entityUniqueIdentifier
              if (formObj.UniqueIdentifier === oldUniqueIdentifier) {
                formObj.entityUniqueIdentifier = newUniqueIdentifier;
                formsDataModified = true;
              }
              // Also check lowercase variant
              if (formObj.uniqueidentifier === oldUniqueIdentifier) {
                formObj.entityUniqueIdentifier = newUniqueIdentifier;
                formsDataModified = true;
              }
            });
          }

          // Update the row with modified formsData
          if (formsDataModified) {
            const updatedRows = rows.map((row) => {
              if (row.fileImportId === selectedCheckbox) {
                return {
                  ...row,
                  formsData: JSON.stringify(parsedFormsData),
                };
              }
              return row;
            });
            setRows(updatedRows);

            // Track this change for audit
            updatedStoreValues.push({
              oldValue: oldUniqueIdentifier,
              newValue: newUniqueIdentifier,
              type: "Forms Data",
              modifiedBy: getUserIdFromLocalStorage().userId,
              modifiedDate: new Date(),
              action: "Updated",
              rowIndex: -1,
              columnName: "entityUniqueIdentifier",
              uniqueIdentifier: newUniqueIdentifier,
            });
          }
        } catch (error) {
          console.error("Error updating formsData UniqueIdentifier:", error);
        }
      }
    }
    Object.keys(newRow).forEach((columnName) => {
      const oldValue = parentRow[columnName] || "";
      const newValue = newRow[columnName] || "";

      // Only log if values are different
      if (oldValue !== newValue) {
        updatedStoreValues.push({
          oldValue: oldValue,
          newValue: newValue,
          type: selectSheet,
          modifiedBy: getUserIdFromLocalStorage().userId,
          modifiedDate: new Date(),
          action: "Updated",
          rowIndex: parentIndex,
          columnName: columnName,
          uniqueIdentifier: newRow["UniqueIdentifier"] || parentRow["UniqueIdentifier"] || "",
        });
      }
    });
    setStoreUpdatingValues(updatedStoreValues);

    // Remove this match from matchedEntitiesData
    const newMatchedEntitiesData = { ...matchedEntitiesData };
    newMatchedEntitiesData[parentIndex].splice(matchIndex, 1);

    // If no more matches for this parent, remove the key
    if (newMatchedEntitiesData[parentIndex].length === 0) {
      delete newMatchedEntitiesData[parentIndex];
    }

    // No need to re-key indices since we're replacing, not inserting
    setMatchedEntitiesData(newMatchedEntitiesData);

    // The row at parentIndex is being replaced, not added as new
    // No need to track as a new row since it's a replacement
  };

  const handleProceed = async () => {
    if (selectedCheckboxList.length === 0) {
      alert("Please select records to approve");
      return;
    }

    try {
      const updatedRows = [...rows];
      const failedFiles = [];

      // Update all selected rows
      for (const fileImportId of selectedCheckboxList) {
        const index = updatedRows.findIndex((row) => row.fileImportId === fileImportId);
        if (index !== -1) {
          updatedRows[index] = {
            ...updatedRows[index],
            approvedDate: new Date(),
            approvedBy: getUserIdFromLocalStorage().userId,
            status: 5, // Status 5: Approved
          };

          try {
            const response = await fetch(`${BASE_URL}/FileData/ImportFiles`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
              },
              body: JSON.stringify(updatedRows[index]),
            });

            if (!response.ok) {
              const errorData = await response.json().catch(() => ({}));
              throw new Error(errorData.message || `Failed to approve file: ${response.status}`);
            }

            logFileProcess({
              fileImportId: updatedRows[index].fileImportId,
              fileName: updatedRows[index].fileName,
              approvedDate: new Date(),
            });
          } catch (error) {
            console.error(`Error approving file ${fileImportId}:`, error);
            failedFiles.push(updatedRows[index].fileName || fileImportId);
          }
        }
      }

      setRows(updatedRows);
      setSelectedCheckboxList([]);
      if (failedFiles.length > 0) {
        alert(`Failed to approve ${failedFiles.length} file(s): ${failedFiles.join(", ")}`);
      } else {
        alert(`Successfully approved ${selectedCheckboxList.length} file(s)`);
      }
      getAllFiles();
    } catch (error) {
      console.error("Error in approval process:", error);
      alert("An error occurred while approving files");
    }
  };

  useEffect(() => {
    rows.forEach((row) => {
      // Check if dataValidation exists and businessUnitList is available and contains data
      if (row.dataValidation) {
        //    console.log(JSON.parse(row.dataValidation)?.businessUnitList);
        handleCompatibility(
          JSON.parse(row.dataValidation)?.businessUnitList ?? [],
          row.fileImportId
        );
      } else {
        // console.warn(`Row is missing valid dataValidation or businessUnitList:`, row);
      }
    });
  }, [rows]);

  const handleSelectSheetProcess = async (column) => {
    setSelectSheet(column); // Update selected tab state

    // Clear states before assigning new data
    setExtractedValidateData([]);

    let newData = []; // Initialize empty array for new data

    switch (column) {
      case "Business Entities":
        newData = dataValidation.businessUnitList || [];
        break;
      case "Accounts":
        newData = dataValidation.accountsList || [];
        break;
      case "Income Codes":
        newData = dataValidation.incomeCodesList || [];
        break;
      case "Account Connections":
        newData = dataValidation.accountConnectionsList || [];
        break;
      case "Forms":
        newData = dataValidation.formsList || [];
        break;
      case "Forms (Self-Cert)":
        newData = dataValidation.selfcertFormsList || [];
        break;
      case "View Forms":
        const selectedRow = rows.find((row) => row.fileImportId === selectedCheckbox);
        newData = processFormsData(selectedRow.formsData);
        break;
      case "Audit":
        try {
          const data = await getFileAuditById(selectedCheckbox);
          setExtractedValidateData(data); // Set audit data after fetching
        } catch (error) {
          console.error("Error fetching audit data:", error);
        }
        return; // Exit early for asynchronous operation
      default:
        newData = [];
    }

    // Update state for synchronous cases
    setExtractedValidateData(newData);
  };

  const handleSelectedSheet = () => {
    if (selectSheet === "Business Entities") {
      return businessList;
    } else if (selectSheet === "Additional Addresses") {
      return addressList;
    } else if (selectSheet === "Tax Juridictions") {
      return taxList;
    } else if (selectSheet === "Accounts") {
      return accountsList;
    } else if (selectSheet === "Income Codes") {
      return incomeList;
    } else if (selectSheet === "Account Connections") {
      return accountConnectionsList;
    } else if (selectSheet === "Account Balances") {
      return accountBalancesList;
    } else if (selectSheet === "Payment") {
      return paymentList;
    } else if (selectSheet === "Forms") {
      return forms;
    } else if (selectSheet === "Version") {
      return versionList;
    } else if (selectSheet === "Lists") {
      return listArray;
    } else if (selectSheet === "Audit") {
      return auditColumnNames;
    } else if (selectSheet === "View Forms") {
      return auditColumnNames;
    } else {
      // Handle the default case, e.g., return an empty array or handle it as needed
      return [];
    }
  };

  const handleReviewClick = (id, rowItem) => {
    history.push({
      pathname: "/displayExtractionView",
      state: {
        someValue: id,
        accuracyPercentage: rowItem.accuracyPercentage,
        datatable: rowItem.dataExtraction,
        dataTree: rowItem.dataVisualisation,
        row: rowItem,
        rootValue: "/approval",
      },
    });
  };

  const updatedSaveSum = () => {
    const key = `${rowIndex}-${columnName}`;
    const rowIndexExists = addNewRowsList.some((row) => row === rowIndex);
    const existingIndex = storeUpdatingValues.findIndex(
      (item) => `${item.rowIndex}-${item.columnName}` === key
    );
    // Check if the oldValue and editValue are the same
    if (oldValue === editValue) {
      // console.warn('Old value and new value are the same. No update will be made.');
      return; // Exit the function early
    }

    if (existingIndex === -1) {
      // If no existing entry found, add new entry
      if (oldValue || editValue) {
        const newEntry = {
          oldValue: oldValue,
          newValue: editValue,
          type: selectSheet,
          modifiedBy: getUserIdFromLocalStorage().userId,
          modifiedDate: new Date(),
          action: rowIndexExists ? "Created" : "Updated",
          rowIndex: rowIndex,
          columnName: columnName,
          uniqueIdentifier: extractedValidatedata[rowIndex]["UniqueIdentifier"],
        };
        setStoreUpdatingValues([...storeUpdatingValues, newEntry]);
        setSaveSum(saveSum + 1);
      }
    } else {
      // If entry exists, update it
      const updatedValues = [...storeUpdatingValues];
      updatedValues[existingIndex] = {
        ...updatedValues[existingIndex],
        newValue: editValue,
      };

      setStoreUpdatingValues(updatedValues);
    }
  };

  const handleSaveChanges = async (filename, fileImportId) => {
    try {
      setIsChangesSaved(false);
      setIsLoading(true);

      const formData = new FormData();
      formData.append("filename", filename);
      const selectedRow = rows.find((item) => item.fileImportId === fileImportId);

      const numberOfFields = selectedRow.numberOfFields || 0;
      const percentage = parseFloat(selectedRow.accuracyPercentage) || 0;
      const fieldPercentage = numberOfFields > 0 ? percentage / numberOfFields : 0;
      const adjustedPercentage = percentage - saveSum * fieldPercentage;

      // Ensure we have a valid number, default to original percentage or 0
      const validAccuracyPercentage =
        !isNaN(adjustedPercentage) && isFinite(adjustedPercentage)
          ? adjustedPercentage.toFixed(2)
          : percentage > 0
            ? percentage.toFixed(2)
            : "0.00";

      formData.append("validate_data", JSON.stringify(dataValidation));
      formData.append("request_id", selectedRow.fileImportId);
      formData.append("organization_id", selectedRow.organizationId);
      formData.append("user_id", selectedRow.userID);
      formData.append("original_filename", selectedRow.fileName);
      formData.append("business_unit", selectedRow.businessUnit || "Demo");

      const url = `${pythonBaseUrl}/Excel/SaveValidateData`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: formData,
      });

      if (response.ok) {
        const jsonData = await response.json();
        const updatedRowData = {
          ...selectedRow,
          dataExtraction: JSON.stringify(jsonData.tableData),
          dataValidation: JSON.stringify(jsonData.extractedValidationData),
          dataVisualisation: JSON.stringify(jsonData.treeData),
          accuracyPercentage: validAccuracyPercentage,
        };

        handleCompatibility(
          jsonData.extractedValidationData?.businessUnitList ?? [],
          selectedRow.fileImportId
        );

        const targetRowIndex = rows.findIndex(
          (item) => item.fileImportId === updatedRowData.fileImportId
        );
        const updatedRows = [...rows];
        updatedRows[targetRowIndex] = updatedRowData;
        setRows(updatedRows);

        // Log changes
        for (const entry of storeUpdatingValues) {
          await logFileChanges({
            fileImportId: fileImportId,
            dataType: entry.type,
            fieldName: entry.columnName,
            oldValue: entry.oldValue,
            newValue: entry.newValue,
            action: entry.action,
            modifiedBy: entry.modifiedBy,
            uid: entry.uniqueIdentifier,
          });
        }

        setStoreUpdatingValues([]);

        // Update file data
        await fetch(`${BASE_URL}/FileData/ImportFiles`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedRowData),
        });
      } else {
        // Handle error case
        console.error("Save failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error saving changes:", error);
    } finally {
      // These will always run, regardless of success or failure
      setIsLoading(false);
      setIsDataValidationPopupOpen(false);
    }
  };

  function compareList(newList, oldList, keyIdentifier, resultContainer) {
    // Default to empty arrays if undefined
    newList = newList || [];
    oldList = oldList || [];

    const updatedFields = [];
    const createdRows = [];
    const deletedRows = [];

    // Compare rows for updates and creations
    newList.forEach((newRow, newRowIndex) => {
      const oldRow = newRowIndex < oldList.length ? oldList[newRowIndex] : null;
      if (!oldRow) {
        // Handle created rows (add only if newValue is not empty)
        Object.keys(newRow).forEach((key, columnIndex) => {
          if (newRow[key]) {
            createdRows.push({
              uniqueIdentifier: newRow["UniqueIdentifier"],
              // rowNumber: newRowIndex + 1,
              // columnNumber: columnIndex + 1,
              columnName: key,
              oldValue: "",
              newValue: newRow[key],
              status: "Created",
            });
          }
        });
      } else {
        const changes = [];

        Object.keys(newRow).forEach((key, columnIndex) => {
          if (newRow[key] !== oldRow[key]) {
            const oldValue = oldRow[key] || "";
            const newValue = newRow[key] || "";
            if (oldValue || newValue) {
              changes.push({
                uniqueIdentifier: newRow["UniqueIdentifier"],
                rowNumber: newRowIndex + 1,
                columnNumber: columnIndex + 1,
                columnName: key,
                oldValue,
                newValue,
                status: "Updated",
              });
            }
          }
        });

        if (changes.length) {
          updatedFields.push(...changes);
        }
      }
    });

    // Find deleted rows (add only if oldValue is not empty)
    oldList.forEach((oldRow, oldRowIndex) => {
      const newRow = newList.find((row) => row[keyIdentifier] === oldRow[keyIdentifier]);
      if (!newRow) {
        Object.keys(oldRow).forEach((key, columnIndex) => {
          if (oldRow[key]) {
            deletedRows.push({
              uniqueIdentifier: oldRow["UniqueIdentifier"], //`${oldRowIndex}-${columnIndex}`,
              rowNumber: oldRowIndex + 1,
              columnNumber: columnIndex + 1,
              columnName: key,
              oldValue: oldRow[key],
              newValue: "",
              status: "Deleted",
            });
          }
        });
      }
    });

    resultContainer.updates = updatedFields;
    resultContainer.createdRows = createdRows;
    resultContainer.deletedRows = deletedRows;
  }

  function compareData(responseData, data) {
    const parsedData = JSON.parse(data);

    const businessUnitList = parsedData?.businessUnitList;
    const accountsList = parsedData?.accountsList;
    const accountConnectionsList = parsedData?.accountConnectionsList;

    const results = {
      accountConnections: {
        updatedFields: 0,
        createdRows: [],
        deletedRows: [],
        updates: [],
      },
      businessEntities: {
        updatedFields: 0,
        createdRows: [],
        deletedRows: [],
        updates: [],
      },
      accounts: {
        updatedFields: 0,
        createdRows: [],
        deletedRows: [],
        updates: [],
      },
    };

    compareList(
      responseData.accountConnectionsList,
      accountConnectionsList,
      "Child",
      results.accountConnections
    );

    compareList(
      responseData.businessUnitList,
      businessUnitList,
      "BusinessUnit",
      results.businessEntities
    );

    compareList(responseData.accountsList, accountsList, "EntityUID", results.accounts);

    const consolidatedEntries = [];
    const entities = ["accountConnections", "businessEntities", "accounts"];

    entities.forEach((entity) => {
      const data = results[entity];

      // Handle created rows
      data.createdRows.forEach((row) => {
        consolidatedEntries.push({
          ...row,
          type: entity,
          modifiedBy: getUserIdFromLocalStorage().userId,
          modifiedDate: new Date(),
        });
      });

      // Handle updated rows
      data.updates.forEach((update) => {
        consolidatedEntries.push({
          ...update,
          type: entity,
          modifiedBy: getUserIdFromLocalStorage().userId,
          modifiedDate: new Date(),
        });
      });

      // Handle deleted rows
      data.deletedRows.forEach((row) => {
        consolidatedEntries.push({
          ...row,
          type: entity,
          modifiedBy: getUserIdFromLocalStorage().userId,
          modifiedDate: new Date(),
        });
      });
    });

    return consolidatedEntries;
  }

  function countFieldsWithValues(data) {
    let totalFieldsWithValues = 0;

    // Helper function to count non-empty values in an object
    const countNonEmptyFields = (obj) => {
      return Object.entries(obj).reduce((count, [_, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          return count + 1;
        }
        return count;
      }, 0);
    };

    // Count fields in accountConnectionsList
    if (data.accountConnectionsList) {
      data.accountConnectionsList.forEach((item) => {
        totalFieldsWithValues += countNonEmptyFields(item);
      });
    }

    // Count fields in accountsList
    if (data.accountsList) {
      data.accountsList.forEach((item) => {
        totalFieldsWithValues += countNonEmptyFields(item);
      });
    }

    // Count fields in businessUnitList
    if (data.businessUnitList) {
      data.businessUnitList.forEach((item) => {
        totalFieldsWithValues += countNonEmptyFields(item);
      });
    }

    return totalFieldsWithValues;
  }

  const handleFileUpload = async (event) => {
    try {
      const file = event.target.files[0];

      // Early validation
      if (!file) {
        return;
      }

      // Find selected row data
      const selectedRow = rows.find((item) => item.fileImportId === selectedCheckbox);

      if (!selectedRow) {
        alert("No file selected for upload.");
        return;
      }

      // Validate file extension
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!["xltx", "xlsx"].includes(fileExtension)) {
        alert("Please upload an Excel file with .xlsx or .xltx extension.");
        return;
      }

      // Confirm overwrite
      const isConfirmed = window.confirm(
        "Importing a new file will overwrite the current file with new changes. Do you want to continue?"
      );
      if (!isConfirmed) {
        return;
      }

      // Set loading state - this will remain true until entire process completes
      setIsLoading(true);

      // Prepare form data
      const userData = getUserIdFromLocalStorage();
      const formData = new FormData();
      formData.append("file", file);
      formData.append("filename", selectedRow.fileImportId);
      formData.append("request_id", selectedRow.fileImportId);
      formData.append("organization_id", userData.organizationId);
      formData.append("user_id", userData.userId);
      formData.append("business_unit", selectedRow.businessUnit || "Demo");
      formData.append("original_filename", selectedRow.fileName);

      // Upload file
      const uploadResponse = await fetch(`${pythonBaseUrl}/Excel/Import-Excel-File`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
        body: formData,
      });

      if (!uploadResponse.ok) {
        throw new Error(`Upload failed: ${uploadResponse.status} ${uploadResponse.statusText}`);
      }

      const responseData = await uploadResponse.json();

      // Process response data
      const totalFieldsWithValues = countFieldsWithValues(responseData.extractedValidationData);

      const comparisonResult = compareData(
        responseData.extractedValidationData,
        selectedRow.dataValidation
      );

      // Calculate accuracy percentage
      const percentagePerField = totalFieldsWithValues > 0 ? 100 / totalFieldsWithValues : 0;
      const affectedPercentage = comparisonResult.length * percentagePerField;
      const accuracyPercentage = Math.max(0, 100 - affectedPercentage);

      // Prepare updated row data
      const updatedRowData = {
        ...selectedRow,
        dataExtraction: JSON.stringify(responseData.tableData),
        dataValidation: JSON.stringify(responseData.extractedValidationData),
        dataVisualisation: JSON.stringify(responseData.treeData),
        numberOfFields: totalFieldsWithValues,
        accuracyPercentage: accuracyPercentage.toFixed(2),
      };

      // Update state
      setStoreUpdatingValues([]);

      // Handle compatibility
      handleCompatibility(
        responseData.extractedValidationData?.businessUnitList ?? [],
        selectedRow.fileImportId
      );

      // Log all file changes with proper error handling
      const logResults = [];
      for (const entry of comparisonResult) {
        try {
          const logResult = await logFileChanges({
            fileImportId: selectedRow.fileImportId,
            dataType: entry.type,
            fieldName: entry.columnName,
            oldValue: entry.oldValue,
            newValue: entry.newValue,
            action: entry.status,
            modifiedBy: entry.modifiedBy,
            uid: entry.uniqueIdentifier,
          });

          logResults.push({
            entry,
            success: logResult.success,
            error: logResult.error,
          });

          if (!logResult.success) {
            console.error(`Failed to log change for field ${entry.columnName}:`, logResult.error);
          }
        } catch (error) {
          console.error(`Error logging change for field ${entry.columnName}:`, error);
          logResults.push({
            entry,
            success: false,
            error: error.message,
          });
        }
      }

      // Check if any logging failed
      const failedLogs = logResults.filter((result) => !result.success);
      if (failedLogs.length > 0) {
        console.warn(`${failedLogs.length} out of ${logResults.length} change logs failed`);
      }

      // Update rows state
      const targetRowIndex = rows.findIndex(
        (item) => item.fileImportId === updatedRowData.fileImportId
      );

      if (targetRowIndex !== -1) {
        const updatedRows = [...rows];
        updatedRows[targetRowIndex] = updatedRowData;
        setRows(updatedRows);
      }

      // Update file data in backend
      try {
        const updateResponse = await fetch(`${BASE_URL}/FileData/ImportFiles`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
          body: JSON.stringify(updatedRowData),
        });

        if (!updateResponse.ok) {
          console.error(
            `Failed to update file data: ${updateResponse.status} ${updateResponse.statusText}`
          );
        }
      } catch (updateError) {
        console.error("Error updating file data:", updateError);
      }

      // Show success message
      alert("File uploaded and processed successfully!");
    } catch (error) {
      console.error("File upload error:", error);
      alert(`Error uploading file: ${error.message}`);
    } finally {
      // Always set loading to false when process is complete (success or failure)
      setIsDataValidationPopupOpen(false);
      setIsLoading(false);
    }
  };

  const handleSaveNote = () => {
    // Reset validation errors
    setValidationErrors({
      type: "",
      reason: "",
      note: "",
    });

    let hasErrors = false;
    const newErrors = {
      type: "",
      reason: "",
      note: "",
    };

    // Check if type is "Rejected" or "Approved" and validate mandatory fields
    if (type === "Rejected" || type === "Approved") {
      // Validate Type
      if (!type || type === "Select") {
        newErrors.type = "Type is required";
        hasErrors = true;
      }

      // Validate Reason
      const reasonPlaceholders = [
        "",
        "Select",
        "Select Reject Reason",
        "Select Approve Reason",
        "Select Outstanding Reason",
        "Select Escalated Reason",
        "Select Additional Info Reason",
      ];
      if (!reason || reasonPlaceholders.includes(reason)) {
        newErrors.reason = "Reason is required";
        hasErrors = true;
      }

      // Validate Note
      if (!addNote || addNote.trim() === "") {
        newErrors.note = "Note is required";
        hasErrors = true;
      }

      // If there are validation errors, set them and return
      if (hasErrors) {
        setValidationErrors(newErrors);
        return;
      }
    }

    if (emailedDate !== null && email !== "Select" && addNote !== "") {
      const filename = rows.find((item) => item.fileImportId === selectedCheckbox)?.fileName ?? "";

      const formData = new FormData();
      formData.append("email", email);
      formData.append("type", type);
      formData.append("reason", reason);
      formData.append("notes", addNote);
      formData.append("filename", filename);

      const url = `${BASE_URL}/Email/SendEmail`;

      fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: formData, // Include the FormData object as the request body
      }).then((response) => {
        if (response.ok) {
          alert("Email sent successfully!");
          setIsAddNotePopupOpen(false);
        }
      });
    }

    // Check if type is "Rejected" and automatically send rejection
    if (type === "Rejected" && addNote && reason && reason !== "Select Reject Reason") {
      // Create a copy of the current rows
      const updatedRows = [...rows];

      // Find the selected row
      const rowIndex = updatedRows.findIndex((row) => row.fileImportId === selectedCheckbox);

      if (rowIndex !== -1) {
        // Add notification for rejection
        addNotification({
          type: "failed",
          message: "File rejected. Please try again.",
          filename: updatedRows[rowIndex].fileName,
          date: new Date().toLocaleString(),
        });

        // Update row data with rejection information
        const _rejUser1 = getUserIdFromLocalStorage();
        updatedRows[rowIndex].rejectedBy =
          `${_rejUser1.firstName || ""} ${_rejUser1.lastName || ""}`.trim() || _rejUser1.userId;
        updatedRows[rowIndex].rejectedDate = new Date();
        updatedRows[rowIndex].notes = addNote;
        updatedRows[rowIndex].rejectionReason = reason;
        updatedRows[rowIndex].status = 4; // Status 4: Rejected

        // Send rejection to server
        fetch(`${BASE_URL}/FileData/ImportFiles`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(updatedRows[rowIndex]),
        }).then((response) => {
          if (response) {
            logFileProcess({
              fileImportId: updatedRows[rowIndex].fileImportId,
              fileName: updatedRows[rowIndex].fileName,
              rejectedDate: new Date(),
            });
          }
        });

        // Update the state with the modified rows
        setRows(updatedRows);
      }
    }

    if (addNote) {
      setIsAddNotePopupOpen(false);
      setShowNoteWindow(false);
      // Clear form values after successful save
      setType("");
      setReason("");
      setAddNote("");
      // Clear validation errors
      setValidationErrors({
        type: "",
        reason: "",
        note: "",
      });
    } else {
      alert("Please enter a note before proceeding.");
    }
  };

  const addNotification = (newNotification) => {
    const updatedNotifications = [
      ...(Array.isArray(notifications) ? notifications : []),
      newNotification,
    ];
    handleNotificationList(updatedNotifications);
  };
  const handleReject = async () => {
    if (selectedCheckboxList.length === 0) {
      alert("Please select records to reject");
      return;
    }

    if (selectedCheckboxList.length === 1) {
      // Single selection - show note window
      if (!addNote && !type && !reason) {
        setType("");
        setReason("");
        setAddNote("");
        setEmail("Select");
        setEmailedDate(null);
        setShowNoteWindow(true);
        setIsAddNotePopupOpen(true);
        setSelectedCheckbox(selectedCheckboxList[0]);
      } else {
        const updatedRows = [...rows];
        const rowIndex = updatedRows.findIndex(
          (row) => row.fileImportId === selectedCheckboxList[0]
        );

        if (rowIndex !== -1) {
          addNotification({
            type: "failed",
            message: "File rejected. Please try again.",
            filename: updatedRows[rowIndex].fileName,
            date: new Date().toLocaleString(),
          });

          const _rejUser2 = getUserIdFromLocalStorage();
          updatedRows[rowIndex].rejectedBy =
            `${_rejUser2.firstName || ""} ${_rejUser2.lastName || ""}`.trim() || _rejUser2.userId;
          updatedRows[rowIndex].rejectedDate = new Date();
          updatedRows[rowIndex].notes = addNote;
          updatedRows[rowIndex].rejectionReason = reason;
          updatedRows[rowIndex].status = 4; // Status 4: Rejected

          fetch(`${BASE_URL}/FileData/ImportFiles`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
            },
            body: JSON.stringify(updatedRows[rowIndex]),
          }).then((response) => {
            if (response) {
              logFileProcess({
                fileImportId: updatedRows[rowIndex].fileImportId,
                fileName: updatedRows[rowIndex].fileName,
                rejectedDate: new Date(),
              });
            }
          });
        }

        setRows(updatedRows);
        setSelectedCheckboxList([]);
      }
    } else {
      // Multiple selection - direct rejection without note
      const confirmReject = window.confirm(
        `Are you sure you want to reject ${selectedCheckboxList.length} files?`
      );

      if (confirmReject) {
        const updatedRows = [...rows];

        for (const fileImportId of selectedCheckboxList) {
          const rowIndex = updatedRows.findIndex((row) => row.fileImportId === fileImportId);
          if (rowIndex !== -1) {
            const _rejUser3 = getUserIdFromLocalStorage();
            updatedRows[rowIndex].rejectedDate = new Date();
            updatedRows[rowIndex].rejectedBy =
              `${_rejUser3.firstName || ""} ${_rejUser3.lastName || ""}`.trim() || _rejUser3.userId;
            updatedRows[rowIndex].status = 4; // Status 4: Rejected

            try {
              await fetch(`${BASE_URL}/FileData/ImportFiles`, {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
                },
                body: JSON.stringify(updatedRows[rowIndex]),
              });

              logFileProcess({
                fileImportId: updatedRows[rowIndex].fileImportId,
                fileName: updatedRows[rowIndex].fileName,
                rejectedDate: new Date(),
              });
            } catch (error) {
              console.error(`Error rejecting file ${fileImportId}:`, error);
            }
          }
        }

        setRows(updatedRows);
        setSelectedCheckboxList([]);
        alert(`Successfully rejected ${selectedCheckboxList.length} file(s)`);
        getAllFiles();
      }
    }
  };
  const handleAddNote = () => {
    if (!canAddNote(selectedFilesInfo)) {
      alert("Please select a single file to add a note");
      return;
    }

    if (showNoteWindow == true) {
      setShowNoteWindow(false);
    } else {
      setSelectedCheckbox(selectedCheckboxList[0]);
      setShowNoteWindow(true);
      setIsAddNotePopupOpen(true);
      setValidationErrors({
        type: "",
        reason: "",
        note: "",
      });
    }
  };

  // Handle Send To Admin for multiple selections
  const handleSendToAdmin = async () => {
    if (selectedCheckboxList.length === 0) {
      alert("Please select records to send to admin");
      return;
    }

    try {
      setIsSendingToAdmin(true);

      // Collect all form submission promises to run in parallel
      const submissionPromises = [];

      for (const fileImportId of selectedCheckboxList) {
        const selectedRow = rows.find((row) => row.fileImportId === fileImportId);

        if (!selectedRow) {
          console.warn(`Row not found for fileImportId: ${fileImportId}`);
          continue;
        }

        // Log the file process
        logFileProcess({
          fileImportId: selectedRow.fileImportId,
          fileName: selectedRow.fileName,
          exportedDate: new Date(),
        });

        if (selectedRow.formsData) {
          try {
            const parsedData = JSON.parse(selectedRow.formsData);

            // Handle different formsData structures
            let formsArray = [];

            if (parsedData.formsData && Array.isArray(parsedData.formsData)) {
              // Structure: { formsData: [{ data: [...] }, ...] }
              formsArray = parsedData.formsData.flatMap((item) =>
                Array.isArray(item.data) ? item.data : [item.data]
              );
            } else if (Array.isArray(parsedData)) {
              // Structure: directly an array of forms
              formsArray = parsedData;
            } else if (parsedData.data) {
              // Structure: { data: [...] }
              formsArray = Array.isArray(parsedData.data) ? parsedData.data : [parsedData.data];
            } else {
              // Single form object
              formsArray = [parsedData];
            }

            // Add all form submissions to the promise array
            for (const formData of formsArray) {
              if (formData && typeof formData === "object") {
                submissionPromises.push(
                  W8BENApiHandler({
                    formData: formData,
                    formType: formatUploadType(selectedRow.uploadType),
                  })
                    .then(() => {
                      return { success: true };
                    })
                    .catch((error) => {
                      console.error(`Error submitting form from ${selectedRow.fileName}:`, error);
                      return { success: false, error };
                    })
                );
              }
            }
          } catch (parseError) {
            console.error(`Error parsing formsData for ${selectedRow.fileName}:`, parseError);
          }
        } else {
          console.warn(`No formsData found for ${selectedRow.fileName}`);
        }
      }

      if (submissionPromises.length === 0) {
        alert("No forms found to send to admin. Please ensure the selected files have form data.");
        setIsSendingToAdmin(false);
        return;
      }

      // Execute all submissions in parallel
      const results = await Promise.all(submissionPromises);

      // Count successes and failures
      const totalFormsSubmitted = results.filter((r) => r.success).length;
      const totalFormsErrors = results.filter((r) => !r.success).length;

      const successMessage =
        totalFormsErrors > 0
          ? `${totalFormsSubmitted} form(s) sent to Admin successfully. ${totalFormsErrors} form(s) failed.`
          : `${totalFormsSubmitted} form(s) sent to Admin successfully.`;

      alert(successMessage);

      // Get business unit from the first selected file and fetch its admin URL
      const firstSelectedRow = rows.find((row) => row.fileImportId === selectedCheckboxList[0]);
      if (firstSelectedRow?.businessUnit) {
        const adminUrl = await getAdminUrlByBusinessUnit(firstSelectedRow.businessUnit);
        if (adminUrl) {
          window.open(adminUrl, "_blank");
        } else {
          console.warn(`No admin URL found for business unit: ${firstSelectedRow.businessUnit}`);
          window.open(
            "https://extractor-admin.complytaxforms.com/Pages/Forms/AllNew.aspx?entity=",
            "_blank"
          );
        }
      } else {
        // Fallback to default URL if no business unit found
        window.open(
          "https://extractor-admin.complytaxforms.com/Pages/Forms/AllNew.aspx?entity=",
          "_blank"
        );
      }
      // Delete all successfully sent files
      if (totalFormsSubmitted > 0) {
        for (const fileImportId of selectedCheckboxList) {
          const selectedRow = rows.find((row) => row.fileImportId === fileImportId);

          if (selectedRow) {
            try {
              await handleFileDelete({
                fileImportId: selectedRow.fileImportId,
                fileName: selectedRow.fileName,
                rows,
                setIsDeleting,
                getAllFiles,
                setIsPopupOpen,
              });
            } catch (deleteError) {
              console.error(`Error deleting file ${selectedRow.fileName}:`, deleteError);
            }
          }
        }
      }

      setSelectedCheckboxList([]);
      getAllFiles();
    } catch (error) {
      setIsSendingToAdmin(false);
      console.error("Error in Send to Admin:", error);
      alert(`Error sending forms to admin: ${error.message}`);
    } finally {
      setIsSendingToAdmin(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setStartIndex((parseInt(newPage) - 1) * dynamicRowsPerPage);
    setEndIndex((parseInt(newPage) - 1) * dynamicRowsPerPage + dynamicRowsPerPage);
  };

  useEffect(() => {
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(dynamicRowsPerPage);
  }, [dynamicRowsPerPage]);

  const handleRowsPerPageChange = (event) => {
    totalPages = Math.ceil(
      rows.filter((item) => item.parentId === null).length / parseInt(event.target.value)
    );
    updateRowNumberOfPages(parseInt(event.target.value));
    setRowsPerPage(parseInt(event.target.value));
    setStartIndex(0);
    setCurrentPage(1);
    setEndIndex(parseInt(event.target.value));
    // Reset to the first page
  };

  let totalPages = Math.ceil(
    rows.filter(
      (item) =>
        item.isProcessed === true &&
        item.approvedDate === null &&
        item.rejectedDate === null &&
        item.reviewedDate !== null &&
        item.parentId === null
    ).length / dynamicRowsPerPage
  );

  // Overlay component
  const LoadingOverlay = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        backgroundColor: "rgba(255, 255, 255, 0.5)", // You can adjust the color and opacity as needed
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {/* <CircularProgress style={{ color: '#2aa7e0', marginLeft: 30 }} /> */}
        <Loader />

        {/* <p style={{ marginTop: '10px', color: '#2aa7e0', }}>Saving changes....</p> */}
      </div>
    </div>
  );

  useEffect(() => {
    const handlePopups = async () => {
      if (
        isViewOpen === false &&
        isChangesSaved === true &&
        runValidation === false &&
        saveSum > 0
      ) {
        await setIsViewOpen(true);
        await setIsConfirmationPopup(true);
      } else {
        setIsConfirmationPopup(false);
      }
    };
    handlePopups();
  }, [isChangesSaved, onClickValue, saveSum, isViewOpen]);
  useEffect(() => {}, [storeUpdatingValues]);

  // Search for matching entities when Business Entities tab is active
  useEffect(() => {
    const searchForMatches = async () => {
      if (selectSheet === "Business Entities" && extractedValidatedata.length > 0) {
        setIsLoadingMatches(true);

        // Call all API requests in parallel using Promise.all() - saves time for 100 rows!
        const searchPromises = extractedValidatedata.map((row, index) =>
          searchSingleRow(row)
            .then((result) => {
              return { index, result };
            })
            .catch((error) => {
              console.error(`❌ Error searching row ${index}:`, error);
              return { index, result: { hasMatches: false } };
            })
        );

        // Wait for all searches to complete in parallel
        const allResults = await Promise.all(searchPromises);

        // Build the matches map from results
        const matchesMap = {};
        allResults.forEach(({ index, result }) => {
          if (result.hasMatches && result.matchedEntities) {
            matchesMap[index] = result.matchedEntities;
          }
        });

        setMatchedEntitiesData(matchesMap);
        setIsLoadingMatches(false);
      }
    };

    searchForMatches();
  }, [selectSheet, extractedValidatedata]);

  const handleDropdownChange = (e, row, column, index) => {
    // Handle the change for the dropdown
    const newValue = e.target.value;
    const oldValue = row[column]; // Store the previous value
    row[column] = newValue;

    // Check for duplicate values in the same column
    const updatedExtractedValidateData = [...extractedValidatedata];

    // Special logic for "Income Code" in Income Codes tab
    if (column === "Income Code" && selectSheet === "Income Codes" && row["Income Type"]) {
      const currentIncomeType = row["Income Type"];

      // Find all rows with the same Income Type
      const matchingRows = updatedExtractedValidateData.filter(
        (data, idx) => data["Income Type"] === currentIncomeType && idx !== index
      );

      if (matchingRows.length > 0) {
        const userConfirmed = window.confirm(
          `There are ${matchingRows.length} other row(s) with the same Income Type "${currentIncomeType}".\n\nDo you want to apply this Income Code change to all rows with this Income Type?`
        );

        if (userConfirmed) {
          // Apply the change to all rows with the same Income Type
          for (let idx = 0; idx < updatedExtractedValidateData.length; idx++) {
            const data = updatedExtractedValidateData[idx];
            if (data["Income Type"] === currentIncomeType && idx !== index) {
              const oldIncomeCode = data["Income Code"];
              const oldIncomeType = data["Income Type"];
              data["Income Code"] = newValue;
              data["Income Type"] = ""; // Clear Income Type when Income Code changes
              updatedSaveSumWithValues(
                idx,
                oldIncomeCode,
                "Income Code",
                newValue,
                data["Account Number"] || data["UniqueIdentifier"]
              );
              updatedSaveSumWithValues(
                idx,
                oldIncomeType,
                "Income Type",
                "",
                data["Account Number"] || data["UniqueIdentifier"]
              );
            }
          }

          // Clear Income Type for the current row as well
          const oldIncomeType = row["Income Type"];
          row["Income Type"] = "";
          updatedSaveSumWithValues(
            index,
            oldIncomeType,
            "Income Type",
            "",
            row["Account Number"] || row["UniqueIdentifier"]
          );

          setExtractedValidateData(updatedExtractedValidateData);

          const updateDataValidation = dataValidation;
          if (selectSheet === "Income Codes") {
            updateDataValidation.incomeCodesList = updatedExtractedValidateData;
          }
          setDataValidation(updateDataValidation);
        }
      }
    }

    // Additional logic for "Entity Type" selection
    if (column === "Entity Type") {
      const updatedExtractedValidateData = [...extractedValidatedata];

      if (e.target.value === "Individual/Sole Proprietor" || e.target.value === "Individual") {
        // Clear the "BusinessUnits" column
        const businessUnitValue = updatedExtractedValidateData[index]["Business Name"] || "";
        if (businessUnitValue) {
          updatedSaveSumWithValues(
            index,
            businessUnitValue,
            "Business Name",
            "",
            row["UniqueIdentifier"]
          );
          updatedExtractedValidateData[index]["Business Name"] = "";

          // Move the BusinessUnits value to "FirstName" and "LastName"
          const nameParts = businessUnitValue.split(" ");
          updatedExtractedValidateData[index]["FirstName"] = nameParts[0] || ""; // FirstName
          updatedSaveSumWithValues(
            index,
            "",
            "FirstName",
            nameParts[0] || "",
            row["UniqueIdentifier"]
          );
          updatedExtractedValidateData[index]["LastName"] = nameParts[1] || ""; // LastName
          updatedSaveSumWithValues(
            index,
            "",
            "LastName",
            nameParts[1] || "",
            row["UniqueIdentifier"]
          );
        }
      } else if (e.target.value === "Corporation") {
        // Combine FirstName and LastName into Business Name

        const firstName = updatedExtractedValidateData[index]["FirstName"] || "";
        const lastName = updatedExtractedValidateData[index]["LastName"] || "";
        const combinedName = `${firstName} ${lastName}`.trim();
        if (combinedName) {
          updatedExtractedValidateData[index]["Business Name"] = combinedName;
          updatedSaveSumWithValues(
            index,
            "",
            "Business Name",
            combinedName,
            row["UniqueIdentifier"]
          );

          // Clear FirstName and LastName
          updatedExtractedValidateData[index]["FirstName"] = "";
          updatedSaveSumWithValues(index, firstName, "FirstName", "", row["UniqueIdentifier"]);
          updatedExtractedValidateData[index]["LastName"] = "";
          updatedSaveSumWithValues(index, lastName, "LastName", "", row["UniqueIdentifier"]);
        }
      }

      setExtractedValidateData(updatedExtractedValidateData);

      const updateDataValidation = dataValidation;

      if (selectSheet === "Business Entities") {
        // Update the business unit to extractedData
        updateDataValidation.businessUnitList = updatedExtractedValidateData;
      }

      setDataValidation(updateDataValidation);
    }

    setEditValue(e.target.value);
    if (oldValue && oldValue !== newValue) {
      const duplicates = updatedExtractedValidateData.filter(
        (data, idx) => data[column] === oldValue && idx !== index
      );
      let userConfirmedValue = true;

      if (userConfirmedValue === true) {
        if (duplicates.length > 0 && !userConfirmedValue) {
          // Ask the user if they want to replace duplicates

          let userConfirmed = window.confirm(
            `The value "${oldValue}" is also used in other rows in the "${column}" column. Do you want to replace it with "${newValue}" in those rows?`
          );

          userConfirmedValue = userConfirmed;

          if (userConfirmed) {
            // Replace duplicates
            updatedExtractedValidateData.forEach((data, idx) => {
              if (data[column] === oldValue && idx !== index) {
                data[column] = newValue;
                updatedSaveSumWithValues(idx, oldValue, column, newValue, data["UniqueIdentifier"]); // Update saved values
                if (column === "Entity Type") {
                  if (
                    e.target.value === "Individual/Sole Proprietor" ||
                    e.target.value === "Individual"
                  ) {
                    // Clear the "BusinessUnits" column
                    const businessUnitValue = data["Business Name"] || "";
                    if (businessUnitValue) {
                      updatedSaveSumWithValues(
                        idx,
                        businessUnitValue,
                        "Business Name",
                        "",
                        row["UniqueIdentifier"]
                      );
                      data["Business Name"] = "";

                      // Move the BusinessUnits value to "FirstName" and "LastName"
                      const nameParts = businessUnitValue.split(" ");
                      data["FirstName"] = nameParts[0] || ""; // FirstName
                      updatedSaveSumWithValues(
                        idx,
                        "",
                        "FirstName",
                        nameParts[0] || "",
                        row["UniqueIdentifier"]
                      );
                      data["LastName"] = nameParts[1] || ""; // LastName
                      updatedSaveSumWithValues(
                        idx,
                        "",
                        "LastName",
                        nameParts[1] || "",
                        row["UniqueIdentifier"]
                      );
                    }
                  } else if (e.target.value === "Corporation") {
                    // Combine FirstName and LastName into Business Name

                    const firstName = data["FirstName"] || "";
                    const lastName = data["LastName"] || "";
                    const combinedName = `${firstName} ${lastName}`.trim();
                    if (combinedName) {
                      data["Business Name"] = combinedName;
                      updatedSaveSumWithValues(
                        idx,
                        "",
                        "Business Name",
                        combinedName,
                        row["UniqueIdentifier"]
                      );

                      // Clear FirstName and LastName
                      data["FirstName"] = "";
                      updatedSaveSumWithValues(
                        idx,
                        firstName,
                        "FirstName",
                        "",
                        row["UniqueIdentifier"]
                      );
                      data["LastName"] = "";
                      updatedSaveSumWithValues(
                        idx,
                        lastName,
                        "LastName",
                        "",
                        row["UniqueIdentifier"]
                      );
                    }
                  }
                }
              }
            });
          }
        }
      }
    }
  };

  const updatedSaveSumWithValues = async (
    indexValue,
    OldRowValue,
    column,
    newvalue,
    uniqueIdentifier
  ) => {
    const key = `${indexValue}-${column}`;
    const rowIndexExists = addNewRowsList.some((row) => row === indexValue);
    // Find if an entry with the same key exists
    const existingIndex = storeUpdatingValues.findIndex(
      (item) => `${item.rowIndex}-${item.columnName}` === key
    );
    // Check if the oldValue and editValue are the same
    if (OldRowValue === newvalue) {
      return; // Exit the function early
    }

    const newEntry = {
      oldValue: OldRowValue,
      newValue: newvalue,
      type: selectSheet,
      modifiedBy: getUserIdFromLocalStorage().userId,
      modifiedDate: new Date(),
      action: rowIndexExists ? "Created" : "Updated",
      rowIndex: indexValue,
      columnName: column,
      uniqueIdentifier: uniqueIdentifier,
    };

    if (existingIndex === -1) {
      // If no existing entry found, add new entry
      if (oldValue || editValue) {
        // setStoreUpdatingValues(prevValues => [...prevValues, newEntry]);
        setStoreUpdatingValues((prevValues) => {
          const updatedValues = [...prevValues, newEntry];
          return updatedValues;
        });
        setSaveSum((prevValues) => {
          const updatedValues = prevValues + 1;
          return updatedValues;
        });
      }
    } else {
      setStoreUpdatingValues((prevValues) => {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = newEntry; // Update the specific index
        return updatedValues;
      });
    }
  };

  // Use centralized delete service
  const handleDelete = async () => {
    if (!selectDeletedItem) {
      alert("No file selected for deletion.");
      return;
    }

    const rowToDelete = rows.find((row) => row.fileImportId === selectDeletedItem);

    await handleFileDelete({
      fileImportId: selectDeletedItem,
      fileName: rowToDelete?.fileName || "Unknown file",
      rows,
      setIsDeleting,
      getAllFiles,
      setIsPopupOpen,
    });
  };

  const handleExcelAuditReport = async () => {
    try {
      setIsLoading(true);
      const formData = new FormData();

      const auditRows = (extractedValidatedata || []).map((item) => ({
        fileName: item.fileName,
        userName: item.userName || item.modifiedBy || "",
        email: item.email || "",
        action: item.action || "",
        actionDate: item.actionDate || item.modifiedDate || "",
      }));

      const formatted = auditRows.map((r) => ({
        "FILE NAME": r.fileName,
        "USER NAME": r.userName,
        EMAIL: r.email,
        ACTION: r.action,
        "ACTION DATE": r.actionDate ? formatDate(r.actionDate) : "",
      }));

      const now = new Date();
      const dateTimeString = now.toISOString().replace(/[:.]/g, "-").slice(0, 19);
      const fileName = `user_audit_report_${dateTimeString}`;

      formData.append("filename", fileName);
      formData.append("reportData", JSON.stringify(formatted));
      formData.append(
        "organizationId",
        selectedRow?.organizationId ||
          rows.find((item) => item.fileImportId === selectedCheckbox)?.organizationId
      );
      formData.append(
        "userId",
        selectedRow?.userID || rows.find((item) => item.fileImportId === selectedCheckbox)?.userID
      );

      const url = `${pythonBaseUrl}/Excel/ExcelReport`;

      const response = await fetch(url, {
        method: "POST",
        headers: { Authorization: `Bearer ${getUserIdFromLocalStorage().token}` },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const contentDisposition = response.headers.get("Content-Disposition");
      let downloadFileName = `${fileName}.xlsx`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          downloadFileName = filenameMatch[1].replace(/['"]/g, "");
        }
      }

      const blob = await response.blob();
      if (blob.size === 0) throw new Error("Received empty Excel file from server");

      const downloadUrl = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");
      downloadLink.href = downloadUrl;
      downloadLink.download = downloadFileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error("Error downloading audit Excel:", err);
      alert("Failed to download audit Excel.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleColumnCheckboxChange = (e) => {
    if (e.target.checked) {
      // Select all visible rows
      const visibleRows = rows
        .filter(
          (item) =>
            item.isProcessed === true &&
            item.approvedDate === null &&
            item.rejectedDate === null &&
            item.reviewedDate !== null &&
            item.parentId === null
        )
        .slice(startIndex, endIndex);

      setSelectedCheckboxList(visibleRows.map((row) => row.fileImportId));
    } else {
      // Deselect all rows
      setSelectedCheckboxList([]);
    }
  };
  // Field name mapping for standardized display
  const getStandardizedFieldName = (fieldName) => {
    const fieldMapping = {
      // Name of organization variants
      "IMY-Name_of_organization": "Name of organization",
      "W8-BENE-Organization_name": "Name of organization",
      "EXP-Organization_name": "Name of organization",
      Organization_name: "Name of organization",
      organizationName: "Name of organization",
      organization_name: "Name of organization",

      // Beneficial Owner name variants
      "W8BEN-Beneficial_owner_name": "Beneficial Owner name",
      Beneficial_owner: "Beneficial Owner name",
      beneficial_owner: "Beneficial Owner name",
      beneficialOwner: "Beneficial Owner name",

      // U.S. taxpayer identification number variants
      "W8BEN-US_taxpayer_id": "U.S. taxpayer identification number",
      US_taxpayer_identification_number: "U.S. taxpayer identification number",
      US_Taxpayer_identification_number: "U.S. taxpayer identification number",
      "W8_BENE-8-us-taxpayer-id": "U.S. taxpayer identification number",
      us_taxpayer_id: "U.S. taxpayer identification number",

      // Country of incorporation or organization variants
      "Country_of_incorporation/organization": "Country of incorporation or organization",
      "W8_BENE-Country_of_incorporation_organization": "Country of incorporation or organization",
      Country_of_incorporation_organization: "Country of incorporation or organization",

      // Country of citizenship variants
      "W8BEN-Country_of_citizenship": "Country of citizenship",
      Country_of_citizenship: "Country of citizenship",
      country_of_citizenship: "Country of citizenship",

      // Foreign tax identifying number variants
      Foreign_tax_identifying_number: "Foreign tax identifying number",
      "W8_BENE-Foreign_tax_identifying_number": "Foreign tax identifying number",
      "W8BEN-Foreign_taxpayer_id": "Foreign tax identifying number",
      foreign_tax_id: "Foreign tax identifying number",

      // Permanent residence address variants
      "W8BEN-Permanent_address_street": "Permanent residence address",
      Permanent_address_street: "Permanent residence address",
      "W8_BENE-Permanent_address_street": "Permanent residence address",
      "W9-Address": "Permanent residence address",
      "ECI-Business_address_street": "Permanent residence address",
      permanent_address_street: "Permanent residence address",

      // Permanent city address variants
      "W8BEN-Permanent_address_city_state_postal": "Permanent city address",
      Permanent_address_city_state_postal: "Permanent city address",
      "W8_BENE-Permanent_address_city_state_postal": "Permanent city address",
      "W9-City_state_zip": "Permanent city address",
      "ECI-Business_address_city_state_zip": "Permanent city address",
      permanent_address_city: "Permanent city address",

      // Permanent address country variants
      "W8BEN-Permanent_address_country": "Permanent address country",
      Permanent_address_country: "Permanent address country",
      "W8_BENE-Permanent_address_country": "Permanent address country",
      permanent_address_country: "Permanent address country",

      // Mailing address variants
      "W8BEN-Mailing_address_street": "Mailing address",
      Mailing_address_street: "Mailing address",
      "W8_BENE-Mailing_address_street": "Mailing address",
      mailing_address_street: "Mailing address",

      // Mailing address city variants
      "W8BEN-Mailing_address_city_state_postal": "Mailing address city",
      Mailing_address_city_state_postal: "Mailing address city",
      "W8_BENE-Mailing_address_city_state_postal": "Mailing address city",
      mailing_address_city: "Mailing address city",

      // Mailing address country variants
      "W8BEN-Mailing_address_country": "Mailing address country",
      Mailing_address_country: "Mailing address country",
      "W8_BENE-Mailing_address_country": "Mailing address country",
      mailing_address_country: "Mailing address country",

      // GIIN variants
      // "IMY-GIIN": "GIIN",
      "EXP-GIIN": "GIIN",
      "W8_BENE-9A_giin": "GIIN",
      "W8_BENE-13_giin": "GIIN",
      giin: "GIIN",

      // Date of birth variants
      "W8BEN-Date_of_birth": "Date of birth",
      Date_of_birth: "Date of birth",
      date_of_birth: "Date of birth",
      dateOfBirth: "Date of birth",

      // Social security number variants
      "W9-Social_security_number": "Social security number",
      Social_security_number: "Social security number",
      social_security_number: "Social security number",
      ssn: "Social security number",

      // Employer identification number variants
      "W9-Employer_identification_number": "Employer identification number",
      Employer_identification_number: "Employer identification number",
      employer_identification_number: "Employer identification number",
      ein: "Employer identification number",

      // New fields
      // Chapter4Status: "Chapter 4 Status",
      // chapter4Status: "Chapter 4 Status",
      // chapter_4_status: "Chapter 4 Status",
      // EntityType: "Entity Type",
      // entityType: "Entity Type",
      // entity_type: "Entity Type",
      uniqueidentifier: "Unique Identifier",
      uniqueIdentifier: "Unique Identifier",
      unique_identifier: "Unique Identifier",
    };

    // First check if there's a specific mapping, otherwise format the field name
    return fieldMapping[fieldName] || formatFieldNameForDisplay(fieldName);
  };

  const processFormsData = (formsDataString) => {
    try {
      // Parse the JSON string
      const formsDataArray = JSON.parse(formsDataString);

      // Iterate through each `data` array and merge its objects into a single object
      const finalArray = formsDataArray.formsData.map((item) => {
        // Merge all objects inside `data` array into one object
        const mergedRow = item.data.reduce((acc, obj) => ({ ...acc, ...obj }), {});
        return mergedRow; // Each merged object becomes a new row
      });

      return finalArray; // Returning the final merged array
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return []; // Return an empty array in case of an error
    }
  };
  // Handle assigning matching unique identifier to form data
  const handleAssignMatchingIdentifier = async (matchingEntity) => {
    if (!singleFormData?.row || !matchingEntity) {
      alert("Unable to assign identifier - missing data");
      return;
    }

    try {
      // Extract the ENTITY unique identifier from the matching entity
      const matchingUniqueId =
        matchingEntity.entity?.uniqueIdentifier || matchingEntity.uniqueIdentifier;

      if (!matchingUniqueId) {
        alert("No entity unique identifier found in the matching entity");
        return;
      }

      const row = singleFormData?.row;

      if (!row) {
        alert("Unable to assign identifier - no row data available");
        return;
      }

      // Get the current unique identifier for comparison
      const currentUniqueId =
        singleFormData.extractedData?.uniqueidentifier ||
        singleFormData.extractedData?.UniqueIdentifier ||
        "Not set";

      // Confirm the assignment with clear indication this is ENTITY identifier
      // const confirmMessage = `Assign ENTITY unique identifier?\n\nNote: This will assign the ENTITY identifier, not the form identifier.`;
      // if (!window.confirm(confirmMessage)) {
      //   return;
      // }

      // Parse the existing formsData
      let parsedData = null;
      if (row.formsData) {
        try {
          parsedData = JSON.parse(row.formsData);
        } catch (error) {
          console.error("Error parsing formsData:", error);
          alert("Error parsing form data");
          return;
        }
      }

      // Update the form data with the matching ENTITY unique identifier
      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        // New format: formsData is directly an array
        if (parsedData[0]) {
          parsedData[0].entityUniqueIdentifier = matchingUniqueId;
        }
      } else if (parsedData && parsedData.data) {
        // Old format: wrapped in data property
        if (Array.isArray(parsedData.data) && parsedData.data.length > 0) {
          parsedData.data[0].entityUniqueIdentifier = matchingUniqueId;
        } else if (typeof parsedData.data === "object") {
          parsedData.data.entityUniqueIdentifier = matchingUniqueId;
        }
      }

      // Update the row's formsData
      row.formsData = JSON.stringify(parsedData);

      // Save the updated row to the server
      const userData = getUserIdFromLocalStorage();
      const response = await fetch(`${BASE_URL}/FileData/ImportFiles`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.token}`,
        },
        body: JSON.stringify(row),
      });

      if (!response.ok) {
        throw new Error("Failed to save updated form data");
      }

      // Update the single form data state immediately for UI reflection
      setSingleFormData((prevData) => ({
        ...prevData,
        row: {
          ...prevData.row,
          formsData: JSON.stringify(parsedData),
        },
        extractedData: {
          ...prevData.extractedData,
          entityUniqueIdentifier: matchingUniqueId,
        },
        // Add timestamp to force form re-render
        lastUpdated: new Date().getTime(),
      }));

      alert(`✅ Successfully updated!`);

      // Force form to re-render by updating the component key
      // This ensures the unique identifier field displays immediately
      setForceFormRerender((prev) => prev + 1);

      // Refresh the single form view to show updated data
      await handleSingleFormView(row);
    } catch (error) {
      console.error("Error assigning unique identifier:", error);
      alert("❌ Error assigning unique identifier. Please try again.");
    }
  };
  const handleCompatibility = (rows, fileImportId) => {
    const updatedNotMatchingFields = [];
    const updatedMandatoryFields = [];
    let notMatchingFieldsCount = 0;
    let mandatoryFieldsCount = 0;

    rows.forEach((row, rowIndex) => {
      const rowErrors = {};
      const mandatoryErrors = {};
      const columnKeys = Object.keys(row); // Dynamically get the column names
      // if (rowIndex === 0) {
      //     console.log(columnKeys);
      // }

      // Mandatory Field Checks
      if (columnKeys.includes("UniqueIdentifier") && !row["UniqueIdentifier"]) {
        mandatoryFieldsCount = mandatoryFieldsCount + 1;
        mandatoryErrors["UniqueIdentifier"] = `Row ${rowIndex + 1}: This field is mandatory.`;
      }

      if (columnKeys.includes("Entity Type") && !row["Entity Type"]) {
        mandatoryFieldsCount = mandatoryFieldsCount + 1;
        mandatoryErrors["Entity Type"] = `Row ${rowIndex + 1}: This field is mandatory.`;
      }
      if (
        row["Entity Type"] === "Individual" ||
        row["Entity Type"] === "Individual/Sole Proprietor"
      ) {
        if (columnKeys.includes("FirstName") && !row["FirstName"]) {
          mandatoryFieldsCount = mandatoryFieldsCount + 1;
          mandatoryErrors["FirstName"] = `Row ${rowIndex + 1}: This field is mandatory.`;
        }
        if (columnKeys.includes("LastName") && !row["LastName"]) {
          mandatoryFieldsCount = mandatoryFieldsCount + 1;
          mandatoryErrors["LastName"] = `Row ${rowIndex + 1}: This field is mandatory.`;
        }
      }
      if (row["Entity Type"] === "Corporation") {
        if (columnKeys.includes("Business Name") && !row["Business Name"]) {
          mandatoryFieldsCount = mandatoryFieldsCount + 1;
          mandatoryErrors["Business Name"] = `Row ${rowIndex + 1}: This field is mandatory.`;
        }
      }
      if (columnKeys.includes("BusinessUnit") && !row["BusinessUnit"]) {
        mandatoryFieldsCount = mandatoryFieldsCount + 1;
        mandatoryErrors["BusinessUnit"] = `Row ${rowIndex + 1}: This field is mandatory.`;
      }

      const permCountry = row["Perm. Country"];
      const mailCountry = row["Mail Country"];

      // Base dropdown columns
      // Base dropdown columns - Business Entities
      const businessEntityCountryColumns = [
        "CountryOfBirth",
        "CountryOfBirthOther",
        "Country Of Citizenship For Tax Purposes",
        "Country Of Citizenship For Tax Purposes Other",
        "Country Of Citizenship For Tax Purposes2",
        "Country Of Citizenship For Tax Purposes3",
        "Business Country",
        "CountryOther",
        "Domicile Country",
        "ForeignTaxpayerCountry",
        "Perm. Country",
        "Perm. CountryOther",
        "Mail Country",
        "Mail CountryOther",
        "Contact CellNumber Country",
        "Contact Telephone Country",
        "Contact Telephone Country2",
        "VATCountry",
      ];

      // Forms tab country columns
      const formsCountryColumns = [
        "Treaty country",
        "Foreign Tax Country",
        "Self-cert Primary Jurisdiction2",
        "Self-cert Additional Jurisdiction1",
        "Self-cert Additional Jurisdiction2",
        "Permanent Country",
        "Permanent Country Other",
        "Country of Citizenship",
        "Country of incorporation or organization",
        "Mailing address Country",
        "Mailing address Country Other",
        "Disregarded entity address Country",
      ];

      const baseColumns = [
        "Entity Type",
        "Entity Classification",
        "Chapter4Status",
        ...(selectSheet === "Business Entities" ? businessEntityCountryColumns : []),
        ...(selectSheet === "Forms"
          ? ["FATCA Entity Types", "Form type and revision", ...formsCountryColumns]
          : []),
      ];

      // Include state/province columns conditionally
      const dropdownColumns = [
        ...baseColumns,
        ...(selectSheet === "Income Codes" ? ["Income Code"] : []),
        ...(permCountry === "United States" || permCountry === "Canada" ? ["State_Province"] : []),
        ...(mailCountry === "United States" || mailCountry === "Canada" ? ["State_Province2"] : []),
        // Forms tab state fields
        ...(selectSheet === "Forms" &&
        (row["Permanent Country"] === "United States" || row["Permanent Country"] === "Canada")
          ? ["Permanent State Province"]
          : []),
        ...(selectSheet === "Forms" &&
        (row["Mailing address Country"] === "United States" ||
          row["Mailing address Country"] === "Canada")
          ? ["Mailing address State Province"]
          : []),
      ];

      // Check if any column in the row matches dropdown columns
      const isDropdownColumn = dropdownColumns.some((column) => columnKeys.includes(column));

      // Options mapping
      const optionsMap = {
        "Entity Type": entityTypeOptions,
        "Entity Classification": entityClassificationOptions,
        Chapter4Status: chapter4StatusOptions,
        "FATCA Entity Types": chapter4StatusOptions,
        "Form type and revision": formsTypeList,
        "Income Code": incomeCodesDropDownList,
        // Business Entities country fields
        CountryOfBirth: countries,
        CountryOfBirthOther: countries,
        "Country Of Citizenship For Tax Purposes": countries,
        "Country Of Citizenship For Tax Purposes Other": countries,
        "Country Of Citizenship For Tax Purposes2": countries,
        "Country Of Citizenship For Tax Purposes3": countries,
        "Business Country": countries,
        CountryOther: countries,
        "Domicile Country": countries,
        ForeignTaxpayerCountry: countries,
        "Perm. Country": countries,
        "Perm. CountryOther": countries,
        "Mail Country": countries,
        "Mail CountryOther": countries,
        "Contact CellNumber Country": countries,
        "Contact Telephone Country": countries,
        "Contact Telephone Country2": countries,
        VATCountry: countries,
        // Forms tab country fields
        "Treaty country": countries,
        "Foreign Tax Country": countries,
        "Self-cert Primary Jurisdiction2": countries,
        "Self-cert Additional Jurisdiction1": countries,
        "Self-cert Additional Jurisdiction2": countries,
        "Permanent Country": countries,
        "Permanent Country Other": countries,
        "Country of Citizenship": countries,
        "Country of incorporation or organization": countries,
        "Mailing address Country": countries,
        "Mailing address Country Other": countries,
        "Disregarded entity address Country": countries,
        // State/Province fields
        State_Province: permCountry ? countriesWithStates[permCountry] || [] : [],
        State_Province2: mailCountry ? countriesWithStates[mailCountry] || [] : [],
        "Permanent State Province": row["Permanent Country"]
          ? countriesWithStates[row["Permanent Country"]] || []
          : [],
        "Mailing address State Province": row["Mailing address Country"]
          ? countriesWithStates[row["Mailing address Country"]] || []
          : [],
        ...(permCountry === "United States" || permCountry === "Canada"
          ? { State_Province: countriesWithStates[permCountry] || [] }
          : {}),
        ...(mailCountry === "United States" || mailCountry === "Canada"
          ? { State_Province2: countriesWithStates[mailCountry] || [] }
          : {}),
      };

      columnKeys.forEach((key) => {
        const value = row[key];
        // Perform matching only if the value is non-empty and the specific column is a dropdown column
        if (dropdownColumns.includes(key) && value && optionsMap[key]) {
          let isValid = false;

          // Special handling for State_Province fields
          if (key === "State_Province" || key === "State_Province2") {
            const country = key === "State_Province" ? permCountry : mailCountry;
            isValid = isValidStateForCountry(value, country);
          } else {
            // Case-insensitive comparison for dropdown validation
            isValid = optionsMap[key].some((opt) => opt.toLowerCase() === value.toLowerCase());
          }

          if (!isValid) {
            notMatchingFieldsCount = notMatchingFieldsCount + 1;
            rowErrors[key] = {
              originalValue: value,
              dropdownValues: optionsMap[key],
              message: `Row ${
                rowIndex + 1
              }: Value '${value}' does not match available dropdown options.`,
            };
          }
        }

        // Validate format for specific fields (SSN, EIN, GIIN, etc.)
        if (value && value.trim() !== "") {
          const validation = validateField(key, value);
          if (!validation.isValid) {
            // Increment count if this is a new error (not already counted from dropdown validation)
            if (!rowErrors[key]) {
              notMatchingFieldsCount = notMatchingFieldsCount + 1;
            }
            rowErrors[key] = {
              ...rowErrors[key],
              originalValue: value,
              validationError: validation.errorMessage,
              message: `Row ${rowIndex + 1}: ${validation.errorMessage}`,
            };
          }
        }
      });

      if (Object.keys(rowErrors).length > 0) {
        updatedNotMatchingFields.push(rowErrors); // Only push rowErrors, no fileImportId here
      }

      if (Object.keys(mandatoryErrors).length > 0) {
        updatedMandatoryFields.push(mandatoryErrors); // Only push mandatoryErrors, no fileImportId here
      }
    });

    setNotMatchingFields((prevValues) => {
      const updatedValues = prevValues.filter((item) => item.fileImportId !== fileImportId);
      updatedValues.push({
        fileImportId,
        notMatchingFields: updatedNotMatchingFields,
        count: notMatchingFieldsCount,
      });
      return updatedValues;
    });

    setMandatoryFields((prevValues) => {
      const updatedValues = prevValues.filter((item) => item.fileImportId !== fileImportId);
      updatedValues.push({
        fileImportId,
        mandatoryFields: updatedMandatoryFields,
        count: mandatoryFieldsCount,
      });
      return updatedValues;
    });
  };
  const shouldHighlightRow = (currentValue, currentRowIndex) => {
    // Skip if currentValue is empty, null, or undefined
    if (
      !currentValue ||
      currentValue === "" ||
      currentValue === null ||
      currentValue === undefined
    ) {
      return { highlight: false, matchType: null };
    }

    const selectedRow = rows.find((row) => row.fileImportId === selectedCheckbox);
    if (!selectedRow || !selectedRow.formsData) {
      return { highlight: false, matchType: null };
    }

    try {
      const newData = processFormsData(selectedRow.formsData) || [];
      const withHoldingData =
        JSON.parse(selectedRow.formsData).withholdingData.businessUnitList || null;

      if (!withHoldingData || !withHoldingData[currentRowIndex]) {
        return { highlight: false, matchType: null };
      }

      const currentRow = withHoldingData[currentRowIndex];
      let matchInViewForm = false;
      let matchInBoth = false;

      // Find any row in viewForms where matchedRow matches current index or need to compare names
      for (let i = 0; i < newData.length; i++) {
        const viewFormRow = newData[i];

        // Check if this row should be compared based on names (when matchingRow is null)
        let shouldCompareThisRow = viewFormRow.matchingRow === currentRowIndex;

        // If matchingRow is null, use name comparison logic
        if (viewFormRow.matchingRow === null || viewFormRow.matchingRow === undefined) {
          // Extract names from viewFormRow
          const beneficialOwnerName =
            viewFormRow["Beneficial Owner name"] ||
            viewFormRow["W8-BENE-Organization_name"] ||
            viewFormRow["Name of organization"] ||
            "";
          // Check if current row has first name, last name or business name that matches
          const excelFirstName = currentRow["FirstName"] || "";
          const excelLastName = currentRow["LastName"] || "";
          const excelBusinessName = currentRow["Business Name"] || "";
          const excelUniqueIdentifier = currentRow["UniqueIdentifier"] || "";
          const formUniqueIdentifier = viewFormRow["UniqueIdentifier"] || "";

          // Compare business names

          // Compare full names
          const formFullName = beneficialOwnerName.toLowerCase();
          const excelFullName = (excelFirstName + " " + excelLastName).toLowerCase().trim();

          if (
            excelUniqueIdentifier &&
            formUniqueIdentifier &&
            excelUniqueIdentifier.toLowerCase() === formUniqueIdentifier.toLowerCase()
          ) {
            shouldCompareThisRow = true;
          }
          // Check name matches
          else if (excelFullName === formFullName) {
            shouldCompareThisRow = true;
          } else if (excelBusinessName.toLowerCase() === formFullName) {
            shouldCompareThisRow = true;
          }
        }

        // If this row should be compared (either by matchingRow or name logic)
        if (shouldCompareThisRow) {
          // Now check if any value in viewForm row contains the current value
          for (const key in viewFormRow) {
            // Skip if viewFormRow[key] is not a string or is null/undefined
            if (
              typeof viewFormRow[key] !== "string" ||
              viewFormRow[key] === null ||
              viewFormRow[key] === undefined
            ) {
              continue;
            }

            const viewFormValue = viewFormRow[key].toLowerCase();
            const currentValueLower = String(currentValue).toLowerCase();

            if (viewFormRow[key] === "selected") {
              // Check if the key exists in entity type or chapter 4 status mappings
              let mappedValue = null;

              if (entityTypeMap[key]) {
                mappedValue = entityTypeMap[key];
              } else if (chapter4StatusMap[key]) {
                mappedValue = chapter4StatusMap[key];
              } else if (key === "Other tax-exempt organization") {
                mappedValue = "Tax-exempt organization";
              }

              if (mappedValue) {
                const mappedValueLower = mappedValue.toLowerCase();
                // Check if the mapped value matches the current value
                if (mappedValueLower === currentValueLower) {
                  matchInViewForm = true;
                  // Check if it also exists in current row data
                  for (const currentKey in currentRow) {
                    if (
                      typeof currentRow[currentKey] === "string" &&
                      currentRow[currentKey].toLowerCase() === currentValueLower
                    ) {
                      matchInBoth = true;
                      break;
                    }
                  }

                  if (matchInBoth) {
                    break;
                  }
                }
              } else if (key.toLowerCase().includes(currentValueLower)) {
                matchInViewForm = true;
                // Check if it also exists in current row data
                for (const currentKey in currentRow) {
                  if (
                    typeof currentRow[currentKey] === "string" &&
                    currentRow[currentKey].toLowerCase() === currentValueLower
                  ) {
                    matchInBoth = true;
                    break;
                  }
                }

                if (matchInBoth) {
                  break;
                }
              }
            } else if (viewFormValue.includes(currentValueLower)) {
              matchInViewForm = true;
              // Check if it also exists in current row data
              for (const currentKey in currentRow) {
                if (
                  typeof currentRow[currentKey] === "string" &&
                  currentRow[currentKey].toLowerCase() === currentValueLower
                ) {
                  matchInBoth = true;
                  break;
                }
              }

              if (matchInBoth) {
                break;
              }
            }
          }

          if (matchInViewForm) {
            break;
          }
        }
      }

      if (matchInBoth) {
        return { highlight: true, matchType: "both" };
      } else if (matchInViewForm) {
        return { highlight: true, matchType: "viewForm" };
      } else {
        return { highlight: false, matchType: null };
      }
    } catch (error) {
      console.error("Error processing forms data:", error);
      return { highlight: false, matchType: null };
    }
  };

  useEffect(() => {
    // console.log(notMatchingFields);
    // console.log(mandatoryFields);
  }, [notMatchingFields, mandatoryFields]);

  const getFormTypeDisplayName = (formType) => {
    if (!formType) return "";
    switch (formType.toLowerCase()) {
      case "w8imy":
        return "W-8IMY";
      case "w8bene":
        return "W-8BEN-E";
      case "w9":
        return "W-9";
      case "w8ben":
        return "W-8BEN";
      case "w8exp":
        return "W-8EXP";
      case "w8eci":
        return "W-8ECI";
      case "8233":
        return "8233";
      case "form 8233":
        return "Form 8233";
      case "self-cert":
        return "Self-Cert";
      case "iddocument":
        return "ID Documents";
      case "id documents":
        return "ID Documents";
      case "selfcert-ind":
        return "SELFCERT-IND";
      case "selfcert-ent":
        return "SELFCERT-ENT";
      case "self-cert entity":
        return "SELFCERT-ENT";
      case "self-cert individual":
        return "SELFCERT-IND";
      case "SELFCERT-IND":
        return "SELFCERT-IND";
      case "SELFCERT-ENT":
        return "SELFCERT-ENT";
      case "selfcert-ind":
        return "SELFCERT-IND";
      case "selfcert-ent":
        return "SELFCERT-ENT";
      default:
        return formType; // Return the original if not matched
    }
  };
  const getIdDocumentType = (formData) => {
    if (formData.displayIdType) {
      // console.log(formData.displayIdType);
    }

    const parts = formData.documentType.split(".");
    // Get all parts except the first one
    let result = parts.length > 1 ? parts.slice(1).join(".") : "ID Document";

    // Capitalize first letter if result is not empty
    if (result.length > 0) {
      result = result.charAt(0).toUpperCase() + result.slice(1);
    }

    return result;
  };
  const getFormTypeCounts = (data) => {
    const counts = {
      w8ben: 0,
      w8bene: 0,
      w8eci: 0,
      w8imy: 0,
      w9: 0,
      w8exp: 0,
      "self-cert": 0,
      idDocument: 0,
      other: 0,
    };

    // Store the original row indices for each form type
    const indexMap = {
      w8ben: [],
      w8bene: [],
      w8eci: [],
      w8imy: [],
      w9: [],
      w8exp: [],
      "self-cert": [],
      idDocument: [],
      other: [],
    };

    data.forEach((item, index) => {
      const formType = item.formType
        ? item.formType.toLowerCase()
        : item.documentType
          ? item.documentType.split(".")[0]
          : "other";
      if (counts.hasOwnProperty(formType)) {
        counts[formType]++;
        indexMap[formType].push(index);
      } else {
        counts.other++;
        indexMap.other.push(index);
      }
    });

    return { counts, indexMap };
  };

  // Calculate the counts and index map
  const { counts: formTypeCounts, indexMap: formTypeIndices } =
    getFormTypeCounts(extractedValidatedata);
  const isFormTypeWithToggle = (formType) => {
    if (!formType) return false;

    const type = formType.toLowerCase();
    // Only show toggle for W-8 variants, W-9, and Self-Cert
    return type.startsWith("w8") || type === "w9" || type === "self-cert";
  };
  // Filter out form types with zero count
  const formTypesWithCount = Object.entries(formTypeCounts).filter(([_, count]) => count > 0);
  const getForm = (formType, selectedRowData, selectedIndex) => {
    // Callback function to handle successful form saves
    const handleFormSaveSuccess = (updatedRowData) => {
      setSaveSum(0);
      setIsChangesSaved(false);
      setStoreUpdatingValues([]);

      // Update the rows state with the new row data
      if (updatedRowData) {
        setRows((prevRows) =>
          prevRows.map((row) => (row.fileImportId === selectedCheckbox ? updatedRowData : row))
        );

        // Refresh the form data by re-processing the updated row data
        if (updatedRowData.formsData) {
          const { formsList } = processFormsDataWithFormTypes(updatedRowData.formsData);
          if (formsList.length > 0) {
            // Update the extractedValidatedata with the new form data
            setExtractedValidateData(formsList);
          }
        }
      }

      // Don't close the modal - let it stay open
    };

    if (!formType)
      return (
        <W8BENFORM
          selectedRowData={selectedRowData}
          row={rows.find((row) => row.fileImportId === selectedCheckbox)}
          selectedIndex={selectedIndex}
          onSaveSuccess={handleFormSaveSuccess}
        />
      );

    switch (formType.toLowerCase()) {
      case "w8imy":
        return (
          <IMYFormComplete
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        );
      case "w8bene":
        return (
          <BENEFormComplete
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        );
      case "w9":
        return (
          <W9Form
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        );
      case "w8ben":
        return (
          <W8BENFORM
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        );
      case "w8exp":
        return (
          <EXPFormComplete
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        );
      case "w8eci":
        return (
          <ECIFormComplete
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        );
      case "self-cert":
        return selectedRowData["SC-Entity-Section_1_entity_name"] ? (
          <SelfCertEntityForm
            key={`self-cert-entity-${selectedCheckbox}-${selectedIndex}`}
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        ) : (
          <SelfCertificationForm
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        );
      case "selfcert-ind":
        return (
          <SelfCertificationForm
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        );
      case "selfcert-ent":
        return (
          <SelfCertEntityForm
            key={`self-cert-entity-${selectedCheckbox}-${selectedIndex}`}
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        );
      default:
        return (
          <W8BENFORM
            selectedRowData={selectedRowData}
            row={rows.find((row) => row.fileImportId === selectedCheckbox)}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleFormSaveSuccess}
          />
        ); // Return the original if not matched
    }
  };
  const containerWidth = isMenuOpen ? "calc(100vw - 350px)" : "calc(100vw - 180px)";
  const halfWidth = `calc(${containerWidth} / 2)`;
  // First, let's enhance the processFormsData function to extract form types
  // Function to process forms data with form types and group by form name
  const processFormsDataWithFormTypes = (formsData) => {
    if (!formsData) return { formsList: [], formTypes: [], formsByName: {} };

    try {
      const formsList = processFormsData(formsData) || [];
      // Extract form types from each form and print its index value
      const formTypes = [];
      formsList.forEach((form, index) => {
        form.originalIndexValue = index;

        if (form.formType && !formTypes.includes(form.formType)) {
          formTypes.push(form.formType);
        }
        if (form.documentType && form.documentType.includes("idDocument")) {
          if (!formTypes.includes("id documents")) {
            formTypes.push("id documents");
          }
        } else if (form.fileName) {
          // Try to extract form type from filename
          const fileNameLower = form.fileName.toLowerCase();
          if (fileNameLower.includes("w8ben") && fileNameLower.includes("e")) {
            formTypes.push("w8bene");
          } else if (fileNameLower.includes("w8ben")) {
            formTypes.push("w8ben");
          } else if (fileNameLower.includes("w8imy")) {
            formTypes.push("w8imy");
          } else if (fileNameLower.includes("w8eci")) {
            formTypes.push("w8eci");
          } else if (fileNameLower.includes("w8exp")) {
            formTypes.push("w8exp");
          } else if (fileNameLower.includes("w9")) {
            formTypes.push("w9");
          } else if (
            fileNameLower.includes("id document") ||
            fileNameLower.includes("passport") ||
            fileNameLower.includes("driving") ||
            fileNameLower.includes("license")
          ) {
            if (!formTypes.includes("id documents")) {
              formTypes.push("id documents");
            }
          } else if (
            fileNameLower.includes("self-cert") ||
            fileNameLower.includes("self cert") ||
            fileNameLower.includes("dsc") ||
            fileNameLower.includes("individual") ||
            fileNameLower.includes("self-certification")
          ) {
            if (!formTypes.includes("self-cert")) {
              formTypes.push("self-cert");
            }
          }
        }
      });

      // Group forms by name and print index values during grouping
      const formsByName = {};
      formsList.forEach((form, index) => {
        let formName;
        if (form.documentType && form.documentType.includes("idDocument")) {
          formName = "id documents";
        } else {
          formName = form.formType || form["Form Type"] || form.Form_number || "Unknown";
        }
        if (!formsByName[formName]) {
          formsByName[formName] = [];
        }
        formsByName[formName].push(form);
      });

      return { formsList, formTypes, formsByName };
    } catch (error) {
      console.error("Error processing forms data:", error);
      return { formsList: [], formTypes: [], formsByName: {} };
    }
  };
  function extractFormNameFromFileName(fileName) {
    if (!fileName) return "";

    // Define regex patterns for each form type
    const formPatterns = [
      /W-8BEN-E/i,
      /W-8BEN/i,
      /W-8ECI/i,
      /W-8IMY/i,
      /W-8EXP/i,
      /W-9/i,
      /SELF-CERT/i,
      /ID Documents/i,
    ];

    // Try to match each pattern
    for (const pattern of formPatterns) {
      const match = fileName.match(pattern);
      if (match) {
        return match[0]; // Return the matched form name
      }
    }

    // Return empty string if no form name found
    return "";
  }

  function extractNameFromFileName(fileName) {
    if (!fileName) return "";

    // Convert to string in case it's not already
    const fileNameStr = String(fileName);

    // Remove all form types with a simple replace
    let name = fileNameStr
      .replace(/W-8BEN-E/i, "")
      .replace(/W-8BEN/i, "")
      .replace(/W-8ECI/i, "")
      .replace(/W-8IMY/i, "")
      .replace(/W8EXP/i, "")
      .replace(/W-9/i, "")
      .replace(/SELF-CERT/i, "")
      .replace(/ID Documents/i, "");

    // Clean up remaining separators and extra spaces
    name = name
      .replace(/[-_]/g, " ") // Replace hyphens and underscores with spaces
      .replace(/\s+/g, " ") // Replace multiple spaces with a single space
      .trim(); // Remove leading and trailing spaces

    return name;
  }
  // Helper function to extract form type from filename

  // Utility function to format field names for display
  const formatFieldNameForDisplay = (fieldName) => {
    if (!fieldName) return "";

    // Replace underscores and hyphens with spaces
    return fieldName.replace(/[_-]/g, " ");
  };

  // Utility function to format uploadType values for display
  const formatUploadType = (uploadType) => {
    if (uploadType === null || uploadType === undefined) return "";

    switch (uploadType) {
      case 1:
        return "Withholding Statement";
      case 2:
        return "W-9";
      case 3:
        return "W-8BEN";
      case 4:
        return "W-8BEN-E";
      case 5:
        return "W-8IMY";
      case 6:
        return "W-8ECI";
      case 7:
        return "W-8EXP";
      case 8:
        return "8233";
      case 9:
        return "Self-Cert Individual";
      case 10:
        return "Self-Cert Entity";
      case 11:
        return "Pack With Forms";
      case 13:
        return "Deloitte Excel Import";
      default:
        return uploadType ? `Type ${uploadType}` : "";
    }
  };
  const createFormRowsFromFormsList = (mainRow) => {
    if (!mainRow || !mainRow.formsData) return [];

    const { formsByName } = processFormsDataWithFormTypes(mainRow.formsData);
    const allFormRows = [];

    // Create form rows at the same level
    Object.entries(formsByName).forEach(([formName, forms], nameIndex) => {
      forms.forEach((form, formIndex) => {
        // Determine display value for beneficial owner or business name
        let displayValue;

        if (formName === "id documents") {
          // For ID documents, format the name differently
          const idType = getIdDocumentType(form);
          let personName = "";

          if (form.FirstName && form.LastName) {
            personName = `${form.FirstName} ${form.LastName}`;
          } else if (form.LastName) {
            personName = form.LastName;
          } else if (form.FirstName) {
            personName = form.FirstName;
          } else {
            personName = `ID ${formIndex + 1}`;
          }

          displayValue = personName;
          form.displayIdType = idType; // Store ID type for display
        } else {
          // Regular forms display logic
          displayValue =
            form["Beneficial Owner name"] ||
            form["Name of organization"] ||
            form["W8-BENE-Organization_name"] ||
            form["SC-Individual-First_name"] + " " + form["SC-Individual-Last_name"] ||
            `Form ${formIndex + 1}`;
        }

        allFormRows.push({
          ...mainRow,
          // Generate unique ID with index information but no parent relationship
          fileImportId: `${mainRow.fileImportId}_form_${nameIndex}_${formIndex}`,
          formType: formName,
          fileName:
            formName === "id documents"
              ? `${getFormTypeDisplayName(formName)} -${getIdDocumentType(form)} - ${displayValue}`
              : `${getFormTypeDisplayName(formName)} - ${displayValue}`,
          isFormRow: true,
          originalIndex: form.originalIndexValue,
          formIndex: formIndex,
          formData: form,
          // No parentId property so all rows appear at same level
        });
      });
    });

    return allFormRows;
  };

  const matchFormsWithWithholdingStatements = (withholdingRow, formTypeRows) => {
    // Ensure this is a withholding statement
    if (
      !withholdingRow.fileName ||
      !withholdingRow.fileName.toLowerCase().includes("withholding")
    ) {
      return [];
    }

    // Debug: Check what data is available

    // Let's try to find accountsList - either from dataValidation or create it from formsData
    let accountsList = [];

    // Try to get accounts from dataValidation if it exists
    if (withholdingRow.dataValidation) {
      accountsList =
        typeof withholdingRow.dataValidation === "string"
          ? JSON.parse(withholdingRow.dataValidation).accountsList
          : withholdingRow.dataValidation.accountsList;
    }

    // Find matching forms in formTypeRows
    const relatedForms = formTypeRows.filter((formRow) => {
      // Extract form name or formType for matching
      const formName = extractNameFromFileName(formRow.fileName || "");

      // Check if this form matches any account in the accountsList
      const matches = accountsList.filter((account) => {
        const accountName = account.Name || "";
        if (!accountName) return false;

        // Try different matching approaches
        const nameMatch = formName.includes(accountName) || accountName.includes(formName);
        const isMatch = nameMatch;

        return isMatch;
      });

      return matches.length > 0;
    });

    relatedForms.forEach((form) => {
      // console.log("- Related form:", form.fileName);
    });

    // Return forms with updated parentId
    return relatedForms.map((form) => ({
      ...form,
      parentId: withholdingRow.fileImportId,
      isFormRow: true,
      isRelatedToWithholding: true,
    }));
  };
  useEffect(() => {
    // Only add the listener if a popup menu is open
    if (activePopupMenu !== null) {
      // Function to handle clicks outside popup
      const handleOutsideClick = (event) => {
        // Don't close if clicking inside the popup
        if (popupRef.current && popupRef.current.contains(event.target)) {
          return;
        }
        // Close popup menu if clicked outside
        setActivePopupMenu(null);
      };

      // Add event listener to the document
      document.addEventListener("mousedown", handleOutsideClick);

      // Clean up the event listener when component unmounts or popup closes
      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }
  }, [activePopupMenu]);
  const [activeFormType, setActiveFormType] = React.useState("All Forms");
  const handleDeleteWithholdingRow = async (row, formName, index) => {
    try {
      // Get the current forms data
      // Parse the formsData from the row
      const parsedData = JSON.parse(row.formsData);
      parsedData.formsData.splice(index, 1);
      const updatedFormsData = parsedData;
      row.formsData = JSON.stringify(updatedFormsData);

      // Update the data store
      const response = await fetch(`${BASE_URL}/FileData/ImportFiles`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: JSON.stringify(row),
      });

      if (!response.ok) {
        throw new Error("Failed to update data store");
      }

      // Collapse row if it's expanded and deselect if it's selected
      if (expandedRows.includes(row.fileImportId)) {
        setExpandedRows(expandedRows.filter((id) => id !== row.fileImportId));
      }

      if (selectedCheckbox === row.fileImportId) {
        setSelectedCheckbox(null);
      }

      setActiveFormType("All Forms");

      // Refresh the data
      getAllFiles();
    } catch (error) {
      console.error("Error deleting withholding row:", error);
      // Handle error appropriately
    }
  };

  const handleMoveWithholdingForm = async (sourceRow, targetRow, formType, index) => {
    try {
      // Get forms data from both rows
      const sourceForms = processFormsDataWithFormTypes(sourceRow.formsData);
      const targetForms = processFormsDataWithFormTypes(targetRow.formsData);

      // Find the form to move by index
      let formToMove = null;
      let currentFormIndex = 0;
      let formName = null;

      // Iterate through all forms to find the one at specified index
      for (const [formTypeName, formArray] of Object.entries(sourceForms.formsByName)) {
        for (const form of formArray) {
          if (currentFormIndex === index) {
            formToMove = form;
            formName = formTypeName;
            break;
          }
          currentFormIndex++;
        }
        if (formToMove) break;
      }

      if (!formToMove) {
        throw new Error("Form not found at specified index");
      }

      // Remove from source - create new array without the form at index
      let updatedSourceFormsData = [];
      currentFormIndex = 0;

      Object.values(sourceForms.formsByName).forEach((formArray) => {
        formArray.forEach((form) => {
          if (currentFormIndex !== index) {
            updatedSourceFormsData.push(form);
          }
          currentFormIndex++;
        });
      });

      // Add to target forms
      if (!targetForms.formsByName[formName]) {
        targetForms.formsByName[formName] = [];
      }
      targetForms.formsByName[formName].push(formToMove);

      // Update both rows
      sourceRow.formsData = JSON.stringify(updatedSourceFormsData);
      targetRow.formsData = JSON.stringify(Object.values(targetForms.formsByName).flat());

      // Update both rows in the data store
      await Promise.all([
        fetch(`${BASE_URL}/FileData/ImportFiles`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(sourceRow),
        }),
        fetch(`${BASE_URL}/FileData/ImportFiles`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(targetRow),
        }),
      ]);

      // Collapse source row if it's expanded and deselect if it's selected
      if (expandedRows.includes(sourceRow.fileImportId)) {
        setExpandedRows(expandedRows.filter((id) => id !== sourceRow.fileImportId));
      }

      if (selectedCheckbox === sourceRow.fileImportId) {
        setSelectedCheckbox(null);
      }

      // Set active form type back to default
      setActiveFormType("All Forms");

      // Refresh the data
      getAllFiles();
    } catch (error) {
      console.error("Error moving withholding form:", error);
      // Handle error appropriately
    }
  };
  const generateUUID = () => {
    const newUUID = uuidv4(); // Generate a new UUID
    return newUUID;
  };

  // Handle Single Form view
  const handleSingleFormView = async (row) => {
    try {
      // Parse the formsData to get extracted data
      let parsedData = null;

      if (row.formsData) {
        try {
          parsedData = JSON.parse(row.formsData);
        } catch (jsonError) {
          console.error("JSON parsing error for formsData:", jsonError);
          console.error("formsData content:", row.formsData);
          alert("Error: Invalid form data format. Please check the data and try again.");
          return;
        }
      }

      // Extract data - handle both new format (direct array) and old format (wrapped in data property)
      let extractedData = null;
      let selectedFormIndex = 0; // Track which form index we're editing
      let selectedDataIndex = 0; // Track which data index within the form
      if (parsedData) {
        // Handle complex structure: { formsData: [...], withholdingData: {...} }
        if (parsedData.formsData && Array.isArray(parsedData.formsData)) {
          // Look through all forms to find the first one with data
          for (let i = 0; i < parsedData.formsData.length; i++) {
            const formItem = parsedData.formsData[i];
            if (
              formItem &&
              formItem.data &&
              Array.isArray(formItem.data) &&
              formItem.data.length > 0
            ) {
              // Found a form with data, use the first data item
              extractedData = formItem.data[0];
              selectedFormIndex = i;
              selectedDataIndex = 0;

              break;
            }
          }
        }
        // Handle simple array format (fallback)
        else if (Array.isArray(parsedData) && parsedData.length > 0) {
          // Find first non-empty form object
          for (let i = 0; i < parsedData.length; i++) {
            if (parsedData[i] && Object.keys(parsedData[i]).length > 0) {
              extractedData = parsedData[i];
              selectedFormIndex = i;

              break;
            }
          }
        }
        // Handle old wrapped format
        else if (parsedData.data) {
          if (Array.isArray(parsedData.data) && parsedData.data.length > 0) {
            extractedData = parsedData.data[0];
          } else if (typeof parsedData.data === "object") {
            extractedData = parsedData.data;
          }
        }
      }
      const entities = await searchEntities(extractedData);

      // Determine form type from extracted data/metadata only (do not use filename)
      let formType = null;

      // Prefer extracted data
      if (extractedData) {
        // Check FormName field
        const formName =
          extractedData.FormName ||
          extractedData.formName ||
          extractedData.Form_name ||
          extractedData["Form_name"] ||
          extractedData.FormType ||
          extractedData.formType ||
          extractedData.Form_number ||
          extractedData["Form Type"]; // various sources

        if (formName) {
          const formNameLower = formName.toLowerCase();
          if (formNameLower.includes("w-8ben-e") || formNameLower.includes("w8bene")) {
            formType = "w8bene";
          } else if (formNameLower.includes("w-8ben") || formNameLower.includes("w8ben")) {
            formType = "w8ben";
          } else if (formNameLower.includes("w-8imy") || formNameLower.includes("w8imy")) {
            formType = "w8imy";
          } else if (formNameLower.includes("w-8eci") || formNameLower.includes("w8eci")) {
            formType = "w8eci";
          } else if (formNameLower.includes("w-8exp") || formNameLower.includes("w8exp")) {
            formType = "w8exp";
          } else if (formNameLower.includes("w-9") || formNameLower.includes("w9")) {
            formType = "w9";
          } else if (formNameLower.includes("8233")) {
            formType = "8233";
          } else if (
            formNameLower.includes("self-cert entity") ||
            formNameLower.includes("selfcert-ent") ||
            formNameLower.includes("self-certification for entities") ||
            formNameLower.includes("entities form")
          ) {
            formType = "selfcert-ent";
          } else if (
            formNameLower.includes("self-cert individual") ||
            formNameLower.includes("selfcert-ind") ||
            formNameLower.includes("self-certification for individuals") ||
            formNameLower.includes("individuals form")
          ) {
            formType = "selfcert-ind";
          }
        }
      }

      // Fallback to row metadata
      if (!formType && row && row.formType) {
        const v = String(row.formType).toLowerCase();
        if (v.includes("w-8ben-e") || v.includes("w8bene")) formType = "w8bene";
        else if (v.includes("w-8ben") || v.includes("w8ben")) formType = "w8ben";
        else if (v.includes("w-8imy") || v.includes("w8imy")) formType = "w8imy";
        else if (v.includes("w-8eci") || v.includes("w8eci")) formType = "w8eci";
        else if (v.includes("w-8exp") || v.includes("w8exp")) formType = "w8exp";
        else if (v.includes("w-9") || v.includes("w9")) formType = "w9";
        else if (v.includes("8233")) formType = "8233";
        else if (
          v.includes("self-cert entity") ||
          v.includes("selfcert-ent") ||
          v.includes("self-certification for entities") ||
          v.includes("entities form")
        )
          formType = "selfcert-ent";
        else if (
          v.includes("self-cert individual") ||
          v.includes("selfcert-ind") ||
          v.includes("self-certification for individuals") ||
          v.includes("individuals form")
        )
          formType = "selfcert-ind";
        else if (v.includes("self-cert")) formType = "self-cert";
      }

      // Search for matching form data from admin
      let matchingFormData = null;

      // Skip matching form API if user doesn't have Comply Admin access
      if (!hasComplyAdmin) {
        matchingFormData = {
          searchTerm: "",
          entities: [],
          matchCount: 0,
          extractedData: extractedData,
          disabled: true,
        };
        setSingleFormMatchingData(matchingFormData);
      } else {
        setIsSingleFormSearchLoading(true);

        try {
          let searchTerm = "";

          if (extractedData) {
            // Get potential search terms from form data with more comprehensive field mapping
            const businessName =
              extractedData["Name of organization"] ||
              extractedData["W8-BENE-Organization_name"] ||
              extractedData["SC-Entity-Section_1_entity_name"] ||
              "";

            const individualName = extractedData["Beneficial Owner name"] || "";

            const firstName =
              extractedData["FirstName"] ||
              extractedData["firstName"] ||
              extractedData["SC-Individual-First_name"] ||
              "";

            const lastName =
              extractedData["LastName"] ||
              extractedData["lastName"] ||
              extractedData["SC-Individual-Last_name"] ||
              "";

            // Determine the best search term with priority logic
            if (businessName.trim()) {
              searchTerm = businessName.trim();
            } else if (individualName.trim()) {
              searchTerm = individualName.trim();
            } else if (firstName.trim() || lastName.trim()) {
              searchTerm = `${firstName} ${lastName}`.trim();
            }
          }

          // Always call the API, even if no search term was found

          if (entities && entities.length > 0) {
            matchingFormData = {
              searchTerm: searchTerm || "No search term found",
              entities: entities,
              matchCount: entities.length,
              extractedData: extractedData,
            };
          } else {
            // Still create matching data object even if no entities found
            matchingFormData = {
              searchTerm: searchTerm || "No search term found",
              entities: [],
              matchCount: 0,
              extractedData: extractedData,
            };
          }
        } catch (error) {
          console.error("Error searching for matching form data:", error);
          // Create error state for matching data
          matchingFormData = {
            searchTerm: "Error occurred",
            entities: [],
            matchCount: 0,
            extractedData: extractedData,
            error: error.message,
          };
        } finally {
          setIsSingleFormSearchLoading(false);
        }

        setSingleFormMatchingData(matchingFormData);
      }

      setSingleFormData({
        row: row,
        extractedData: extractedData,
        formType: formType,
        selectedFormIndex: selectedFormIndex, // Store which form index we're editing
        selectedDataIndex: selectedDataIndex, // Store which data index within the form
        originalParsedData: parsedData, // Store the original parsed structure
      });
      setSelectedCheckbox(row.fileImportId); // Set selectedCheckbox when opening single form view
      setIsSingleFormPopupOpen(true);
    } catch (error) {
      console.error("Error parsing Single Form data:", error);
      alert("Error loading Single Form data");
    }
  };

  // Close Single Form popup
  const closeSingleFormPopup = () => {
    setIsSingleFormPopupOpen(false);
    setSingleFormData(null);
    setSingleFormMatchingData(null);
    setSingleFormViewMode("form"); // Reset view mode
    setIsSingleFormSearchLoading(false);
  };

  // Handle form save success in single form view
  const handleSingleFormSaveSuccess = (updatedRowData) => {
    // Update the rows state with the new row data
    if (updatedRowData) {
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.fileImportId === singleFormData?.row?.fileImportId ? updatedRowData : row
        )
      );

      // Update the single form data with the new data
      try {
        const parsedData = updatedRowData.formsData ? JSON.parse(updatedRowData.formsData) : null;
        let extractedData = null;
        if (parsedData) {
          if (Array.isArray(parsedData) && parsedData.length > 0) {
            // New format: formsData is directly an array of form objects
            extractedData = parsedData[0]; // Get the first form object
          } else if (parsedData.data) {
            // Old format: wrapped in data property
            if (Array.isArray(parsedData.data) && parsedData.data.length > 0) {
              extractedData = parsedData.data[0];
            } else if (typeof parsedData.data === "object") {
              extractedData = parsedData.data;
            }
          }
        }

        setSingleFormData((prevData) => ({
          ...prevData,
          row: updatedRowData,
          extractedData: extractedData,
        }));
      } catch (error) {
        console.error("Error updating single form data:", error);
      }
    }
  };

  // Get form component for single form view
  const getSingleFormComponent = (formType, extractedData, row, forceKey = 0) => {
    if (!formType || !extractedData) return null;

    const selectedIndex = 0; // For single form, always use index 0

    switch (formType.toLowerCase()) {
      case "w8imy":
        return (
          <IMYFormComplete
            key={`imy-${forceKey}`}
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      case "w8bene":
        return (
          <BENEFormComplete
            key={`bene-${forceKey}`}
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      case "w9":
        return (
          <W9Form
            key={`w9-${forceKey}`}
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      case "w8ben":
        return (
          <W8BENFORM
            key={`ben-${forceKey}`}
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      case "w8exp":
        return (
          <EXPFormComplete
            key={`exp-${forceKey}`}
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      case "w8eci":
        return (
          <ECIFormComplete
            key={`eci-${forceKey}`}
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      case "8233":
        return (
          <Form8233Complete
            key={`8233-${forceKey}`}
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      case "self-cert":
        return extractedData["SC-Entity-Section_1_entity_name"] ? (
          <SelfCertEntityForm
            key={`self-cert-entity-approval-1-${row?.fileImportId}-${selectedIndex}`}
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        ) : (
          <SelfCertificationForm
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      case "selfcert-ind":
        return (
          <SelfCertificationForm
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      case "selfcert-ent":
        return (
          <SelfCertEntityForm
            key={`self-cert-entity-approval-2-${row?.fileImportId}-${selectedIndex}`}
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
      default:
        return (
          <W8BENFORM
            selectedRowData={extractedData}
            row={row}
            selectedIndex={selectedIndex}
            onSaveSuccess={handleSingleFormSaveSuccess}
          />
        );
    }
  };

  // Entity search and matching functions for Single Form
  const searchEntities = async (extractedData = null) => {
    try {
      setIsEntitySearchLoading(true);

      // Extract additional identifiers from form data if available
      let tinValue = null;
      let giinValue = null;
      let formRevision = null;
      let signatureDate = "2013-09-20"; // Default value
      let name = null;
      let formType = null;

      if (extractedData) {
        name =
          extractedData["Beneficial Owner name"] ||
          extractedData["Name of organization"] ||
          extractedData["W8-BENE-Organization_name"] ||
          extractedData["SC_Entity-Section_1_entity_name"] ||
          extractedData["SC-Individual-First_name"] +
            " " +
            extractedData["SC-Individual-Last_name"];
        // Extract TIN from various fields
        tinValue =
          extractedData["U.S. taxpayer identification number"] ||
          extractedData["Foreign tax identifying number"] ||
          extractedData["Social security number"] ||
          extractedData["Employer identification number"] ||
          null;
        formType =
          extractedData["Form Type"] ||
          extractedData["formType"] ||
          extractedData["Form_name"] ||
          extractedData["FormType"] ||
          "";

        // Extract GIIN from various fields
        giinValue = extractedData["GIIN"] || null;

        // Extract Form revision
        formRevision =
          extractedData["Form_revision_date"] ||
          extractedData["Form_revision"] ||
          extractedData["form_revision"] ||
          extractedData["formRevision"] ||
          null;

        // Extract Signature date
        signatureDate =
          extractedData["Signature_date"] ||
          extractedData["SignatureDate"] ||
          extractedData["Date_of_signature"] ||
          "2013-09-20"; // Fallback to default
      }

      const userData = JSON.parse(localStorage.getItem("token"));
      const organizationId = userData?.organizationId;

      // Extract search term from extractedData if available
      let searchTerm = "";
      if (extractedData) {
        // Debug: Log all available fields in extractedData

        const businessName =
          extractedData["Name of organization"] ||
          extractedData["W8-BENE-Organization_name"] ||
          extractedData["SC_Entity-Section_1_entity_name"] ||
          "";

        const individualName = extractedData["Beneficial Owner name"] || "";

        const firstName =
          extractedData["FirstName"] ||
          extractedData["firstName"] ||
          extractedData["SC-Individual-First_name"] ||
          "";

        const lastName =
          extractedData["LastName"] ||
          extractedData["lastName"] ||
          extractedData["SC-Individual-Last_name"] ||
          "";

        // Determine the best search term with priority logic
        if (businessName.trim()) {
          searchTerm = businessName.trim();
        } else if (individualName.trim()) {
          searchTerm = individualName.trim();
        } else if (firstName.trim() || lastName.trim()) {
          searchTerm = `${firstName} ${lastName}`.trim();
        }
      }

      // Don't call API if all search criteria are empty/null
      if (!searchTerm && !tinValue && !giinValue) {
        setIsEntitySearchLoading(false);
        return [];
      }

      // Create request body in the correct format as expected by the API
      const requestBody = {
        UID: null,
        Name: searchTerm || null,
        Tin: tinValue || null,
        Giin: giinValue || null,
        SignatureDate: null,
        FormType: formType || null,
        Revision: formRevision ? formRevision.replace("(Rev. ", "").replace(")", "") : null,
        ShowOrphan: false,
      };

      // Don't call API if all search criteria are empty/null
      if (!searchTerm && !tinValue && !giinValue) {
        setIsEntitySearchLoading(false);
        return [];
      }
      const response = await fetch(`${BASE_URL}/Utilities/SearchForm`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        const apiResult = await response.json();

        // Only use the forms list; ignore entities
        const formsOnly = Array.isArray(apiResult)
          ? apiResult.flatMap((item) => (Array.isArray(item.forms) ? item.forms : []))
          : Array.isArray(apiResult?.forms)
            ? apiResult.forms
            : [];

        return formsOnly; // If empty => treat as no match found upstream
      } else {
        const errorText = await response.text();

        return [];
      }
    } catch (error) {
      return [];
    } finally {
      setIsEntitySearchLoading(false);
    }
  };

  // Function to handle Return button with unsaved changes warning
  const handleReturnWithUnsavedChangesCheck = () => {
    // Check if there are unsaved changes
    if (saveSum > 0 || storeUpdatingValues.length > 0) {
      const confirmExit = window.confirm(
        "You have unsaved changes that will be lost. Are you sure you want to return without saving?"
      );

      if (confirmExit) {
        // User confirmed they want to exit without saving
        setSaveSum(0);
        setIsChangesSaved(false);
        setStoreUpdatingValues([]);
        setIsDataValidationPopupOpen(false);
      }
      // If user cancels, do nothing (stay in the modal)
    } else {
      // No unsaved changes, safe to close
      setIsDataValidationPopupOpen(false);
    }
  };

  return (
    <>
      <div style={screenHeaderStyle(isMenuOpen)}>
        {/* Loading overlay during deletion */}
        {isDeleting && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              zIndex: 999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                boxShadow: "none",
              }}
            >
              <CircularProgress size={24} style={{ color: "#2aa7e0" }} />
              <span style={{ fontFamily: fontFamily, fontSize: "14px" }}>Deleting file...</span>
            </div>
          </div>
        )}

        {/* Loading overlay during send to admin */}
        <SendingAdminModal isOpen={isSendingToAdmin} fontFamily={fontFamily} />

        {!isDataValidationPopupOpen && (
          <>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                marginTop: paddingAndMargin.headerTopHeight,
                marginBottom: paddingAndMargin.headerBelowHeight,
              }}
            >
              <SearchInput
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                onClear={() => {
                  setSearchValue("");
                }}
              />

              {/* Pagination Controls */}
              {rows.filter(
                (item) =>
                  item.isProcessed === true &&
                  item.reviewedDate !== null &&
                  item.approvedDate === null &&
                  item.rejectedDate === null &&
                  item.parentId === null
              ).length > 5 && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label
                        style={{
                          fontFamily: "Poppins, sans-serif", // Add this line
                          fontWeight: 400,
                          fontSize: 12,
                        }}
                      >
                        Displayed per page:&nbsp;
                        <select
                          className="pagination-select"
                          style={{ width: 50 }}
                          value={rowsPerPage}
                          onChange={handleRowsPerPageChange}
                        >
                          {[5, 10, 15, 20, 25, 30].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                              {pageSize}
                            </option>
                          ))}
                        </select>
                      </label>
                    </div>
                  </div>
                </>
              )}

              {/* Selection count display */}
              {/* {selectedCheckboxList.length > 0 && (
          <div
            style={{
              marginLeft: 20,
              padding: "8px 16px",
              backgroundColor: "#e3f2fd",
              borderRadius: 4,
              fontSize: 14,
              fontFamily: fontFamily,
              color: "#1976d2",
              display: "flex",
              alignItems: "center",
            }}
          >
            {getSelectionCountText(selectedCheckboxList.length)}
          </div>
        )} */}

              <div style={{ display: "flex", marginLeft: "auto" }}>
                {/* Conditional button display using service */}
                {buttonVisibility.showEditForm && (
                  <Button
                    variant="contained"
                    style={reviewScreenButtonWithOutColor(130)}
                    onClick={() => {
                      const selectedRow = rows.find(
                        (row) => row.fileImportId === selectedCheckboxList[0]
                      );
                      if (selectedRow) {
                        handleSingleFormView(selectedRow);
                      }
                    }}
                  >
                    Edit Form
                  </Button>
                )}
                {buttonVisibility.showDataValidation && (
                  <Button
                    variant="contained"
                    style={reviewScreenButtonWithOutColor(210)}
                    onClick={handleRunValidation}
                  >
                    Data Validation Check
                  </Button>
                )}

                {buttonVisibility.showReject && (
                  <Button
                    variant="contained"
                    style={reviewScreenButtonWithOutColor(100)}
                    onClick={handleReject}
                  >
                    Reject
                  </Button>
                )}
                {buttonVisibility.showApprove && (
                  <Button
                    variant="contained"
                    style={reviewScreenButtonWithColor(100)}
                    onClick={handleProceed}
                  >
                    Approve
                  </Button>
                )}
                {buttonVisibility.showSendToAdmin && hasComplyAdmin && (
                  <Button
                    variant="contained"
                    style={reviewScreenButtonWithColor(160)}
                    onClick={handleSendToAdmin}
                  >
                    Send To Admin
                  </Button>
                )}
              </div>
            </div>

            {/* Table Container with fixed header and scrollable body */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 220px)",
                marginLeft: 0,
                marginRight: 0,
              }}
            >
              {/* Fixed Table Header */}
              <div class="columntitlesRowStyle" style={{ flexShrink: 0 }}>
                <div>
                  <AppCheckbox
                    header
                    onChange={handleColumnCheckboxChange}
                    checked={
                      selectedCheckboxList.length > 0 &&
                      selectedCheckboxList.length ===
                        rows
                          .filter(
                            (item) =>
                              item.isProcessed === true &&
                              item.approvedDate === null &&
                              item.rejectedDate === null &&
                              item.reviewedDate !== null &&
                              item.parentId === null
                          )
                          .slice(startIndex, endIndex).length
                    }
                    indeterminate={
                      selectedCheckboxList.length > 0 &&
                      selectedCheckboxList.length <
                        rows
                          .filter(
                            (item) =>
                              item.isProcessed === true &&
                              item.approvedDate === null &&
                              item.rejectedDate === null &&
                              item.reviewedDate !== null &&
                              item.parentId === null
                          )
                          .slice(startIndex, endIndex).length
                    }
                  />
                </div>
                {columns.map((column) => (
                  <div
                    key={column.field}
                    title={
                      column.headerName === "Compatibility Issues"
                        ? "Compatability Issues are datafields that the extractor has identified as being incorrectly formatted or missing to achieve a perfect export to Comply Admin."
                        : column.field === "confidenceLevel"
                          ? "Confidence(%) shows the accuracy of the data that has been extracted on a field by field basis."
                          : ""
                    }
                    class="columntitlesStyle"
                  >
                    <UpperLowerText text={column.headerName} />
                  </div>
                ))}
              </div>

              {/* Scrollable Table Body */}
              {loading ? (
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Loader />
                </div>
              ) : rows.length === 0 ? (
                <div className="no-record">There are no records available.</div>
              ) : (
                <div
                  ref={scrollContainerRef}
                  style={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  {rows
                    .filter(
                      (item) =>
                        item.isProcessed === true &&
                        item.approvedDate === null &&
                        item.rejectedDate === null &&
                        item.reviewedDate !== null &&
                        item.parentId === null
                    )
                    .slice(startIndex, endIndex)
                    .map((row, indexValue) => {
                      const notMatchingCount =
                        notMatchingFields.find((item) => item.fileImportId === row.fileImportId)
                          ?.count || 0;
                      const mandatoryCount =
                        mandatoryFields.find((item) => item.fileImportId === row.fileImportId)
                          ?.count || 0;
                      const formTypes = [
                        "W-8IMY",
                        "W-8BEN-E",
                        "W-8BEN",
                        "W-9",
                        "W-8ECI",
                        "W-8EXP",
                        "ID Documents",
                        "Other",
                      ];

                      // Check if row has children
                      const hasChildren = rows.some(
                        (childRow) => childRow.parentId === row.fileImportId
                      );

                      // Check if this row is a parent (not a child of another row)
                      const isParent = !row.parentId;

                      // Get existing child rows if expanded
                      const existingChildRows = expandedRows.includes(row.fileImportId)
                        ? rows
                            .filter((childRow) => childRow.parentId === row.fileImportId)
                            .filter(
                              (item) =>
                                item.isProcessed === true &&
                                item.approvedDate === null &&
                                item.rejectedDate === null &&
                                item.reviewedDate !== null
                            )
                        : [];

                      // Get form child rows if expanded
                      const formChildRows = expandedRows.includes(row.fileImportId)
                        ? createFormRowsFromFormsList(row)
                        : [];

                      // Get form type nested rows - only those that are direct children of the parent
                      const formTypeRows = formChildRows.filter(
                        (row) => row.isFormParentRow || !row.isFormInstanceRow
                      );
                      const expandedFormTypeRows = {};

                      // Find withholding statement rows within the initial child rows
                      const withholdingRows = existingChildRows.filter(
                        (childRow) =>
                          childRow.fileName &&
                          childRow.fileName.toLowerCase().includes("withholding")
                      );

                      // Create a map to track which withholding statements have related forms
                      const withholdingHasRelatedForms = {};

                      // Get forms related to each withholding statement row
                      const withholdingRelatedForms = [];
                      if (expandedRows.includes(row.fileImportId)) {
                        withholdingRows.forEach((withholdingRow) => {
                          // Pass formTypeRows as the second argument
                          const relatedForms = matchFormsWithWithholdingStatements(
                            withholdingRow,
                            formTypeRows
                          );

                          // Record if this withholding statement has related forms
                          withholdingHasRelatedForms[withholdingRow.fileImportId] =
                            relatedForms.length > 0;

                          withholdingRelatedForms.push(...relatedForms);
                        });
                      }

                      // Get the fileImportIds of all related forms to exclude them from allChildRows
                      const relatedFormIds = withholdingRelatedForms.map(
                        (form) => form.fileImportId
                      );

                      // Use all form type rows without filtering
                      const filteredFormTypeRows = formTypeRows;
                      const isRowSelected = selectedCheckboxList.includes(row.fileImportId);

                      return (
                        <React.Fragment key={row.fileImportId}>
                          {/* Parent row */}
                          <div
                            className="columnRowStyle"
                            style={{
                              backgroundColor: isRowSelected
                                ? "rgba(110, 115, 248, 0.15)"
                                : "transparent",
                            }}
                          >
                            {/* Parent row content */}
                            <div>
                              <AppCheckbox
                                onClick={() => handleCheckboxClick(row.fileImportId)}
                                checked={isRowSelected}
                              />
                            </div>
                            {columns.map((column) => (
                              <div
                                key={column.field}
                                title={
                                  column.headerName === "UPLOADED DATE"
                                    ? formatDate(row[column.field])
                                    : column.headerName === "UPLOAD TYPE"
                                      ? formatUploadType(row[column.field])
                                      : row[column.field]
                                }
                                className="columnValuesStyle"
                              >
                                {column.headerName === "ACCURACY CHECK(%)" ? (
                                  <span className="valuesBackground">
                                    {" "}
                                    {row.accuracyPercentage}
                                  </span>
                                ) : column.field === "fileName" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <span
                                      style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        fontWeight: 400,
                                        color: "#101828",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {row[column.field]}
                                    </span>
                                    {isParent &&
                                      (hasChildren || row.formsData) &&
                                      row.uploadType === 11 && (
                                        <span
                                          onClick={() => {
                                            setSelectedCheckbox(row.fileImportId);
                                            if (expandedRows.includes(row.fileImportId)) {
                                              setExpandedRows([]); // Clear all expanded rows
                                            } else {
                                              setExpandedRows([row.fileImportId]); // Set only this row as expanded
                                            }
                                          }}
                                          className="arrowStyle"
                                        >
                                          {expandedRows.includes(row.fileImportId) ? (
                                            <span className="rotated">⌵</span>
                                          ) : (
                                            "⌵"
                                          )}
                                        </span>
                                      )}
                                  </div>
                                ) : column.headerName === "Confidence(%)" ? (
                                  <span
                                    className="valuesBackground"
                                    style={{
                                      width: 40,
                                      display: "flex",
                                      justifyContent: "center",
                                      marginLeft: 21,
                                    }}
                                  >
                                    {" "}
                                    {row[column.field]}%
                                  </span>
                                ) : column.field === "functions" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <div style={{ marginRight: "auto" }} />
                                    {/* {(row.uploadType === 1 || row.uploadType === 11) && (
                                      <img
                                        src={noteIcon}
                                        alt="Add Note"
                                        title="Add Note"
                                        onClick={() => {
                                          setSelectedCheckbox(row.fileImportId);
                                          setSelectedCheckboxList([row.fileImportId]);
                                          setShowNoteWindow(true);
                                          setIsAddNotePopupOpen(true);
                                          setValidationErrors({ type: "", reason: "", note: "" });
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: 10,
                                          width: 18,
                                          height: 18,
                                        }}
                                      />
                                    )} */}
                                    <div title="View">
                                      <img
                                        src={eyeIcon}
                                        alt="View"
                                        title="View"
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: 10,
                                          width: "20px",
                                          height: "20px",
                                        }}
                                        onClick={() => {
                                          if (row.uploadType >= 2 && row.uploadType <= 10) {
                                            // Handle Single Form entity matching
                                            setSelectedRow(row);
                                            handleSingleFormView(row);
                                          } else {
                                            setSelectedRow(row);
                                            handleReviewClick(row.fileImportId, row);
                                          }
                                        }}
                                      />
                                    </div>
                                    <DeleteButton
                                      onClick={() => {
                                        setIsPopupOpen(true);
                                        setSelectDeletedItem(row.fileImportId);
                                      }}
                                    />
                                  </div>
                                ) : column.headerName === "STATUS" && row.status === 1 ? (
                                  "Under Review"
                                ) : column.headerName === "REVIEWED DATE" ? (
                                  formatDate(row[column.field])
                                ) : column.headerName === "UPLOAD TYPE" ? (
                                  formatUploadType(row[column.field])
                                ) : column.headerName === "Compatibility" ? (
                                  <span
                                    title={`Not Matching Fields: ${notMatchingCount} | Mandatory Fields: ${mandatoryCount}`}
                                    style={{ color: InstaColors.primary }}
                                  >
                                    {notMatchingCount > 0 || mandatoryCount > 0 ? (
                                      <span className="errorsBackground">
                                        Errors {`${notMatchingCount + mandatoryCount}`}
                                      </span>
                                    ) : (
                                      <span className="noErrorsBackground">No Errors</span>
                                    )}
                                  </span>
                                ) : column.headerName === "Forms" && row[column.field] ? (
                                  <span
                                    className="valuesBackground"
                                    style={{ width: 40, display: "flex", justifyContent: "center" }}
                                  >
                                    {row[column.field] || ""}
                                  </span>
                                ) : (column.headerName === "Pages" && row[column.field]) ||
                                  (column.headerName === "Pages" && row[column.field] === 0) ? (
                                  <span
                                    className="valuesBackground"
                                    style={{ width: 40, display: "flex", justifyContent: "center" }}
                                  >
                                    {row[column.field] ?? ""}
                                  </span>
                                ) : column.headerName === "Forms" && row[column.field] === 0 ? (
                                  <span
                                    className="valuesBackground"
                                    style={{ width: 40, display: "flex", justifyContent: "center" }}
                                  >
                                    {"0"}
                                  </span>
                                ) : (
                                  row[column.field]
                                )}
                              </div>
                            ))}
                          </div>

                          {/* Form Type Navigation Buttons */}
                          {expandedRows.includes(row.fileImportId) && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexWrap: "nowrap",

                                paddingLeft: 20,
                                paddingRight: 20,
                                paddingTop: 30,
                                paddingBottom: 20,
                                backgroundColor: "#E9F5FE",

                                // backgroundColor: "white",
                                // borderBottom: "1px solid #E5E7EB",
                                gap: "6px",
                                overflowX: "auto",
                              }}
                            >
                              {/* Tabs - left side */}
                              <div
                                style={{ display: "flex", flexWrap: "wrap", flex: 1, gap: "4px" }}
                              >
                                {/* All Forms button */}
                                <button
                                  onClick={() => setActiveFormType("All Forms")}
                                  className={
                                    activeFormType === "All Forms"
                                      ? "formTypeButton"
                                      : "formTypeButtonDisable"
                                  }
                                >
                                  All Forms
                                  <span
                                    style={{
                                      backgroundColor:
                                        activeFormType === "All Forms"
                                          ? "rgba(255,255,255,0.25)"
                                          : "#F3F4F6",
                                      color: activeFormType === "All Forms" ? "white" : "#6B7280",
                                      borderRadius: "50%",
                                      minWidth: "20px",
                                      height: "20px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "11px",
                                      padding: "0 4px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {filteredFormTypeRows.length}
                                  </span>
                                </button>

                                {/* Withholding Statement buttons */}
                                {withholdingRows.reverse().map((withholding) => (
                                  <button
                                    key={withholding.fileImportId}
                                    onClick={() => setActiveFormType(withholding.fileImportId)}
                                    className={
                                      activeFormType === withholding.fileImportId
                                        ? "formTypeButton"
                                        : "formTypeButtonDisable"
                                    }
                                  >
                                    {withholding.fileName.substring(0, 13)}
                                    <span
                                      style={{
                                        backgroundColor:
                                          activeFormType === withholding.fileImportId
                                            ? "rgba(255,255,255,0.25)"
                                            : "#F3F4F6",
                                        color:
                                          activeFormType === withholding.fileImportId
                                            ? "white"
                                            : "#6B7280",
                                        borderRadius: "50%",
                                        minWidth: "20px",
                                        height: "20px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "11px",
                                        padding: "0 4px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {
                                        withholdingRelatedForms.filter(
                                          (f) => f.parentId === withholding.fileImportId
                                        ).length
                                      }
                                    </span>
                                  </button>
                                ))}

                                {/* Form Type buttons - only show if there are form types that match */}
                                {formTypes.map((formType) => {
                                  const matchingForms = filteredFormTypeRows.filter(
                                    (form) =>
                                      form.fileName &&
                                      extractFormNameFromFileName(form.fileName) === formType
                                  );

                                  if (matchingForms.length > 0) {
                                    return (
                                      <button
                                        key={formType}
                                        onClick={() => setActiveFormType(formType)}
                                        className={
                                          activeFormType === formType
                                            ? "formTypeButton"
                                            : "formTypeButtonDisable"
                                        }
                                      >
                                        {formType}
                                        <span
                                          style={{
                                            backgroundColor:
                                              activeFormType === formType
                                                ? "rgba(255,255,255,0.25)"
                                                : "#F3F4F6",
                                            color:
                                              activeFormType === formType ? "white" : "#6B7280",
                                            borderRadius: "50%",
                                            minWidth: "20px",
                                            height: "20px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "11px",
                                            padding: "0 4px",
                                            fontWeight: 600,
                                          }}
                                        >
                                          {matchingForms.length}
                                        </span>
                                      </button>
                                    );
                                  }
                                  return null;
                                })}
                              </div>

                              {/* Right side: Add Form */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  flexShrink: 0,
                                }}
                              >
                                {/* Add Form Dropdown */}
                                <div style={{ position: "relative", height: 32 }}>
                                  <select
                                    id={`add-form-dropdown-${row.fileImportId}`}
                                    style={{
                                      borderRadius: 6.07,
                                      border: "1px solid #2aa7e0",
                                      background: "#fff",
                                      color: "#2aa7e0",
                                      fontWeight: 500,
                                      fontSize: 13,
                                      padding: "0 28px 0 10px",
                                      cursor: "pointer",
                                      appearance: "none",
                                      WebkitAppearance: "none",
                                      MozAppearance: "none",
                                      outline: "none",
                                      height: 32,
                                      boxSizing: "border-box",
                                    }}
                                    defaultValue=""
                                    onChange={async (e) => {
                                      const selectedType = e.target.value;
                                      if (!selectedType) return;
                                      // Open file input
                                      const input = document.createElement("input");
                                      input.type = "file";
                                      input.accept = "application/pdf";
                                      input.click();
                                      // // Reset dropdown
                                      e.target.value = "";
                                      input.onchange = async (event) => {
                                        setLoading(true);
                                        const file = event.target.files[0];
                                        if (!file) return;
                                        // Generate filename: <type>-<todate>-<date and time>.pdf
                                        const now = new Date();
                                        const fileId = generateUUID();
                                        const pad = (n) => n.toString().padStart(2, "0");
                                        const dateStr = `${now.getFullYear()}${pad(
                                          now.getMonth() + 1
                                        )}${pad(now.getDate())}`;
                                        const timeStr = `${pad(now.getHours())}${pad(
                                          now.getMinutes()
                                        )}${pad(now.getSeconds())}`;
                                        const filename = `${selectedType.replace(
                                          /\s+/g,
                                          "_"
                                        )}-${dateStr}-${timeStr}.pdf`;

                                        // 1. Upload file to /uploadFile
                                        const uploadFormData = new FormData();
                                        uploadFormData.append("file", file);
                                        uploadFormData.append(
                                          "filename",
                                          `${selectedType.replace(/\s+/g, "_")}-${dateStr}-${timeStr}`
                                        );
                                        uploadFormData.append(
                                          "organization_id",
                                          row.organizationId
                                        );
                                        uploadFormData.append("user_id", row.userID);
                                        uploadFormData.append(
                                          "business_unit",
                                          row.businessUnit || "Demo"
                                        );
                                        try {
                                          const uploadResp = await fetch(
                                            `${pythonBaseUrl}/File/UploadFile`,
                                            {
                                              method: "POST",
                                              body: uploadFormData,
                                              headers: {
                                                Authorization: `Bearer ${
                                                  getUserIdFromLocalStorage().token
                                                }`,
                                              },
                                            }
                                          );
                                          if (!uploadResp.ok) {
                                            setLoading(false);
                                            alert("Failed to upload file.");
                                            return;
                                          }
                                        } catch (err) {
                                          setLoading(false);
                                          alert("Error uploading file.");
                                          return;
                                        }

                                        // 2. Upload Extraction
                                        const extractionFormData = new FormData();
                                        // extractionFormData.append('file', file, filename);
                                        extractionFormData.append(
                                          "filepath",
                                          "S:/comply_e_form_api-master/WHS/" + filename
                                        );
                                        const formattedType =
                                          selectedType === "Self-Cert Individual" ||
                                          selectedType === "Self-Cert Entity"
                                            ? "SELF-CERT"
                                            : selectedType.replace(/-/g, "").toLowerCase();
                                        extractionFormData.append("doc_type", formattedType);
                                        extractionFormData.append("request_id", fileId);
                                        extractionFormData.append("correlation_id", fileId);
                                        extractionFormData.append(
                                          "organization_id",
                                          row.organizationId
                                        );
                                        extractionFormData.append("user_id", row.userID);
                                        extractionFormData.append(
                                          "business_unit",
                                          row.businessUnit || "Demo"
                                        );

                                        let extractionResponse;
                                        try {
                                          extractionResponse = await fetch(
                                            `${pythonBaseUrl}/Extract/UploadExtraction`,
                                            {
                                              method: "POST",
                                              body: extractionFormData,
                                              headers: {
                                                Authorization: `Bearer ${
                                                  getUserIdFromLocalStorage().token
                                                }`,
                                              },
                                            }
                                          );
                                        } catch (err) {
                                          setLoading(false);
                                          alert("Error uploading form for extraction.");
                                          return;
                                        }
                                        if (!extractionResponse.ok) {
                                          setLoading(false);
                                          alert("Failed to upload form for extraction.");
                                          return;
                                        }

                                        // 3. Poll Extraction Status
                                        let extractionStatus = null;
                                        let statusData = null;
                                        let retryCount = 0;
                                        const maxRetries = 1;

                                        const pollStatus = async () => {
                                          const statusFormData = new FormData();
                                          statusFormData.append("request_id", fileId);
                                          statusFormData.append("filename", row.fileImportId);
                                          statusFormData.append(
                                            "filepath",
                                            "https://eformapi.complytaxforms.com/WHS/" + filename
                                          );
                                          statusFormData.append("doc_type", formattedType);
                                          statusFormData.append("correlation_id", fileId);
                                          statusFormData.append(
                                            "organization_id",
                                            row.organizationId
                                          );
                                          statusFormData.append("user_id", row.userID);
                                          statusFormData.append(
                                            "business_unit",
                                            row.businessUnit || "Demo"
                                          );

                                          try {
                                            const statusResp = await fetch(
                                              `${pythonBaseUrl}/Extract/ExtractionStatus`,
                                              {
                                                method: "POST",
                                                body: statusFormData,
                                                headers: {
                                                  Authorization: `Bearer ${
                                                    getUserIdFromLocalStorage().token
                                                  }`,
                                                },
                                              }
                                            );

                                            if (!statusResp.ok) {
                                              setLoading(false);
                                              throw new Error("Status check failed");
                                            }

                                            const statusJson = await statusResp.json();
                                            if (statusJson.status === "success") {
                                              extractionStatus = "success";
                                              statusData = statusJson;

                                              return true;
                                            }
                                            return false;
                                          } catch (error) {
                                            setLoading(false);
                                            console.error("Error checking status:", error);
                                            return false;
                                          }
                                        };

                                        // Try up to 30 times with 3 second intervals
                                        for (let i = 0; i < 30; i++) {
                                          const success = await pollStatus();
                                          if (success) {
                                            break;
                                          }

                                          if (i === 29) {
                                            // Last attempt failed
                                            if (retryCount < maxRetries) {
                                              retryCount++;
                                              alert(
                                                "Extraction status check failed. Retrying one more time..."
                                              );
                                              i = -1; // Reset counter for retry
                                              continue;
                                            } else {
                                              setLoading(false);
                                              alert(
                                                "Extraction failed after retry. Please try again later."
                                              );
                                              return;
                                            }
                                          }

                                          await new Promise((res) => setTimeout(res, 3000));
                                        }

                                        if (extractionStatus !== "success") {
                                          setLoading(false);
                                          alert("Extraction failed or timed out.");
                                          return;
                                        }

                                        // 4. Import Excel
                                        const excelFormData = new FormData();
                                        excelFormData.append("filename", row.fileImportId);
                                        excelFormData.append("request_id", row.fileImportId);
                                        excelFormData.append("organization_id", row.organizationId);
                                        excelFormData.append("user_id", row.userID);
                                        excelFormData.append(
                                          "business_unit",
                                          row.businessUnit || "Demo"
                                        );
                                        excelFormData.append("original_filename", row.fileName);

                                        const excelResp = await fetch(
                                          `${pythonBaseUrl}/Excel/Import-Excel-File`,
                                          {
                                            method: "POST",
                                            body: excelFormData,
                                            headers: {
                                              Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
                                            },
                                          }
                                        );
                                        if (!excelResp.ok) {
                                          setLoading(false);
                                          alert("Import Excel failed.");
                                          return;
                                        }
                                        const excelData = await excelResp.json();
                                        setLoading(false);
                                        // 5. Update selected row data and save back

                                        const existingFormDataList = row.formsData
                                          ? JSON.parse(row.formsData)
                                          : { formsData: [] };
                                        if (statusData && statusData.data) {
                                          // Append new form data to existing formsData array
                                          const existingData = existingFormDataList.formsData || [];
                                          existingData.push(statusData);
                                          existingFormDataList.formsData = existingData;
                                          // existingFormDataList.formsData = [
                                          //     ...(existingFormDataList.formsData || []),
                                          //     ...(Array.isArray(statusData.data) ? statusData.data : [statusData.data])
                                          // ];
                                        }
                                        const totalFieldsWithValues = countFieldsWithValues(
                                          excelData.extractedValidationData
                                        );
                                        const updatedRow = {
                                          ...row,
                                          dataExtraction: JSON.stringify(excelData.tableData),
                                          dataValidation: JSON.stringify(
                                            excelData.extractedValidationData
                                          ),
                                          dataVisualisation: JSON.stringify(excelData.treeData),
                                          numberOfFields: totalFieldsWithValues,
                                          formsData: JSON.stringify(existingFormDataList),
                                        };
                                        await fetch(`${BASE_URL}/FileData/ImportFiles`, {
                                          method: "PUT",
                                          headers: {
                                            "Content-Type": "application/json",
                                            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
                                          },
                                          body: JSON.stringify(updatedRow),
                                        });

                                        alert("Form uploaded and processed successfully!");
                                        getAllFiles();
                                      };
                                    }}
                                  >
                                    <option value="" hidden>
                                      + Add Form
                                    </option>
                                    <option value="W-8IMY">W-8IMY</option>
                                    <option value="W-8BEN-E">W-8BEN-E</option>
                                    <option value="W-8BEN">W-8BEN</option>
                                    <option value="W-9">W-9</option>
                                    <option value="W-8ECI">W-8ECI</option>
                                    <option value="W-8EXP">W-8EXP</option>
                                    <option value="Self-Cert Individual">
                                      Self-Cert Individual
                                    </option>
                                    <option value="Self-Cert Entity">Self-Cert Entity</option>
                                  </select>
                                  {/* Use the same dropdown icon as the other buttons */}
                                  <span
                                    className="rotated"
                                    style={{
                                      position: "absolute",
                                      right: 8,
                                      bottom: 4,
                                      paddingBottom: "8px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      pointerEvents: "none",
                                      color: "#2aa7e0",
                                      fontSize: 18,

                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {" "}
                                    ⌵{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Content area based on active form type */}
                          {expandedRows.includes(row.fileImportId) && (
                            <div style={{ padding: "0 0 0px 0" }}>
                              {/* For "All Forms" - show all form types horizontally */}
                              {activeFormType === "All Forms" && (
                                <>
                                  {/* Horizontal Form Cards Display */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      padding: "0px 10px 10px 15px",
                                      // margin: "0px 40px 0px 40px",
                                      backgroundColor: "#E9F5FE",
                                    }}
                                  >
                                    {filteredFormTypeRows.map((form) => (
                                      <div
                                        key={form.fileImportId}
                                        style={{
                                          margin: "5px",
                                          padding: "6px",
                                          backgroundColor: "white",
                                          border: "1px solid #E5E7EB",
                                          borderRadius: "10px",
                                          display: "flex",
                                          width: "300px",
                                          alignItems: "center",
                                          minHeight: "44px",
                                          position: "relative",
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                          // Don't trigger if clicking on the menu button
                                          if (e.target.closest(".menu-button")) {
                                            return;
                                          }

                                          // Trigger the same action as the View option
                                          const newData = processFormsData(row.formsData) || [];
                                          setSelectedIndex(form.originalIndex);
                                          setSelectedRowId(null);
                                          setAddNewRowsList([]);
                                          setStoreUpdatingValues([]);
                                          setSaveSum(0);

                                          // Set up dataValidation state - this was missing!
                                          setSelectedCheckbox(row.fileImportId);
                                          setDataValidation(JSON.parse(row.dataValidation));
                                          setExtractedValidateData(
                                            JSON.parse(row.dataValidation).businessUnitList
                                          );

                                          setIsDataValidationPopupOpen(true);
                                          setRunValidation(true);
                                          handleSelectSheetProcess("View Forms");
                                          setSelectSheet("View Forms");
                                          setActivePopupMenu(null);
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%",
                                          }}
                                        >
                                          <div
                                            title={form.fileName.replace(/ID Documents -/i, "")}
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              flex: 1,
                                              minWidth: 0,
                                              marginRight: "15px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontWeight: "500",
                                                color: "#2aa7e0",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              }}
                                            >
                                              {form.fileName
                                                .replace(/ID Documents -/i, "")
                                                .replace(
                                                  /^(W-8BEN-E|W-8BEN|W-8ECI|W-8IMY|W-8EXP|W-9|8233|SELF-CERT)\s*[-\u2013]\s*/i,
                                                  ""
                                                )
                                                .trim()}
                                              {form.isFormParentRow &&
                                                form.formCount > 1 &&
                                                ` (${form.formCount})`}
                                            </div>
                                            {extractFormNameFromFileName(form.fileName) && (
                                              <div
                                                style={{
                                                  fontSize: "11px",
                                                  color: "#9CA3AF",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                }}
                                              >
                                                {extractFormNameFromFileName(form.fileName)}
                                              </div>
                                            )}
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              gap: "6px",
                                              padding: "0px 6px 1px 6px",
                                              borderRadius: "3px",
                                              fontSize: "12px",
                                              backgroundColor:
                                                form.errorCount > 0
                                                  ? "rgba(255, 0, 0, 0.1)"
                                                  : "rgba(0, 255, 0, 0.1)",
                                              color: form.errorCount > 0 ? "#ff0000" : "#00aa00",
                                            }}
                                          >
                                            <span
                                              style={{
                                                width: "6px",
                                                height: "6px",
                                                borderRadius: "50%",
                                                backgroundColor:
                                                  form.errorCount > 0 ? "#ff0000" : "#00aa00",
                                                display: "inline-block",
                                              }}
                                            ></span>
                                            {form.errorCount > 0
                                              ? `${form.errorCount} Errors`
                                              : "No Errors"}
                                          </div>

                                          <div
                                            className="menu-button"
                                            style={{
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: "24px",
                                              height: "24px",
                                              backgroundColor: "#E9F5FE",
                                              borderRadius: "3px",
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setPopupMenuPosition({
                                                x: e.clientX,
                                                y: e.clientY,
                                              });
                                              setActivePopupMenu(form.fileImportId);
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "20px",
                                                fontWeight: "bold",
                                                color: "#2aa7e0",
                                              }}
                                            >
                                              ⋮
                                            </span>
                                          </div>
                                          {activePopupMenu === form.fileImportId && (
                                            <div
                                              ref={popupRef}
                                              style={{
                                                position: "absolute",
                                                top: "30px",
                                                right: "10px",
                                                backgroundColor: "#E9F5FE",
                                                boxShadow: "none",
                                                borderRadius: "4px",
                                                zIndex: 1000,
                                                width: "70px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  padding: "6px 10px",
                                                  cursor: "pointer",
                                                  color: "#2aa7e0",
                                                  textAlign: "left",
                                                  fontSize: 12,
                                                }}
                                                onClick={(e) => {
                                                  const newData =
                                                    processFormsData(row.formsData) || [];
                                                  // if (newData.length > 0) {
                                                  //     W8BENApiHandler({
                                                  //         formData: newData[form.originalIndex],
                                                  //         formType: form.fileName
                                                  //     });
                                                  // }
                                                  setSelectedIndex(form.originalIndex);
                                                  setSelectedRowId(null);
                                                  setAddNewRowsList([]);
                                                  setStoreUpdatingValues([]);
                                                  setSaveSum(0);

                                                  // Set up dataValidation state - this was missing!
                                                  setSelectedCheckbox(row.fileImportId);
                                                  setDataValidation(JSON.parse(row.dataValidation));
                                                  setExtractedValidateData(
                                                    JSON.parse(row.dataValidation).businessUnitList
                                                  );

                                                  setIsDataValidationPopupOpen(true);
                                                  setRunValidation(true);
                                                  handleSelectSheetProcess("View Forms");
                                                  setSelectSheet("View Forms");
                                                  setActivePopupMenu(null);
                                                }}
                                              >
                                                View
                                              </div>
                                              {withholdingRows.length > 0 && (
                                                <div
                                                  style={{
                                                    padding: "10px 15px",
                                                    cursor: "pointer",
                                                    color: "#2aa7e0",
                                                    textAlign: "center",
                                                    // borderTop: '1px solid #eee',
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    const moveMenu =
                                                      e.currentTarget.querySelector(
                                                        ".move-dropdown-content"
                                                      );
                                                    if (moveMenu) {
                                                      moveMenu.style.display = "block";
                                                    }
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    const moveMenu =
                                                      e.currentTarget.querySelector(
                                                        ".move-dropdown-content"
                                                      );
                                                    if (moveMenu) {
                                                      moveMenu.style.display = "none";
                                                    }
                                                  }}
                                                >
                                                  Move
                                                  <div
                                                    className="move-dropdown-content"
                                                    style={{
                                                      display: "none",
                                                      position: "absolute",
                                                      left: "100%",
                                                      top: 0,
                                                      backgroundColor: "white",
                                                      boxShadow: "none",
                                                      borderRadius: "4px",
                                                      zIndex: 1001,
                                                      minWidth: "150px",
                                                    }}
                                                  >
                                                    {withholdingRows
                                                      .filter(
                                                        (targetRow) =>
                                                          targetRow.fileImportId !== form.parentId
                                                      )
                                                      .map((targetRow) => (
                                                        <div
                                                          key={targetRow.fileImportId}
                                                          style={{
                                                            padding: "10px 15px",
                                                            cursor: "pointer",
                                                            color: "#2aa7e0",
                                                            textAlign: "center",
                                                            borderBottom: "1px solid #eee",
                                                          }}
                                                          onClick={() => {
                                                            handleMoveWithholdingForm(
                                                              row,
                                                              targetRow,
                                                              form.formType
                                                            );
                                                            setActivePopupMenu(null);
                                                          }}
                                                        >
                                                          {targetRow.fileName.substring(0, 13)}
                                                        </div>
                                                      ))}
                                                  </div>
                                                </div>
                                              )}
                                              <div
                                                style={{
                                                  padding: "6px 10px",
                                                  cursor: "pointer",
                                                  color: "#ff4d4f",
                                                  textAlign: "left",
                                                  fontSize: 12,
                                                }}
                                                onClick={() => {
                                                  // Handle delete action
                                                  handleDeleteWithholdingRow(
                                                    row,
                                                    form.fileName,
                                                    form.originalIndex
                                                  );
                                                  setActivePopupMenu(null);
                                                }}
                                              >
                                                Delete
                                              </div>
                                            </div>
                                          )}
                                        </div>

                                        {/* Show error status similar to the image */}
                                      </div>
                                    ))}
                                  </div>
                                </>
                              )}

                              {/* For specific withholding statement -show withoholding statement then show only related forms */}
                              {withholdingRows.some((w) => w.fileImportId === activeFormType) && (
                                <>
                                  {/* First show the selected withholding statement */}
                                  {withholdingRows
                                    .filter((w) => w.fileImportId === activeFormType)
                                    .map((withholding) => (
                                      <div
                                        key={withholding.fileImportId}
                                        className="columnRowStyle"
                                        style={{
                                          backgroundColor: "rgba(210, 245, 188, 0.1)",
                                        }}
                                      >
                                        {/* <span
                                                                title={`Not Matching Fields: ${notMatchingCount} | Mandatory Fields: ${mandatoryCount}`}
                                                                style={{ color: InstaColors.primary }}
                                                            >
                                                                {(notMatchingCount > 0 || mandatoryCount > 0) ? <span className="errorsBackground">Errors {`${notMatchingCount + mandatoryCount}`}</span> : <span className="noErrorsBackground">No Errors</span>}
                                                            </span> */}

                                        <AppCheckbox
                                          onClick={() => {
                                            if (selectedCheckbox === withholding.fileImportId) {
                                              setSelectedCheckbox(null);
                                            } else {
                                              setSaveSum(0);
                                              setSelectedCheckbox(withholding.fileImportId);
                                              setRunValidation(false);
                                              setEmailedDate(null);
                                            }
                                          }}
                                          checked={selectedCheckbox === withholding.fileImportId}
                                        />
                                        <div style={{ flex: 1, paddingLeft: "10px" }}>
                                          <span
                                            style={{
                                              fontWeight: "normal",
                                              color: "#2aa7e0",
                                            }}
                                          >
                                            {withholding.fileName}
                                          </span>
                                        </div>
                                        {/* Error status indicator */}

                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-end",
                                          }}
                                        >
                                          <div style={{ marginRight: "auto" }}></div>
                                          <EditButton
                                            onClick={() => {
                                              setSelectedRow(withholding);
                                              handleReviewClick(
                                                withholding.fileImportId,
                                                withholding
                                              );
                                            }}
                                          />
                                          <DeleteButton
                                            onClick={() => {
                                              setIsPopupOpen(true);
                                              setSelectDeletedItem(withholding.fileImportId);
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ))}

                                  {/* Then show all related forms */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      padding: "5px 10px 5px 15px",
                                      // margin: "0px 40px 0px 40px",
                                      backgroundColor: "#E9F5FE",
                                      borderLeft: "2px solid rgba(42, 167, 224, 0.3)",
                                    }}
                                  >
                                    {withholdingRelatedForms
                                      .filter((form) => form.parentId === activeFormType)
                                      .map((relatedForm) => (
                                        <div
                                          key={relatedForm.fileImportId}
                                          style={{
                                            margin: "10px 5px 10px 5px",
                                            padding: "10px 10px 10px 10px",
                                            backgroundColor: "white",
                                            border: "1px solid #E5E7EB",
                                            borderRadius: "10px",
                                            display: "flex",
                                            width: "300px",
                                            alignItems: "center",
                                            minHeight: "44px",
                                            position: "relative",
                                            cursor: "pointer",
                                          }}
                                          onClick={(e) => {
                                            // Don't trigger if clicking on the menu button
                                            if (e.target.closest(".menu-button")) {
                                              return;
                                            }

                                            // Trigger the same action as the View option
                                            const newData = processFormsData(row.formsData) || [];
                                            if (newData.length > 0) {
                                              // W8BENApiHandler({
                                              //     formData: newData[relatedForm.fileImportId.split('_').pop()],
                                              //     formType: relatedForm.fileName
                                              // });
                                            }
                                            setSelectedIndex(relatedForm.originalIndex);
                                            setSelectedRowId(null);
                                            setAddNewRowsList([]);
                                            setStoreUpdatingValues([]);
                                            setSaveSum(0);

                                            // Set up dataValidation state - this was missing!
                                            setSelectedCheckbox(row.fileImportId);
                                            setDataValidation(JSON.parse(row.dataValidation));
                                            setExtractedValidateData(
                                              JSON.parse(row.dataValidation).businessUnitList
                                            );

                                            setIsDataValidationPopupOpen(true);
                                            setRunValidation(true);
                                            handleSelectSheetProcess("View Forms");
                                            setSelectSheet("View Forms");
                                            setActivePopupMenu(null);
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <div
                                              title={relatedForm.fileName}
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                flex: 1,
                                                minWidth: 0,
                                                marginRight: "15px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  fontWeight: "500",
                                                  color: "#2aa7e0",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                }}
                                              >
                                                {relatedForm.fileName
                                                  .replace(
                                                    /^(W-8BEN-E|W-8BEN|W-8ECI|W-8IMY|W-8EXP|W-9|8233|SELF-CERT)\s*[-\u2013]\s*/i,
                                                    ""
                                                  )
                                                  .trim()}
                                                {relatedForm.isFormParentRow &&
                                                  relatedForm.formCount > 1 &&
                                                  ` (${relatedForm.formCount})`}
                                              </div>
                                              {extractFormNameFromFileName(
                                                relatedForm.fileName
                                              ) && (
                                                <div
                                                  style={{
                                                    fontSize: "11px",
                                                    color: "#9CA3AF",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                >
                                                  {extractFormNameFromFileName(
                                                    relatedForm.fileName
                                                  )}
                                                </div>
                                              )}
                                            </div>

                                            {/* Error status indicator */}
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "6px",
                                                padding: "0px 6px 2px 6px",
                                                borderRadius: "3px",
                                                fontSize: "12px",
                                                backgroundColor:
                                                  relatedForm.errorCount > 0
                                                    ? "rgba(255, 0, 0, 0.1)"
                                                    : "rgba(0, 255, 0, 0.1)",
                                                color:
                                                  relatedForm.errorCount > 0
                                                    ? "#ff0000"
                                                    : "#00aa00",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  width: "6px",
                                                  height: "6px",
                                                  borderRadius: "50%",
                                                  backgroundColor:
                                                    relatedForm.errorCount > 0
                                                      ? "#ff0000"
                                                      : "#00aa00",
                                                  display: "inline-block",
                                                }}
                                              ></span>
                                              {relatedForm.errorCount > 0
                                                ? `${relatedForm.errorCount} Errors`
                                                : "No Errors"}
                                            </div>

                                            {/* Menu button */}
                                            <div
                                              className="menu-button"
                                              style={{
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "24px",
                                                height: "24px",
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setPopupMenuPosition({
                                                  x: e.clientX,
                                                  y: e.clientY,
                                                });
                                                setActivePopupMenu(relatedForm.fileImportId);
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontSize: "20px",
                                                  fontWeight: "bold",
                                                  color: "#2aa7e0",
                                                }}
                                              >
                                                ⋮
                                              </span>
                                            </div>
                                            {activePopupMenu === relatedForm.fileImportId && (
                                              <div
                                                ref={popupRef}
                                                style={{
                                                  position: "absolute",
                                                  top: "30px",
                                                  right: "10px",
                                                  backgroundColor: "#E9F5FE",
                                                  boxShadow: "none",
                                                  borderRadius: "4px",
                                                  zIndex: 1000,
                                                  width: "90px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    padding: "6px 10px",
                                                    cursor: "pointer",
                                                    color: "#2aa7e0",
                                                    textAlign: "left",
                                                    fontSize: 12,
                                                  }}
                                                  onClick={() => {
                                                    const newData =
                                                      processFormsData(row.formsData) || [];
                                                    if (newData.length > 0) {
                                                      // W8BENApiHandler({
                                                      //     formData: newData[relatedForm.fileImportId.split('_').pop()],
                                                      //     formType: relatedForm.fileName
                                                      // });
                                                    }
                                                    setSelectedIndex(relatedForm.originalIndex);
                                                    setSelectedRowId(null);
                                                    setAddNewRowsList([]);
                                                    setStoreUpdatingValues([]);
                                                    setSaveSum(0);

                                                    // Set up dataValidation state - this was missing!
                                                    setSelectedCheckbox(row.fileImportId);
                                                    setDataValidation(
                                                      JSON.parse(row.dataValidation)
                                                    );
                                                    setExtractedValidateData(
                                                      JSON.parse(row.dataValidation)
                                                        .businessUnitList
                                                    );

                                                    setIsDataValidationPopupOpen(true);
                                                    setRunValidation(true);
                                                    handleSelectSheetProcess("View Forms");
                                                    setSelectSheet("View Forms");
                                                    setActivePopupMenu(null);
                                                  }}
                                                >
                                                  View
                                                </div>
                                                {withholdingRows.length > 0 && (
                                                  <div
                                                    style={{
                                                      padding: "10px 15px",
                                                      cursor: "pointer",
                                                      color: "#2aa7e0",
                                                      textAlign: "center",
                                                      // borderTop: '1px solid #eee',
                                                      position: "relative",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      const moveMenu =
                                                        e.currentTarget.querySelector(
                                                          ".move-dropdown-content"
                                                        );
                                                      if (moveMenu) {
                                                        moveMenu.style.display = "block";
                                                      }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      const moveMenu =
                                                        e.currentTarget.querySelector(
                                                          ".move-dropdown-content"
                                                        );
                                                      if (moveMenu) {
                                                        moveMenu.style.display = "none";
                                                      }
                                                    }}
                                                  >
                                                    Move
                                                    <div
                                                      className="move-dropdown-content"
                                                      style={{
                                                        display: "none",
                                                        position: "absolute",
                                                        left: "100%",
                                                        top: 0,
                                                        backgroundColor: "white",
                                                        boxShadow: "none",
                                                        borderRadius: "4px",
                                                        zIndex: 1001,
                                                        minWidth: "150px",
                                                      }}
                                                    >
                                                      {withholdingRows
                                                        .filter(
                                                          (targetRow) =>
                                                            targetRow.fileImportId !==
                                                            relatedForm.fileImportId
                                                        )
                                                        .map((targetRow) => (
                                                          <div
                                                            key={targetRow.fileImportId}
                                                            style={{
                                                              padding: "10px 15px",
                                                              cursor: "pointer",
                                                              color: "#2aa7e0",
                                                              textAlign: "center",
                                                              borderBottom: "1px solid #eee",
                                                            }}
                                                            onClick={() => {
                                                              handleMoveWithholdingForm(
                                                                relatedForm,
                                                                targetRow,
                                                                relatedForm.formType
                                                              );
                                                              setActivePopupMenu(null);
                                                            }}
                                                          >
                                                            {targetRow.fileName.substring(0, 13)}
                                                          </div>
                                                        ))}
                                                    </div>
                                                  </div>
                                                )}

                                                <div
                                                  style={{
                                                    padding: "6px 10px",
                                                    cursor: "pointer",
                                                    color: "#ff4d4f",
                                                    textAlign: "left",
                                                    fontSize: 12,
                                                  }}
                                                  onClick={() => {
                                                    // Handle delete action
                                                    handleDeleteWithholdingRow(
                                                      row,
                                                      relatedForm.fileName,
                                                      relatedForm.originalIndex
                                                    );
                                                    setActivePopupMenu(null);
                                                  }}
                                                >
                                                  Delete
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                </>
                              )}

                              {/* For specific form type - show only forms of that type */}
                              {formTypes.includes(activeFormType) && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    padding: "0px 10px 10px 15px",
                                    // margin: "0px 40px 0px 40px",
                                    backgroundColor: "#E9F5FE",
                                  }}
                                >
                                  {filteredFormTypeRows
                                    .filter(
                                      (form) =>
                                        form.fileName && form.fileName.includes(activeFormType)
                                    )
                                    .map((form) => (
                                      <div
                                        key={form.fileImportId}
                                        style={{
                                          margin: "5px",
                                          padding: "10px",
                                          backgroundColor: "white",
                                          border: "1px solid #E5E7EB",
                                          borderRadius: "10px",
                                          display: "flex",
                                          width: "300px",
                                          alignItems: "center",
                                          minHeight: "44px",
                                          position: "relative",
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                          // Don't trigger if clicking on the menu button
                                          if (e.target.closest(".menu-button")) {
                                            return;
                                          }

                                          // Trigger the same action as the View option
                                          const newData = processFormsData(row.formsData) || [];
                                          if (newData.length > 0) {
                                            // W8BENApiHandler({
                                            //     formData: newData[form.fileImportId.split('_').pop()],
                                            //     formType: form.fileName
                                            // });
                                          }
                                          setSelectedIndex(form.originalIndex);
                                          setSelectedRowId(null);
                                          setAddNewRowsList([]);
                                          setStoreUpdatingValues([]);
                                          setSaveSum(0);

                                          // Set up dataValidation state - this was missing!
                                          setSelectedCheckbox(row.fileImportId);
                                          setDataValidation(JSON.parse(row.dataValidation));
                                          setExtractedValidateData(
                                            JSON.parse(row.dataValidation).businessUnitList
                                          );

                                          setIsDataValidationPopupOpen(true);
                                          setRunValidation(true);
                                          handleSelectSheetProcess("View Forms");
                                          setSelectSheet("View Forms");
                                          setActivePopupMenu(null);
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%",
                                          }}
                                        >
                                          <div
                                            title={form.fileName.replace(/ID Documents -/i, "")}
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              flex: 1,
                                              minWidth: 0,
                                              marginRight: "15px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontWeight: "500",
                                                color: "#2aa7e0",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              }}
                                            >
                                              {form.fileName
                                                .replace(/ID Documents -/i, "")
                                                .replace(
                                                  /^(W-8BEN-E|W-8BEN|W-8ECI|W-8IMY|W-8EXP|W-9|8233|SELF-CERT)\s*[-\u2013]\s*/i,
                                                  ""
                                                )
                                                .trim()}
                                              {form.isFormParentRow &&
                                                form.formCount > 1 &&
                                                ` (${form.formCount})`}
                                            </div>
                                            {extractFormNameFromFileName(form.fileName) && (
                                              <div
                                                style={{
                                                  fontSize: "11px",
                                                  color: "#9CA3AF",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                }}
                                              >
                                                {extractFormNameFromFileName(form.fileName)}
                                              </div>
                                            )}
                                          </div>

                                          {/* Error status indicator */}
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              gap: "6px",
                                              padding: "0px 6px 2px 6px",
                                              borderRadius: "3px",
                                              fontSize: "12px",
                                              backgroundColor:
                                                form.errorCount > 0
                                                  ? "rgba(255, 0, 0, 0.1)"
                                                  : "rgba(0, 255, 0, 0.1)",
                                              color: form.errorCount > 0 ? "#ff0000" : "#00aa00",
                                            }}
                                          >
                                            <span
                                              style={{
                                                width: "6px",
                                                height: "6px",
                                                borderRadius: "50%",
                                                backgroundColor:
                                                  form.errorCount > 0 ? "#ff0000" : "#00aa00",
                                                display: "inline-block",
                                              }}
                                            ></span>
                                            {form.errorCount > 0
                                              ? `${form.errorCount} Errors`
                                              : "No Errors"}
                                          </div>

                                          {/* Menu button */}
                                          <div
                                            className="menu-button"
                                            style={{
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: "24px",
                                              height: "24px",
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setPopupMenuPosition({
                                                x: e.clientX,
                                                y: e.clientY,
                                              });
                                              setActivePopupMenu(form.fileImportId);
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "20px",
                                                fontWeight: "bold",
                                                color: "#2aa7e0",
                                              }}
                                            >
                                              ⋮
                                            </span>
                                          </div>

                                          {/* Popup Menu */}
                                          {activePopupMenu === form.fileImportId && (
                                            <div
                                              ref={popupRef}
                                              style={{
                                                position: "absolute",
                                                top: "40px",
                                                right: "10px",
                                                backgroundColor: "#E9F5FE",
                                                boxShadow: "none",
                                                borderRadius: "4px",
                                                zIndex: 1000,
                                                width: "90px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  padding: "6px 10px",
                                                  cursor: "pointer",
                                                  color: "#2aa7e0",
                                                  textAlign: "left",
                                                  fontSize: 12,
                                                }}
                                                onClick={() => {
                                                  const newData =
                                                    processFormsData(row.formsData) || [];
                                                  if (newData.length > 0) {
                                                    // W8BENApiHandler({
                                                    //     formData: newData[form.fileImportId.split('_').pop()],
                                                    //     formType: form.fileName
                                                    // });
                                                  }
                                                  setSelectedIndex(form.originalIndex);
                                                  setSelectedRowId(null);
                                                  setAddNewRowsList([]);
                                                  setStoreUpdatingValues([]);
                                                  setSaveSum(0);

                                                  // Set up dataValidation state - this was missing!
                                                  setSelectedCheckbox(row.fileImportId);
                                                  setDataValidation(JSON.parse(row.dataValidation));
                                                  setExtractedValidateData(
                                                    JSON.parse(row.dataValidation).businessUnitList
                                                  );

                                                  setIsDataValidationPopupOpen(true);
                                                  setRunValidation(true);
                                                  handleSelectSheetProcess("View Forms");
                                                  setSelectSheet("View Forms");
                                                  setActivePopupMenu(null);
                                                }}
                                              >
                                                View
                                              </div>
                                              {withholdingRows.length > 0 && (
                                                <div
                                                  style={{
                                                    padding: "10px 15px",
                                                    cursor: "pointer",
                                                    color: "#2aa7e0",
                                                    textAlign: "center",
                                                    // borderTop: '1px solid #eee',
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    const moveMenu =
                                                      e.currentTarget.querySelector(
                                                        ".move-dropdown-content"
                                                      );
                                                    if (moveMenu) {
                                                      moveMenu.style.display = "block";
                                                    }
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    const moveMenu =
                                                      e.currentTarget.querySelector(
                                                        ".move-dropdown-content"
                                                      );
                                                    if (moveMenu) {
                                                      moveMenu.style.display = "none";
                                                    }
                                                  }}
                                                >
                                                  Move
                                                  <div
                                                    className="move-dropdown-content"
                                                    style={{
                                                      display: "none",
                                                      position: "absolute",
                                                      left: "100%",
                                                      top: 0,
                                                      backgroundColor: "white",
                                                      boxShadow: "none",
                                                      borderRadius: "4px",
                                                      zIndex: 1001,
                                                      minWidth: "150px",
                                                    }}
                                                  >
                                                    {withholdingRows
                                                      .filter(
                                                        (targetRow) =>
                                                          targetRow.fileImportId !==
                                                          row.fileImportId
                                                      )
                                                      .map((targetRow) => (
                                                        <div
                                                          key={targetRow.fileImportId}
                                                          style={{
                                                            padding: "10px 15px",
                                                            cursor: "pointer",
                                                            color: "#2aa7e0",
                                                            textAlign: "center",
                                                            borderBottom: "1px solid #eee",
                                                          }}
                                                          onClick={() => {
                                                            handleMoveWithholdingForm(
                                                              row,
                                                              targetRow,
                                                              form.formType
                                                            );
                                                            setActivePopupMenu(null);
                                                          }}
                                                        >
                                                          {targetRow.fileName.substring(0, 13)}
                                                        </div>
                                                      ))}
                                                  </div>
                                                </div>
                                              )}
                                              <div
                                                style={{
                                                  padding: "6px 10px",
                                                  cursor: "pointer",
                                                  color: "#ff4d4f",
                                                  textAlign: "left",
                                                  fontSize: 12,
                                                }}
                                                onClick={() => {
                                                  // Handle delete action
                                                  handleDeleteWithholdingRow(
                                                    row,
                                                    form.fileName,
                                                    form.originalIndex
                                                  );
                                                  setActivePopupMenu(null);
                                                }}
                                              >
                                                Delete
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              )}
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                </div>
              )}
            </div>

            {/* Fixed Pagination at bottom */}
            {isLoading && <LoadingOverlay />}
            <Modal
              open={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              aria-labelledby="add-administrator-modal-title"
              aria-describedby="add-administrator-modal-description"
            >
              <div
                style={{
                  top: "50%",
                  left: "50%",
                  outline: "none",
                  transform: "translate(-50%, -50%)",
                  position: "absolute",
                  width: "450px", // Width changed to 500px
                  padding: "20px",
                  backgroundColor: "white",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
              >
                <h6 style={{ color: "#2aa7e0", fontFamily: fontFamily }}>UPDATE DATA</h6>
                <div
                  style={{
                    height: "1px",
                    width: "410px",
                    fontFamily: fontFamily,
                    backgroundColor: "#2aa7e0",
                    marginBottom: "20px",
                    marginRight: "10px",
                  }}
                ></div>

                <div>
                  {/* Adjusting height of text boxes */}
                  <div
                    style={{
                      marginBottom: "20px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "black",
                        display: "inline-block",
                        display: "-webkit-box",
                        WebkitLineClamp: "2",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontFamily: fontFamily,
                        maxWidth: 170,
                      }}
                    >
                      {columnName}
                    </span>
                    <InputBase
                      value={editValue}
                      style={searchBoxStyle}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Check if this is a date field using the service
                        if (isDateField(columnName)) {
                          // Use the service to format the date input
                          const formatted = formatDateInput(value);
                          setEditValue(formatted);
                        } else {
                          setEditValue(value);
                        }
                      }}
                      variant="outlined"
                      disabled={false}
                      placeholder={getDatePlaceholder(columnName)}
                    ></InputBase>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                    }}
                  >
                    {/* Adjusting button styles as per requirements */}
                    <Button
                      variant="contained"
                      style={reviewScreenButtonWithOutColor(100)}
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      style={reviewScreenButtonWithColor(80)}
                      onClick={() => {
                        handleSaveEditData();
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </Modal>

            {/* Delete File Popup */}

            <DeleteModal
              open={isPopupOpen}
              isDeleting={isDeleting}
              onClose={() => setIsPopupOpen(false)}
              onDelete={handleDelete}
              deleteButtonStyle={reviewScreenButtonWithColor(100)}
              cancelButtonStyle={reviewScreenButtonWithOutColor(100)}
            />

            {/* Add Note Popup */}
            <Modal
              open={isAddNotePopupOpen}
              onClose={() => {}} // Disable closing on outside click
              disableBackdropClick={true} // Disable backdrop click
              disableEscapeKeyDown={false} // Keep ESC key functionality
              aria-labelledby="delete-confirmation-modal-title"
              aria-describedby="delete-confirmation-modal-description"
              style={{
                border: "none", // Remove border
                background: "transparent", // Remove background color
                boxShadow: "none",
              }}
            >
              <div
                style={{
                  top: "50%",
                  left: "50%",
                  border: "none",
                  transform: "translate(-50%, -50%)",
                  position: "absolute",
                  width: "600px",
                  // height: "500px",
                  // overflowY: "auto",
                  paddingLeft: 30,
                  outline: "none",
                  paddingRight: 30,
                  paddingTop: 30,
                  paddingBottom: 30,
                  boxSizing: "border-box",
                  backgroundColor: "white",
                  boxShadow: "none",
                  borderRadius: "18px",
                }}
              >
                {/* Close button */}
                <button
                  onClick={() => {
                    setIsAddNotePopupOpen(false);
                    setType("");
                    setReason("");
                    setAddNote("");
                    setValidationErrors({ type: "", reason: "", note: "" });
                  }}
                  style={{
                    position: "absolute",
                    top: 24,
                    right: 32,
                    width: 22,
                    height: 22,
                    background: "#a1dbf6",
                    border: "none",
                    borderRadius: "6px",

                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                  }}
                >
                  <CloseIcon style={{ color: "white", fontSize: 14, color: "#2AA7E0" }} />
                </button>
                {showNoteWindow && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",

                      marginLeft: 0,
                      marginRight: 0,
                      borderRadius: 18,
                      background: "white",
                    }}
                  >
                    {/* First Row */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 12,
                        marginBottom: 24,
                      }}
                    >
                      <img src={lightNoteIcon} alt="Add Note" style={{ width: 20, height: 20 }} />
                      <span
                        style={{
                          color: "#111111",
                          fontSize: 25,
                          fontWeight: 500,
                          fontFamily: fontFamily,
                        }}
                      >
                        Add Note
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "16px",
                        marginLeft: 0,
                        gap: 20,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginRight: 0,
                        }}
                      >
                        <span
                          style={{
                            color: "#6A6A6B",
                            fontSize: "15.04px",
                            fontWeight: 400,
                            marginBottom: 8,
                            fontFamily: fontFamily,
                          }}
                        >
                          Type
                          {(type === "Rejected" || type === "Approved") && (
                            <span style={{ color: "red", marginLeft: 4 }}>*</span>
                          )}
                        </span>
                        <div>
                          <ReactSelect
                            value={type ? { value: type, label: type } : null}
                            onChange={(selected) => {
                              if (selected) {
                                setType(selected.value);
                                setReason("");
                                setValidationErrors((prev) => ({
                                  ...prev,
                                  type: "",
                                  reason: "",
                                }));
                              }
                            }}
                            options={typeList
                              .filter((item) => item !== "Select")
                              .map((item) => ({ value: item, label: item }))}
                            placeholder="Select"
                            isSearchable={false}
                            components={{ DropdownIndicator: NoteDropdownIndicator }}
                            styles={getSelectStyles(validationErrors.type)}
                          />
                        </div>
                        {validationErrors.type && (
                          <span
                            style={{
                              color: "red",
                              fontSize: 12,
                              marginTop: 4,
                              fontFamily: fontFamily,
                            }}
                          >
                            {validationErrors.type}
                          </span>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: "auto",
                        }}
                      >
                        <span
                          style={{
                            color: "#6A6A6B",
                            fontSize: "15.04px",
                            fontWeight: 400,
                            marginBottom: 8,
                            fontFamily: fontFamily,
                          }}
                        >
                          Reason
                          {(type === "Rejected" || type === "Approved") && (
                            <span style={{ color: "red", marginLeft: 4 }}>*</span>
                          )}
                        </span>
                        <div>
                          <ReactSelect
                            value={reason ? { value: reason, label: reason } : null}
                            onChange={(selected) => {
                              if (selected) {
                                setReason(selected.value);
                                setValidationErrors((prev) => ({
                                  ...prev,
                                  reason: "",
                                }));
                              }
                            }}
                            options={
                              type === "Approved"
                                ? approveList
                                    .filter((i) => i !== "Select Approve Reason")
                                    .map((i) => ({ value: i, label: i }))
                                : type === "Rejected"
                                  ? rejectionList
                                      .filter((i) => i !== "Select Reject Reason")
                                      .map((i) => ({ value: i, label: i }))
                                  : type === "Outstanding Action"
                                    ? outstandingList
                                        .filter((i) => i !== "Select Outstanding Reason")
                                        .map((i) => ({ value: i, label: i }))
                                    : type === "Escalated"
                                      ? escalatedList
                                          .filter((i) => i !== "Select Escalated Reason")
                                          .map((i) => ({ value: i, label: i }))
                                      : type === "Additional Information Only"
                                        ? additionalInfoList
                                            .filter((i) => i !== "Select Additional Info Reason")
                                            .map((i) => ({ value: i, label: i }))
                                        : []
                            }
                            placeholder="Select"
                            isSearchable={false}
                            components={{ DropdownIndicator: NoteDropdownIndicator }}
                            styles={getSelectStyles(validationErrors.reason)}
                          />
                        </div>
                        {validationErrors.reason && (
                          <span
                            style={{
                              color: "red",
                              fontSize: 12,
                              marginTop: 4,
                              fontFamily: fontFamily,
                            }}
                          >
                            {validationErrors.reason}
                          </span>
                        )}
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "16px",
                        marginLeft: 0,
                        gap: 20,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginRight: 0,
                        }}
                      >
                        <span
                          style={{
                            color: "#6A6A6B",
                            fontSize: "15.04px",
                            fontWeight: 400,
                            marginBottom: 8,
                            fontFamily: fontFamily,
                          }}
                        >
                          Recipient
                        </span>

                        <div>
                          <ReactSelect
                            value={
                              email && email !== "Select" ? { value: email, label: email } : null
                            }
                            onChange={(selected) => {
                              if (selected) {
                                const d = new Date();
                                setEmailedDate(
                                  `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`
                                );
                                setEmail(selected.value);
                              }
                            }}
                            options={usersEmailsList
                              .filter((item) => item !== "Select")
                              .map((item) => ({ value: item, label: item }))}
                            placeholder="Select"
                            isSearchable={false}
                            components={{ DropdownIndicator: NoteDropdownIndicator }}
                            styles={getSelectStyles(false)}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: "auto",
                        }}
                      >
                        <span
                          style={{
                            color: "#6A6A6B",
                            fontSize: "15.04px",
                            fontWeight: 400,
                            marginBottom: 8,
                            fontFamily: fontFamily,
                          }}
                        >
                          {" "}
                          Date{" "}
                        </span>

                        <div
                          style={{
                            background: "white",
                            height: 46,
                            border: "1.14px solid #DDDDDD",
                            borderRadius: "4.55px",
                            fontFamily: fontFamily,
                            width: 260,
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "16px",
                            boxSizing: "border-box",
                          }}
                        >
                          <span style={{ color: "#9F9F9F", fontSize: 14 }}>
                            {emailedDate || "Select"}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginRight: 0,
                        marginLeft: 0,
                      }}
                    >
                      <span
                        style={{
                          color: "#6A6A6B",
                          fontSize: "15.04px",
                          fontWeight: 400,
                          marginBottom: 8,
                          fontFamily: fontFamily,
                        }}
                      >
                        Note
                        {(type === "Rejected" || type === "Approved") && (
                          <span style={{ color: "red", marginLeft: 4 }}>*</span>
                        )}
                      </span>
                      <InputBase
                        multiline
                        value={addNote} // Set value
                        onChange={(e) => {
                          setAddNote(e.target.value);
                          // Clear validation error when user types
                          setValidationErrors((prev) => ({ ...prev, note: "" }));
                        }} // Update state on change
                        rows={4}
                        style={{
                          // height: "28px",
                          backgroundColor: "white",
                          borderRadius: "4.55px",
                          width: "100%",
                          // minHeight: 100,
                          paddingLeft: "8px",
                          fontFamily: fontFamily,
                          border: validationErrors.note ? "2px solid red" : "1.14px solid #DDDDDD", // Show red border if error
                          paddingRight: "8px",
                          color: "#9F9F9F",
                          // minHeight: '150px',
                        }}
                        // placeholder="Add note..."
                        inputProps={{
                          "aria-label": "Entity Search",
                          style: { padding: "0 8px", color: "#9F9F9F" },
                        }}
                      />
                      {validationErrors.note && (
                        <span
                          style={{
                            color: "red",
                            fontSize: 12,
                            marginTop: 4,
                            fontFamily: fontFamily,
                          }}
                        >
                          {validationErrors.note}
                        </span>
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "row",
                        marginTop: 34,
                      }}
                    >
                      <Button
                        variant="contained"
                        style={{
                          ...reviewScreenButtonWithColor(310),
                          height: 52,
                          borderRadius: 5,
                          fontSize: 14,
                          fontWeight: 700,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textTransform: "none",
                          position: "relative",
                        }}
                        onClick={handleSaveNote}
                      >
                        Submit
                        <img
                          src={rightArrowIcon}
                          alt=""
                          style={{ position: "absolute", right: 32, width: 8, height: 13 }}
                        />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Modal>
          </>
        )}

        {isDataValidationPopupOpen && (
          <DataValidationPopup
            open={isDataValidationPopupOpen}
            onClose={handleReturnWithUnsavedChangesCheck}
            rows={rows}
            selectedCheckbox={selectedCheckbox}
            runValidation={runValidation}
            setOnClickValue={setOnClickValue}
            selectSheet={selectSheet}
            handleSelectSheetProcess={handleSelectSheetProcess}
            extractedValidatedata={extractedValidatedata}
            formTypesWithCount={formTypesWithCount}
            formTypeIndices={formTypeIndices}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            viewMode={viewMode}
            setViewMode={setViewMode}
            handleSaveChanges={handleSaveChanges}
            handleFileUpload={handleFileUpload}
            handleExcelAuditReport={handleExcelAuditReport}
            handleDeleteRow={handleDeleteRow}
            handleAddEmptyRow={handleAddEmptyRow}
            handleAddMatchingRow={handleAddMatchingRow}
            handleDropdownChange={handleDropdownChange}
            matchedEntitiesData={matchedEntitiesData}
            shouldHighlightRow={shouldHighlightRow}
            handleSelectedSheet={handleSelectedSheet}
            rowHasErrors={rowHasErrors}
            columnHasErrors={columnHasErrors}
            getIdDocumentType={getIdDocumentType}
            getFormTypeDisplayName={getFormTypeDisplayName}
            halfWidth={halfWidth}
            isFormTypeWithToggle={isFormTypeWithToggle}
            getForm={getForm}
            setIsModalOpen={setIsModalOpen}
            setColumnName={setColumnName}
            setEditValue={setEditValue}
            setOldValue={setOldValue}
            setRowIndex={setRowIndex}
            handleSaveEditData={handleSaveEditData}
            onAddNote={(row) => {
              setSelectedCheckbox(row.fileImportId);
              setSelectedCheckboxList([row.fileImportId]);
              setShowNoteWindow(true);
              setIsAddNotePopupOpen(true);
              setValidationErrors({ type: "", reason: "", note: "" });
            }}
            actionColumnWidth={80}
          />
        )}

        <Modal
          open={isConfirmationPopup}
          onClose={() => setIsConfirmationPopup(false)}
          aria-labelledby="delete-confirmation-modal-title"
          aria-describedby="delete-confirmation-modal-description"
          style={{
            border: "none", // Remove border
            background: "transparent", // Remove background color
            boxShadow: "none",
          }}
        >
          <div
            style={{
              top: "50%",
              left: "50%",
              border: "none",
              transform: "translate(-50%, -50%)",
              position: "absolute",
              width: "450px",
              padding: "20px",
              backgroundColor: "white",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <h6 style={{ color: "#2aa7e0", fontFamily: fontFamily }}>SAVE CHANGES CONFIRMATION</h6>
            <div
              style={{
                height: "1px",
                width: "410px",
                backgroundColor: "#2aa7e0",
                marginBottom: "20px",
                marginRight: "10px",
              }}
            ></div>

            <div>
              <div style={{ marginBottom: "20px" }}>
                <div style={{ marginLeft: "20px", fontFamily: fontFamily }}>
                  Are you sure you don't want to save the changes?
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#2aa7e0",
                    color: "white",
                    width: 60,
                    height: 34,
                    fontFamily: fontFamily,
                  }}
                  onClick={() => {
                    setIsConfirmationPopup(false);
                    setIsChangesSaved(false);
                  }}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#2aa7e0",
                    color: "white",
                    width: 60,
                    height: 34,
                    fontFamily: fontFamily,
                  }}
                  onClick={() => {
                    setIsConfirmationPopup(false);
                    setIsChangesSaved(false);
                    setIsViewOpen(false);
                    setRunValidation(false);
                    setSaveSum(0);
                  }}
                >
                  Yes
                </Button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Single Form Popup */}
        <SingleFormPopup
          open={isSingleFormPopupOpen}
          onClose={closeSingleFormPopup}
          singleFormData={singleFormData}
          singleFormViewMode={singleFormViewMode}
          setSingleFormViewMode={setSingleFormViewMode}
          singleFormMatchingData={singleFormMatchingData}
          isSingleFormSearchLoading={isSingleFormSearchLoading}
          selectedCheckbox={selectedCheckbox}
          forceFormRerender={forceFormRerender}
          getSingleFormComponent={getSingleFormComponent}
          handleAssignMatchingIdentifier={handleAssignMatchingIdentifier}
          isFormComparisonOpen={isFormComparisonOpen}
          onCloseComparison={() => setIsFormComparisonOpen(false)}
          currentPdfFileImportId={currentPdfFileImportId}
          selectedFormIdForComparison={selectedFormIdForComparison}
          setSelectedFormIdForComparison={setSelectedFormIdForComparison}
          setCurrentPdfFileImportId={setCurrentPdfFileImportId}
          setIsFormComparisonOpen={setIsFormComparisonOpen}
        />
      </div>
      {!isDataValidationPopupOpen && (
        <ConditionalPagination
          itemCount={
            rows.filter(
              (item) =>
                item.isProcessed === true &&
                item.approvedDate === null &&
                item.rejectedDate === null &&
                item.reviewedDate !== null &&
                item.parentId === null
            ).length
          }
          itemsPerPage={dynamicRowsPerPage}
          threshold={dynamicRowsPerPage}
          paginationProps={{
            page: currentPage,
            onChange: handlePageChange,
            style: paginationstyle,
            sx: paginationStyles,
            hidePrevButton: false,
            hideNextButton: false,
            showFirstButton: true,
            showLastButton: true,
          }}
        />
      )}
    </>
  );
}
